import { TUTORIAL_MESSAGES } from './message-tutorial.utils';

export const MESSAGE = {
  button: {
    loading: "...",
    loadMore: "Charger plus",
    filter: "Filtres",
    login: "Connexion",
    confirm: "Confirmer",
    save: "Enregistrer",
    edit: "Editer",
    view: "Voir",
    copy: "Copier",
    add: "Ajouter",
    save_draft: "Enregistrer le brouillon",
    valid: "Valider",
    delete: "Supprimer",
    delete_version: "Supprimer la version",
    modif: "Modifier",
    assign: "Assigner",
    continue: "Continuer",
    import: "Importer",
    print: "Imprimer",
    send: "Envoyer",
    precedent: "Précédent",
    next: "Suivant",
    close: "Fermer",
    done: "Terminé",
    see_all: "Voir tout",
    cancel: "Annuler",
    cancel_modif: "Annuler la modification",
    create: "Créer",
    ordonner: "Ordonner",
    reset: "Réinitialiser",
    searchArticleLot: "Article, lot....",
    select: "Sélectionner",
    selected: "Sélectionné",
    drag_drop:
      "Glissez-déposez vos documents à extraire ici... (seulement aux formats image et PDF)",
    browse_files: "... ou parcourez vos fichiers",
    more_param: "Plus de paramètres",
    less_param: "Moins de paramètres",
    refresh: "Rafraichir",
    invalid: {
      default: "Vous avez des erreurs dans le formulaire",
      stepperError: "Vous avez des etapes en erreur",
      noFiles: "Aucun fichier sélectionné",
      selectOne: "Veuillez sélectionnez au moins un élément",
      selectCommande: "Veuillez sélectionnez une commande",
      selectPalette: "Veuillez sélectionnez au moins une unité d'expédition",
      palettesNotReady: "Toutes les unités d'expédition doivent être déclarées « Prête » avant l'expédition",
      commandeCreate: "Veuillez sélectionnez un fournisseur et une adresse",
      noMouvement: "Veuillez renseigner au moins un mouvement",
      receptionInvalid:
        "Vous avez des réceptions incomplètes. Veuillez terminer la saisie ou supprimer les éléments en surplus",
      dechargementInvalid: "Vous avez des déchargements invalides",
      enregistrementInvalid: "Vous avez des enregistrements invalides",
      commentOrDocument:
        "Vous devez renseigner au moins un commentaire ou un document",
      ean13: "Vous pouvez créer un article uniquement avec un EAN13",
      pdcRetour: "Vous avez des retours de PDC invalides",
      noArticle: "Aucun article dans la nomenclature",
      noProcess: "Aucun procédé dans la nomenclature",
      processNotPending:
        "L’annulation est impossible car certaines Opés ont déjà démarré.",
      stepNomenclature: "Veuillez renseigner un lot pour cet article",
      ofWithoutLot: "L'OF n'a pas encore de lot valide.",
      endOpe: "Veuillez renseigner une évaluation",
    },
  },
  system: {
    network_error: "Problème de réseau détecté",
    check_connexion: "Veuillez vérifier votre connexion internet",
    browser_version: "Version du navigateur incompatible",
    browser_version_update: "Veuillez mettre à jour votre navigateur",
  },
  sideNav: {
    header: {
      infos: "Données de base",
      daily_todo: "Tâches journalières",
      inventaire: "Logistique",
      production: "Production",
      commandes: "Commandes",
      administration: "Administration",
    },
    menu: {
      mouvements: "Mouvements de stocks",
      todo: "Listes de tâches",
      inventaire: "Inventaires",
      specifications_to_treat: "Spécifications à traiter",
      dashboard: "Tableau de bord",
      documents: "Documents",
      articles: "Articles",
      production: "Productions",
      stock: "Stock",
      personnel: "Personnel",
      controles: "Contrôles à réaliser",
      ofs: "Ordres de fabrication (OF)",
      models: "Modèles de spécifs.",
      etapes: "Spécifications produit",
      commandes: "Commandes fournisseurs",
      commandes_client: "Commandes clients",
      preparation: "Préparation de commandes",
      of_plannif: "Planification",
      of_plannif_composant: "Planification des composants",
      ligne: "Lignes de production",
      info_journalieres: "Saisie des heures",
      tiers: "Fournisseurs et clients",
      article_param: "Spécification article",
      activite_param: "Paramétrage activité",
      admin_param: "Paramétrage administratif",
      user_param: "Paramétrage utilisateurs",
      administration: "Administration",
      suivi_production: "Suivi des productions",
      stats_prod: "Statistiques",
      dechargements: "Déchargements et Réceptions",
      expeditions: "Expéditions et BL",
      equipes: "Gestion des équipes",
      analyse: "Analyse",
      justup_billing: "Facturation JustUp",
      factures: "Factures et avoirs",
      transferts: "Transferts",
      cost_impact: "Simulation de coûts",
      cost_impact_2: "Simulation de coûts (réf.)",
    },
    privacy_policy: "Politique de confidentialité",
  },
  tutorial: TUTORIAL_MESSAGES,
  billing: {
    START_OF: "Démarrage",
    END_OF: "Fin de la production",
    RESTART_OF: "Redémarrage de la production",
    START_OPE: "Démarrage de l'opération de production",
    END_OPE: "Fin de l'opération de production",
    CONTROLE_OPE: "Réalisation d'un contrôle sur l'opération de production",
    PEO_VALID:
      "Validation d'une étape de procédé sur l'opération de production",
    of_of: "de l'OF",
  },
  documents: {
    title: "Documents",
    empty: "Aucun document",
    uploading: "Envoi en cours...",
    initing: "Initialisation...",
    processing: "Préparation de la vidéo...",
    select: "Sélectionner un fichier",
    import: "Importer un fichier",
    remote_photo: "Prendre une photo",
  },
  specification: {
    create: "Nouvelle version",
    send: "Demander validation",
    validate: "Valider la conformité",
    approuve: "Utiliser cette version",
    duplicate_path: "Dupliquer",
    create_etape: "Créer une spécification",
    master_etapes: "Spécifications produit",
    etats: "États",
    specifs_archivees: "Spécifications archivées",
    editing: "En cours de modification...",
    tips_variables:
      "Un paramètre est une donnée (texte ou nombre) que vous pouvez définir une seule fois et réutiliser ensuite dans vos procédés et vos contrôles via la fonction de texte dynamique.\n" +
      "\n" +
      "👉 Exemple : si plusieurs étapes de votre procédé font référence à un temps de cuisson, créez un paramètre “Temps de cuisson”. Vous pourrez ensuite l’appeler directement sans avoir à le ressaisir à chaque fois.\n" +
      "\n" +
      "✅ Moins de travail répétitif\n" +
      "✅ Moins de risque d’oubli ou d’erreur\n" +
      "✅ Plus de clarté et de cohérence dans vos spécifications",
    demandes_modifications: "Demandes de modifications",
    nouvelles_demandes: "Nouvelles demandes:",
    demandes_traitees: "Demandes traitées:",
    refuser: "Refuser",
    autres_versions: "Autres version",
    version_courante: "Version courante",
    en_redaction: "En rédaction",
    archive_tooltip: "Un article archivé n'apparait plus dans les recherches",
    archive_label: "Archivé",
    importer_specif: "Importer depuis une autre specification",
    archiver: "Archiver",
    desarchiver: "Désarchiver",
    supprimer_article: "Supprimer définitivement",
    archive_or_delete_title: "Archiver ou supprimer ?",
    archive_or_delete_message:
      "Cet article n'a jamais été utilisé. Vous pouvez le supprimer définitivement ou simplement l'archiver.",
    voir_specification: "Voir la spécification",
    consulter_specification: "Consulter la spécification",
    creer_etape_enfant: "Créer une étape enfant",
    demander_modification: "Demander une modification",
    du: "Du",
    au: "au",
    proprietaire: "Propriétaire",
    code_client: "Code client",
    afficher_plannificateur: "Afficher le plannificateur",
    specif_produit: "Spécification produit",
    demander_modif: "Demander une modification",
    voir_specif: "Voir la spécification",
    consulter_specif: "Consulter la spécification",
    duplicate: {
      warningProcesses: "Tous les procédés existantes seront remplacés",
      warningNomenclature:
        "Les articles de nomenclature seront ajouté à la nomenclature existante",
      warningControles: "Tous les contrôles existants seront remplacés",
    },
  },
  cta: {
    fill: "Veuillez la renseigner",
  },
  palette: {
    title: "Gestionnaire d'unités d'expédition",
    add_label: "Créer une unité d'expédition",
    create: "Créer une unité d'expédition",
    edit: "Modifier l'unité d'expédition",
    edit_hint_preparing:
      "Vous pouvez modifier le nom et le type d'unité. Pour modifier le contenu, utilisez le bouton Préparer.",
    edit_hint_ready:
      "L'unité est prête. Vous pouvez modifier le nom et le type, ou reprendre la préparation pour modifier le contenu.",
    for_commande: "Unités d'expédition pour la commande client",
    add_lot_cta:
      "Veuillez sélectionner le lot et la quantité à ajouter au colis",
    add_lot: "Sélection du lot à mettre sur l'unité d'expédition",
    livraison_no_expe: "Livraison directe / gardé en stock",
    preparation: "Préparation de l'unité d'expédition",
    see_other_for_commande: "Voir les autres colis pour cette commande",
    warning_no_lines:
      "Afin de pouvoir préparer une unité d'expédition, veuillez ajouter au moins une ligne de commande",
    palettes_selectionnees: "unités d'expédition sélectionnées",
    palette_selectionnee: "unité d'expédition sélectionnée",
    expedier: "Expédier",
    tare: "Tare",
    entrepot_source: "Entrepôt de départ",
    entrepot_readonly: "Videz l'unité pour changer d'entrepôt",
    entrepot_required: "L'entrepôt de départ est obligatoire",
    empty_confirm_title: "Vider l'unité d'expédition",
    empty_confirm_message: "Tous les produits seront réintégrés dans l'entrepôt d'origine. Continuer ?",
    stock_support: "Stock disponible",
    stock_support_unit: "unité(s) en stock",
    stock_support_insufficient: "Stock insuffisant pour cet article support dans l'entrepôt sélectionné",
    stock_support_go_to_stock: "Voir les stocks",
    stock_support_lot: "Lot article support",
    stock_support_select_lot: "Sélectionnez un lot pour l'article support",
  },
  palette_finder: {
    title: "Ajouter des unités d'expédition",
    empty: "Aucune unité d'expédition disponible",
    entrepot_filter: "Unités disponibles depuis",
    hidden_no_adresse:
      "1 unité vide masquée — ajoutez du stock dessus avant de la charger",
    hidden_no_adresse_plural:
      "#count unités vides masquées — ajoutez du stock dessus avant de les charger",
    scan_no_adresse:
      "Cette unité d'expédition est vide (sans destination). Ajoutez du stock dessus avant.",
    none_available:
      "Aucune unité d'expédition disponible — préparez une palette avec du stock avant de la charger.",
    added_success: "#count unité(s) d'expédition ajoutée(s) au chargement",
  },
  commandes_client: {
    send_mail: "Envoyer la confirmation au client",
  },
  commandes: {
    command: "Commander",
    send_mail: "Envoyer la commande au fournisseur",
    terminer: "Déclarer comme terminée",
    expedier: "Expédier",
    prete: "Déclarer comme prête",
    preparer: "Préparer la commande",
    creation: "Création d'une commande fournisseur",
    createur: "Créée par",
    passer: "Passer commande",
    solder: "Solder",
    annuler: "Annuler",
    modifier: "Modifier la commande",
    from: "Choisir",
    article: "un article",
    fournisseur: "un fournisseur",
    add_label: "Ajouter une commande",
    for: "Commande pour",
    confirmer: "Confirmer",
    confirmer_the: "Confirmer la commande",
    recevoir: "Réception",
    recevoir_the: "Réception de la commande",
    details: "Mettre à jour la commande",
    add_new_articles: "Ajout de nouveaux articles à la commande",
    dateLivraison: "Date de livraison",
    resume: "Résumé des commandes",
    createCommandes: "Créer #nb commandes",
    noCommand: "Aucune commande à afficher",
    noArticle: "Aucun article",
    aucune_reception: "Aucune réception pour cette commande",
    livreeLe: "Livrée le: ",
    delaiLivraison: "Délai de livraison",
    dateLivraisonAlert:
      "Le délai de livraison pour cet article repousse la date de livraison",
    dateLivraisonManuelleAlert:
      "La date de livraison de la commande est manuelle, cependant le délai de livraison de l'article est de #delai jours. Voulez-vous modifier la date de livraison de la commande ?",
    confirmMulti: "#nb commande crée.",
    confirmMulti_plural: "#nb commandes crées.",
    createMulti: "Créer #nb commande",
    createMulti_plural: "Créer #nb commandes",
    createSingle: "Créer cette commande",
    confirmSingle: "Commande créée avec succès",
    errorSingle: "Erreur lors de la création de la commande",
    lot_obligatoire: "Lot fournisseur requis",
    lot_obligatoire_desc:
      "Cet article est soumis à traçabilité. Veuillez renseigner le numéro de lot.",
    multiple_info: "Multiple de #multiple #unite",
    multiple_ok: "#factor × #multiple #unite",
    multiple_hint: "Multiple de #multiple #unite — arrondir à :",
    multiple_keep: "garder #qty",
  },
  commande_client: {
    creation: "Création d'une commande client",
    createur: "Créée par",
    plus_de_parametres: "Plus de paramètres",
    entrepot_optionnel_hint:
      "Optionnel. Sans entrepôt assigné, la commande est visible par tous et peut puiser dans le stock de n'importe quel entrepôt.",
    eclatement_multi_entrepots:
      "Lignes éclatées sur plusieurs entrepôts (stock insuffisant dans un seul)",
    eclatement_multi_entrepots_hint:
      "L'auto-affectation a réparti les lots sur plusieurs entrepôts car aucun seul entrepôt ne couvrait l'intégralité des lignes. Coordonnez la prépa pour éviter les transferts.",
    eclatement_ligne: "Éclatée multi-entrepôts",
    eclatement_ligne_hint:
      "Cette ligne a été couverte par des lots de plusieurs entrepôts. Vérifie la faisabilité opérationnelle (transferts, équipes).",
    tous_entrepots_assignes:
      "Tous les entrepôts disponibles sont déjà assignés à cette commande.",
    aucun_entrepot_mode_global:
      "Aucun entrepôt assigné — mode global (visible par tous, stock puisé partout).",
    aucun_entrepot_mais_ue:
      "Pas d'entrepôt assigné explicitement. Les entrepôts ci-dessus sont détectés via les unités d'expédition (palettes) ou les réservations actives.",
    date_expedition_auto_hint:
      "Préremplie avec la valeur calculée (livraison − délai logistique). Modifier le champ pour forcer une autre date.",
    date_expedition_overridden_hint:
      "Date saisie manuellement (override). Cliquer sur Réinitialiser pour revenir au calcul automatique.",
    commentaires_et_pj: "Commentaires & pièces jointes",
    entrepots_detectes_ue_label: "Détectés (UE / réservation) :",
    entrepot_ue_tooltip:
      "Entrepôt utilisé par une UE (palette) liée à cette commande ou par une réservation active en zone-prepa, mais pas assigné explicitement.",
    entrepot_ue_tooltip_promote:
      "Entrepôt détecté via une UE liée ou une réservation active. Cliquer pour le promouvoir en entrepôt assigné explicitement.",
    include_sans_entrepot: "Inclure CC sans entrepôt",
    include_sans_entrepot_hint:
      "Les commandes sans entrepôt assigné sont visibles par tous (mode global). Décocher pour ne voir que les CC strictement assignées aux entrepôts sélectionnés.",
    entrepots_assignes: "Entrepôts assignés",
    aucun_entrepot_disponible:
      "Aucun entrepôt disponible. Crée des adresses d'entrepôt dans la fiche société.",
    passer: "Passer commande",
    modifier: "Modifier la commande",
    from: "Choisir",
    article: "un article",
    fournisseur: "un fournisseur",
    add_label: "Ajouter une commande",
    for: "Commande pour",
    qtt_livre: "Quantité livrée",
    join_bill: "Joindre la facture proforma",
    join_confirmation: "Joindre la confirmation de commande",
    lignesDeCommande: "Lignes de commande",
    preparationVrac: "Préparation vrac",
    creerNouvellePalette: "Ajouter une Unité d'Expédition",
    expedierVrac: "Expédier",
    ajouterDesLots: "Ajouter des lots",
    ajouterLignesAvant: "Veuillez d'abord ajouter des lignes à la commande",
    expeditionDu: "Expédition du",
    imprimerBL: "Imprimer le BL",
    envoyerVersChargement: "Envoyer vers chargement",
    preparation: "Préparation",
    avec_expedition: "Avec expédition",
    livraison_directe: "Facturé — gardé en stock",
    livraison_directe_retrait: "Livraison directe (retrait)",
    livraison_directe_retrait_desc:
      "Sortie de stock réelle : la marchandise quitte physiquement l'entrepôt (ex. le client vient la chercher). Un BL et une facture sont générés. À ne pas confondre avec « Facturé — gardé en stock ».",
    livraison_directe_desc:
      "Facturez la marchandise au client sans expédition physique : les produits restent en stock, seul le propriétaire change. À distinguer de « Livraison directe (retrait) » qui sort réellement le stock de l'entrepôt.",
    stock_autre_entrepot: "Stock disponible dans d'autres entrepôts :",
    palettes: "Unités d'expéditions",
    vrac: "Lots sans unités d'expéditions",
    paletteDu: "Unité d'expédition ·",
    vracDu: "Vrac ·",
    mettreSurPalette: "Mettre sur unité d'expédition",
    choisirArticle: "Cliquez sur un article pour ajouter des lots",
    enZone: "En zone",
    surPalette: "Sur unité d'expédition",
    aide_expedition_maker:
      "Sélectionnez un article pour choisir les lots et quantités à ajouter sur l'unité d'expédition. La barre de progression indique l'avancement par rapport à la quantité demandée.",
    voir_proforma: "Éditer la facture proforma",
    proforma_rib_title: "Choisir le RIB à afficher sur la proforma",
    voir_confirmation: "Éditer la confirmation de commande",
  },
  search: {
    label: "Rechercher ici ...",
    main_bar: "Rechercher un article, un tiers, une commande...",
  },
  ligne_param: {
    label: "Paramétrage de la ligne",
    add_cta: "Ajouter un paramétrage",
    create_label: "Création d'un nouveau paramétrage",
    edit_label: "Edition du paramétrage",
    no_param: "Aucun paramétrage n'a été configuré.",
  },
  mouvement: {
    pending_to_save: "Mouvements à enregistrer",
    edit_title: "Modifier le mouvement",
  },
  of: {
    voir_of: "Voir l’OF",
    epingle: "Épinglé",
    creer_of: "Créer un OF",
    why_delete:
      "Vous ne pouvez supprimer un OF que s’il n’a aucune opération en cours ni aucune opération déjà terminée.",
    withQuantiteOpe: "Suivi des quantités produites par opé.",
    chose_other: "Sélectionner un autre OF",
    end: "Terminer l'OF",
    list: "Liste des OF",
    add_cta: "Ajouter un OF",
    reinte_and_end: "Réintégrer et finir l'OF",
    confirmation_mouvement: "Confirmer les mouvements pour l'",
    no_ope: "Aucune opé. sur cet OF",
    bilan_matieres_intermediaire: "Avec bilans matières intermédiaires",
    auto_plan: "Planifier automatiquement",
    prepare_opes: "Préparation des opés.",
    quantiteParOpe: "Quantité par opé.",
    missing_precondition_text:
      "Avant de démarrer un ordre de fabrication, vous devez d'abord configurer une ligne de production et un article.",
    missing_precondition_text_article: "Créer votre premier article",
    missing_precondition_text_ligne: "Créer votre première ligne de production",
    no_current_specif1: "La spécification de",
    no_current_specif2: "n'est pas validée",
    select_of: "Veuillez sélectionner un OF",
    specifOutdated1: "La spécification a été modifiée.",
    specifOutdated2: "Voulez-vous mettre à jour l'OF ?",
    regenerateOpe: "Mettre à jour",
    confirmUpdateSpecif: "Mise à jour de la spécification de l'OF",
    selectParam: "Veuillez sélectionner un paramètre de ligne",
    stockOutDated1:
      "Vous avez des articles en pied de chaine qui ne sont plus dans la nomenclature.",
    stockOutDated2: "Cette opération va les réintégrer.",
    stockOutDatedQtt: "Quantité en pied de chaine",
    cancel: "Annuler l'OF",
    cancel_impossible: "Impossible d'annuler l'OF car des opés sont en cours",
    cancel_confirm:
      "Vous êtes sur le point d'annuler l'OF #numero. Confirmez-vous ?",
    prepare_pdc: "Préparer PDC",
    reintegrer_pdc: "Réintégrer PDC",
    du: "Du",
    au: "Au",
    match_date: "Correspond à la date",
    quantity_produced: "Quantité produite :",
    edit: "Modifier l'OF",
  },
  bilan_matiere: {
    why_disabled:
      "Afin de pouvoir saisir le bilan matière, veuillez terminer au moins une opération de production",
  },
  heures: {
    empty: "Aucune heure n'a été saisie sur cet OF",
  },
  users: {
    edit: "Edition",
    activate: "Réactiver",
    deactivate: "Désactiver",
    go_profile: "Profil",
    showDisabled: "Voir les utilisateurs désactivés",
    status_all: "Tous",
    status_active: "Actifs",
    status_inactive: "Désactivés",
    disabledAt: "Désactivé le",
    language: "Langue",
    tutorial_enabled: "Activer les tutoriels interactifs",
  },
  administration: {
    doc_commerciaux: "Documents",
    data_extract: "Exports CSV",
    numerotations: "Numérotations",
    validations: "Validations des Ofs / Spécifications",
    my_business: "Mon entreprise",
    user_management: "Gestion des utilisateurs",
    pass_management: "Gestion des autorisations",
    add_user: "Ajouter un utilisateur",
    devices: "JustUp live",
    advance: "Paramètres avancés",
    planning: "Planning par défaut",
    ip: "Sécurité IP",
    identity: "Identité visuelle",
    infos: "Informations",
    controles_generaux: "Contrôles généraux",
    controles_generaux_chargement: "Contrôles généraux de chargement",
    param_generaux: "Paramétrages généraux",
    validation: "Paramétrages generaux",
    custom_enum: "Enumérations",
    billing: "Facturation JustUp",
    tokens: "Tokens IA",
    chargement: "Chargement / Expédition",
    signature_operateur_obligatoire: "Signature de l'opérateur obligatoire au chargement",
  },
  tokenManagement: {
    title: "Facturation JustUp",
    subtitle:
      "Votre consommation, vos tokens IA Justy, vos moyens de paiement et vos factures JustUp.",
    tab_consumption: "Consommation",
    tab_overview: "Tokens IA",
    tab_buy: "Acheter des tokens",
    tab_payment: "Moyens de paiement",
    tab_invoices: "Factures",
    tab_history: "Historique",
    balance: "Solde de tokens",
    balance_remaining: "Tokens restants",
    quota_monthly: "Quota mensuel inclus",
    quota_used: "Consommé",
    quota_consumed_pct: "du quota consommé",
    current_estimate: "Facture du mois en cours (estimation)",
    estimate_hint: "Montant prévisionnel, non encore facturé",
    total_ht: "Total HT",
    total_ttc: "Total TTC",
    subscription: "Abonnement",
    plan: "Formule",
    renews_on: "Renouvellement le",
    monthly_amount: "Montant mensuel",
    no_subscription: "Aucun abonnement actif",
    buy_title: "Recharger des tokens",
    buy_subtitle: "Crédités instantanément après paiement. Sans engagement, valables sur toute la durée de votre abonnement.",
    best_value: "Meilleure valeur",
    per_million: "million",
    pack_tokens: "tokens",
    buy_pack: "Acheter",
    services_title: "Formation & accompagnement",
    services_subtitle: "Accélérez votre prise en main avec nos experts. Réservez votre créneau en ligne.",
    service_formation_title: "Formation & aide à l'intégration",
    service_formation_desc: "Prise en main complète et paramétrage de votre ERP avec un expert JustUp.",
    service_support_title: "Accompagnement sur-mesure",
    service_support_desc: "Journée d'accompagnement dédiée (optimisation, formation avancée, support).",
    service_once: "forfait",
    service_per_day: "/ jour",
    service_nb_days: "Jours",
    book_slot: "Réserver un créneau",
    book_pay: "Réserver & payer",
    book_success: "Paiement validé — choisissez votre créneau sur Calendly.",
    buy_confirm_title: "Confirmer l'achat",
    buy_success: "Achat effectué — tokens crédités",
    no_pack: "Aucun pack disponible pour le moment",
    payment_methods_title: "Moyens de paiement",
    add_payment_method: "Ajouter un moyen de paiement",
    card: "Carte bancaire",
    sepa: "Prélèvement SEPA",
    default_badge: "Par défaut",
    set_default: "Définir par défaut",
    delete_pm: "Supprimer",
    no_payment_method: "Aucun moyen de paiement enregistré",
    pm_form_title: "Ajouter une carte ou un mandat SEPA",
    pm_save: "Enregistrer",
    pm_saved: "Moyen de paiement enregistré",
    pm_error: "Échec de l'enregistrement du moyen de paiement",
    invoices_title: "Factures Justup",
    invoice_number: "N° facture",
    invoice_date: "Date",
    invoice_amount: "Montant TTC",
    invoice_status: "Statut",
    download_invoice: "Télécharger",
    no_invoice: "Aucune facture",
    status_paid: "Réglée",
    status_open: "En attente",
    status_void: "Annulée",
    status_uncollectible: "Impayée",
    status_draft: "Brouillon",
    history_title: "Historique des transactions",
    tx_date: "Date",
    tx_type: "Type",
    tx_amount: "Tokens",
    no_transaction: "Aucune transaction",
    type_subscription_grant: "Quota mensuel",
    type_pack_purchase: "Achat de pack",
    type_chat_consumption: "Consommation chatbot",
    type_refund: "Remboursement",
  },
  activity_infos: {
    logo: "Logo de votre entreprise",
    color: "Couleur de votre entreprise",
    delai_expedition_par_defaut: "Délai expédition par défaut (jours ouvrés)",
    delai_expedition_par_defaut_placeholder: "Ex : 1",
    delai_expedition_par_defaut_hint:
      "Nombre de jours ouvrés entre l'expédition et la livraison client. Sert au calcul automatique de la date d'expédition prévue. Peut être surchargé par adresse de livraison.",
    section_qualite_securite: "Qualité & sécurité alimentaire",
    activer_blocage_dlc:
      "Bloquer les expéditions contenant un lot DLC dépassée",
    activer_blocage_dlc_hint:
      "Recommandé pour les sites agro frais et IFS-compliants. Une expédition contenant un lot dont la DLC est dépassée sera refusée (R. 412-21 Code Conso). Ne s'applique qu'aux articles classés DLC ; les DDM dépassées génèrent un simple avertissement.",
  },
  validations: {
    specification: "Validation des spécifications",
    of: "Validation des OFs",
    facture: "Facturation",
  },
  facture: {
    search_placeholder: "N° facture, tiers ou montant (HT/TTC)…",
    export_excel_tooltip:
      "Exporter toutes les factures et avoirs filtrés vers un fichier Excel formaté (6 onglets : synthèse, factures, avoirs, règlements, lignes détail, par client)",
    bulk_zip_btn: "Télécharger PDF",
    bulk_zip_tooltip:
      "Télécharge un ZIP contenant un PDF par facture cochée (un fichier nommé par numéro de facture / avoir)",
    bulk_zip_select_first:
      "Sélectionnez au moins une facture dans la liste (cochez la case à gauche) pour activer le téléchargement groupé",
    bulk_zip_success: "{count} factures téléchargées dans le ZIP",
    bulk_zip_error: "Échec du téléchargement groupé. Réessayez ou consultez les logs.",
    transaction_type: "Type de règlement",
    transaction_amount: "Montant",
    transaction_add_cta: "Création d'un règlement",
    transaction_edit_cta: "Modification d'un règlement",
    transaction_link_to_facture: "Imputer à une autre facture",
    transaction_from_ps: "Règlement créé automatiquement depuis PrestaShop — non modifiable.",
    transaction_from_ps_tooltip: "Règlement importé depuis PrestaShop",
    reglement_section_infos: "Règlement",
    reglement_section_imputations: "Affectation aux factures",
    reglement_section_facture_en_cours: "Facture en cours",
    reglement_section_autres_factures: "Autres factures du tiers",
    reglement_add_type: "Ajouter un type de règlement",
    reglement_facture_deja_reglee: "Déjà réglée",
    reglement_facture_deja_reglee_help:
      "Cette facture est entièrement réglée. Le règlement peut être affecté à d'autres factures du tiers ou enregistré comme acompte.",
    reglement_factures_du_tiers: "Factures à régler de #tiers",
    reglement_factures_aucune: "Aucune facture en attente de règlement.",
    reglement_jauge_recu: "Montant du règlement",
    reglement_jauge_impute: "Affecté aux factures",
    reglement_jauge_restant_apres: "Restant dû après",
    reglement_jauge_reste: "Reste à affecter",
    reglement_jauge_excedent: "Trop affecté",
    reglement_jauge_impute_complet: "Règlement entièrement affecté",
    reglement_acompte_toggle: "Acompte (sans facture)",
    reglement_acompte_help: "Le montant sera enregistré sans affectation, à imputer plus tard sur des factures.",
    reglement_select_all: "Tout cocher",
    reglement_unselect_all: "Tout décocher",
    reglement_select_filter_search: "Rechercher une facture…",
    reglement_facture_reste_du: "Reste dû",
    reglement_facture_echeance: "Échéance",
    reglement_facture_echeance_depassee: "Échéance dépassée",
    reglement_facture_total_ttc: "Total TTC",
    reglement_match_exact: "Le montant correspond exactement à cette facture",
    reglement_match_combo:
      "Le montant correspond à #count factures",
    reglement_apply_match: "Affecter automatiquement",
    reglement_loading_factures: "Chargement des factures…",
    reglement_no_tiers_yet: "Sélectionnez d'abord un tiers",
    send_to_client: "Envoyer au client",
    generate_avoir: "Générer un avoir",
    enter_tiers: "Saisir le tiers",
    attach_bl: "Rattacher un BL",
    no_bl_linked: "Aucun bon de livraison lié",
    linked_avoir: "Avoir lié",
    linked_facture: "Facture liée",
    payment: "Paiement",
    add_payment: "Ajouter un règlement",
    imputer_avoir: "Imputer un avoir",
    imputation_avoir_title: "Imputer un avoir client",
    imputation_avoir_help:
      "Sélectionnez un avoir du même tiers pour l'imputer sur cette facture (règlement sans encaissement).",
    imputation_avoir_select: "Avoir disponible",
    imputation_avoir_solde: "Solde restant de l'avoir",
    imputation_avoir_amount: "Montant à imputer (€)",
    add_line: "Ajouter une ligne",
    unit_price_ht: "PU HT",
    billed: "Facturé",
    unbilled: "Non facturé",
    create: "Créer facture",
    add_cta: "Ajouter une facture/un avoir",
    return_of: "Retour de",
    to: "à",
    facturation: "Facturation",
    add_ligne: "Ajouter une ligne",
    not_billed: "Non facturé",
    valid_facture: "Valider et figer la facture",
    valid_avoir: "Valider et figer l'avoir",
    valid_facture_warning:
      "Vous allez assigner un numéro à la facture, ceci est irréversible. Confirmez-vous?",
    valid_avoir_warning:
      "Vous allez assigner un numéro à l'avoir, ceci est irréversible. Si des retours clients sont prévus, ils seront réalisé en même temps. Confirmez-vous?",
    en_cours: "En cours",
    a_regler: "À régler",
    reglees: "Réglées",
    en_attente_reglement: "En attente de règlement",
    echeance_depassee: "Échéance dépassée",
    echeances_depassees_detail: "Factures en retard de paiement",
    echeances_voir_tout: "Voir #count autre facture en retard",
    echeances_voir_tout_plural: "Voir les #count autres factures en retard",
    echeances_dialog_title: "Factures en échéance dépassée",
    echeances_search_placeholder: "Rechercher par numéro ou tiers…",
    total_du: "Total dû",
    tout_facture: "Tout est facturé",
    paiements_a_affecter: "Paiements à affecter",
    total_regle: "Total réglé",
    transactions_list: "Liste des règlements",
    etats_facture: "États de la facture",
    filter_amount_trigger: "Montant",
    filter_amount_mode_label: "Mode",
    filter_amount_min: "Min (€)",
    filter_amount_max: "Max (€)",
    filter_amount_clear: "Effacer",
    filter_amount_active: "#mode : #min → #max",
    filter_amount_unbounded: "−",
    adresse_reintegration: "Adresse de réintégration",
    figer_numero: "Figer et affecter un numéro",
    paiement_dialog_title: "Affecter un paiement à une facture",
    affectation: "Affectation",
    affectation_complete: "Le montant du règlement est intégralement affecté",
    affectation_incomplete:
      "Le montant du règlement n'est pas intégralement affecté",
    affectation_exceeded:
      "Le montant du règlement ne peut pas être inférieur à la somme des affectations",
    paiement_label: "#amount € réglé le #date",
    paiement_label_plural: "#amount € réglés le #date",
    paiement_label_avoir: "#amount € imputés via avoir N° #numero",
    paiement_label_avoir_no_num:
      "#amount € imputés via avoir",
    bl_chooser_title: "Sélection des bons de livraison à associer",
    no_pending_bl_for_tiers:
      "Aucun bon de livraison non facturé disponible pour ce tiers",
    builder_create_facture: "Création d'une facture",
    builder_edit_facture: "Édition d'une facture",
    builder_create_avoir: "Création d'un avoir",
    builder_edit_avoir: "Édition d'un avoir",
    ref_document: "Référence document",
    ref_document_hint: "Référence libre (ex : réf. fournie par le client)",
    ligne_builder_create: "Création d'une ligne de facture",
    ligne_builder_edit: "Édition d'une ligne de facture",
    ligne_type_commande: "Commandé",
    ligne_type_autre: "Autre",
    mail_dialog_relance: "Envoi d'une relance pour la facture",
    mail_dialog_send: "Envoi de la facture",
    mail_recipient: "Destinataire",
    mail_cc: "En copie",
    mail_message_placeholder: "Votre message ici...",
    mail_show_pdf: "Voir la facture",
    paiement_allocated: "#amount € affecté à #numero",
    paiement_allocated_plural: "#amount € affectés à #numero",
    total_paid: "Montant réglé",
    remaining_due: "Reste à payer",
    empty_lignes_draft: "Ajoutez votre première ligne de facture",
    empty_lignes: "Aucune ligne",
    copied_numero: "Numéro copié",
    copy_numero_tooltip: "Copier le numéro",
    pdf_tooltip: "Télécharger en PDF",
    send_mail_tooltip: "Envoyer par mail",
    encours_section: "Règlement",
    encours_remaining: "Reste à payer",
    encours_paid: "Réglé",
    encours_due_today: "Échéance aujourd'hui",
    encours_overdue: "En retard de #count jour(s)",
    encours_no_paiement: "Aucun règlement enregistré",
    encours_settled: "Facture entièrement réglée",
    section_identite: "Informations",
    section_lignes: "Détail",
    section_autres_lignes: "Autres lignes",
    section_totaux: "Totaux",
    rib_inline_label: "Coordonnées de paiement",
    immutable_error: "Cette facture est émise et ne peut plus être modifiée",
    badge_en_redaction: "En rédaction",
    badge_emise_lock: "Émise — non modifiable",
    remise_pied: "Remise pied de facture",
    remise_pied_type: "Type remise pied",
    remise_pied_fixe: "fixe",
    escompte: "Escompte de règlement (%)",
    escompte_hint: "Informatif — mentionné sur la facture",
    sous_total_ht_lignes: "Sous-total HT lignes",
    total_ht_avant_remise: "Total HT avant remise",
    total_remises_ligne: "Total remises",
    pu_brut_ht: "PU brut HT",
    remise: "Remise",
    montant_remise_pied: "Remise pied",
    remises_pied: "Remises pied de facture",
    remise_pied_add_manual: "Ajouter une remise",
    remise_pied_label_placeholder: "Libellé de la remise (optionnel)",
    remise_pied_source_commande: "Commande",
    remise_pied_auto: "Auto-reportée",
    chrono_warning: "La date de cette facture (#date) est antérieure à la dernière facture émise #numero (#lastDate).",
    mentions_legales: {
      titre: "Mentions légales",
      penalite_retard: "Pénalités de retard",
      indemnite_forfaitaire: "Indemnité forfaitaire",
      delai_paiement: "Délai de paiement",
      jours: "jours",
      escompte: "Escompte",
      warning_delai_egalim: "Délai de paiement inférieur à 30 jours (EGAlim)",
    },
  },
  chat: {
    label: "Chat",
    deactive: "Fermer",
    message_label: "Votre message ici ...",
    conversation_label: "Discutons !",
    new_chat: "Nouvelle discussion",
  },
  auth: {
    login: "Se connecter",
    logout: "Se déconnecter",
    signup: "Créer un compte",
  },
  home: {
    remote_operation: "Opération",
    remote_variable: "à distance",
    remote_wait:
      "Veuillez patienter jusqu'à sa complétion, ou ouvrez un nouvel onglet!",
  },
  chatbot: {
    title: "Justy",
    tooltip: "Ouvrir l'assistant",
    placeholder: "Posez votre question sur Justup ou vos données...",
    welcome: "Bonjour ! Comment puis-je vous aider ?",
    welcome_named: "Bonjour #prenom ! Comment puis-je vous aider ?",
    import_commande_client: "Importer une commande client",
    import_commande_client_hint: "Joignez un bon de commande (PDF ou photo) et je m'occupe du reste.",
    welcome_hint:
      "Posez-moi une question sur l'utilisation de Justup ou interrogez vos données métier.",
    clear: "Effacer la conversation",
    new_conversation: "Nouvelle conversation",
    no_conversations: "Aucune conversation",
    delete: "Supprimer",
    send: "Envoyer",
    conversations: "Conversations",
    toggle_sidebar: "Afficher/masquer les conversations",
    suggestion_of: "Derniers OF",
    suggestion_help: "Créer un OF",
    suggestion_ca: "Mon CA",
    attach_file: "Joindre un document",
    interrupted: "La réponse a été interrompue",
    retry: "Réessayer",
    cancel: "Arrêter la génération",
    show_capabilities: "Découvrir toutes les capacités",
    hide_capabilities: "Masquer",
    cap_documents: "Traitement de documents",
    cap_documents_desc: "Photographiez ou déposez un BL, une facture ou un bon de commande. L'assistant lit le document, identifie le fournisseur, rapproche les articles et propose la réception.",
    cap_data: "Interrogation de données",
    cap_data_desc: "Posez vos questions en français : chiffre d'affaires, marges, stocks, production, commandes. L'assistant cherche, calcule et génère des graphiques.",
    cap_quality: "Qualité & Sécurité alimentaire",
    cap_quality_desc: "HACCP, traçabilité, rappels produit, audits IFS/BRC, alertes DLC — l'assistant est votre copilote qualité.",
    cap_nav: "Navigation guidée",
    cap_nav_desc: "Demandez comment faire quelque chose : l'assistant vous guide visuellement dans l'application en mettant en surbrillance les boutons et zones concernés.",
    cap_actions: "Actions rapides",
    cap_actions_desc: "Créez des fournisseurs, passez des commandes, lancez des réceptions — l'assistant exécute pour vous après confirmation.",
  },
  ribs: {
    isDefault: "RIB par défaut",
    setIsDefault: "Utiliser par défaut",
    title: "Coordonnées bancaires",
    add_title: "Ajouter un RIB",
    edit_title: "Modifier le RIB",
    chose_title: "Choisir un RIB de paiement",
    add_cta: "Ajouter un RIB",
    empty: "Aucun RIB enregistré",
    loading: "Chargement...",
    unnamed: "RIB sans nom",
    denomination: "Libellé",
    denomination_placeholder: "Ex: Compte principal, Compte pro...",
    banque: "Code banque",
    banque_tooltip: "5 chiffres identifiant la banque",
    guichet: "Code guichet",
    guichet_tooltip: "5 chiffres identifiant l'agence",
    numero: "N° de compte",
    numero_tooltip: "11 caractères alphanumériques",
    cle: "Clé",
    cle_tooltip: "2 chiffres de vérification",
    IBAN: "IBAN",
    BIC: "BIC / SWIFT",
    BIC_hint: "Optionnel - Code international de la banque",

    show_details: "Afficher les détails RIB",
    hide_details: "Masquer les détails RIB",
    rib_details: "Détails du RIB (remplis automatiquement depuis l'IBAN)",
    copy_iban: "Copier l'IBAN",
    iban_copied: "IBAN copié",

    form_invalid: "Veuillez corriger les erreurs du formulaire",

    validation: {
      iban_required: "L'IBAN est requis",
      iban_format: "Format IBAN invalide",
      iban_key: "Clé IBAN invalide",
      iban_length_fr: "L'IBAN français doit contenir 27 caractères",
      bic_format: "Format BIC invalide (8 ou 11 caractères)",
      bank_code_format: "Code banque : 5 chiffres",
      branch_code_format: "Code guichet : 5 chiffres",
      account_format: "Numéro de compte : 11 caractères",
      rib_key_format: "Clé RIB : 2 chiffres",
    },
  },
  teams: {
    // search: 'Propriétaire de l\'article (si article possédé par un tiers)',
    add_label: "Ajout d'une équipe",
    add_cta: "Ajouter une équipe",
    edit_label: "Modification de l'équipe",
    supervision: "Supervision des équipes",
    supervision_team: "Supervision de l'équipe",
    no_team: "Vous n'êtes affecté à aucune équipe pour le moment",
  },
  ocr: {
    start: "Démarrer l'extraction",
    model_only: "Seulement créer la specif",
    model_article: "Créer un article et y rattacher le modèle",
  },
  data: {
    articles_treated: "Articles traités",
    conso_delta: "Ecart de consommation",
    defineMax: "Définir le maximum possible",
    quantiteProduire: "Quantité à produire",
    quantiteAConsommer: "Quantité à consommer",
    billing: "Facturation",
    theoric_conso: "Consommation théorique",
    manual_conso: "Consommation déclarée",
    consumed: "consommé",
    consumed_plural: "consommés",
    enregistrement: "enregistrement",
    enregistrements: "enregistrements",
    not_specified: "Non précisé",
    last_traced_lot: "Dernier lot tracé",
    users: "Utilisateurs",
    shipped: "Expedié :",
    ready_to_go: "Mis sur unités d'expédition, en attente d'expédition :",
    ordered: "Commandé :",
    client: "Client",
    clients: "Clients",
    fournisseur: "Fournisseur",
    fournisseurs: "Fournisseurs",
    transporteur: "Transporteur",
    details: "Détails",
    dossier_prod: "Dossier de production",
    dashboard: "Tableau de bord",
    confirmation: "Confirmation",
    facture: "Facture",
    avoir: "Avoir",
    factures: "factures",
    client_or_tiers: "Client / Tiers",
    bon_livraisons: "Bons de livraison",
    designation: "Désignation",
    qty_ug_short: "Qté (UG)",
    tva_label: "TVA",
    totalTTC: "Total TTC",
    ttc_short: "TTC",
    quantiteRetourClient: "Quantité à réintégrer",
    facture_avoir: "Factures et avoirs",
    missing_info: "Information manquante",
    validity_date: "Date de validité",
    organisme: "Organisme",
    certificat_bio: "Certificat BIO",
    numero_certificat: "Numéro du certificat",
    costs: "Coûts",
    status: "Statut",
    destinataire_mail: "Destinataire",
    expediteur_mail: "Expéditeur",
    denominationSpecif: "Dénomination de la spécif.",
    denominationArticle: "Dénomination de l'article",
    stayConnected: "Ne pas forcer la reconnexion",
    showLots: "Voir les lots en pied de chaine",
    modifyControleUserDate: "Modifier contrôleur et date de contrôle",
    link: "Lien",
    instructionsAI: "Instruction pour l'IA",
    consigneNC: "Consigne en cas de non conformité",
    tolerance: "Tolérance",
    login: "Identifiant",
    controle_conso: "Combien reste-t-il en PDC du lot",
    bilan_matiere: "Bilan matière",
    billings: "Facturation JustUp",
    delaiReglementJour: "Délai réglement (jours)",
    ip: "IP",
    devise: "Devise",
    checklists: "Checklists",
    documents: "Documents",
    ribs: "RIB",
    models: "Modèles d'articles",
    prixUnitaireAchat: "Prix unitaire (par unité d'achat)",
    stats: "Statistiques",
    quantitePrevue: "Quantité prévue",
    dechargements: "Déchargements",
    receptions: "Réceptions",
    controleParQuantite: "Echantillon dépendant de la quantité à contrôler",
    echantillonParQuantite: "Quantité par échantillon (en unité de gestion)",
    quantite_recue: "Quantité reçue",
    conforme: "Conforme",
    non_conforme: "Non conforme",
    quantite_conforme: "Conforme",
    quantite_non_conforme: "Non conforme",
    quantite_recue_conforme: "Quantité reçue conforme",
    sscc: "SSCC / numéro d'unité d'expédition",
    general_controls: "Contrôles généraux",
    textColor: "Initiales en blanc",
    prixParDefaut: "Prix par défaut",
    prixUnitaire: "Prix unitaire",
    prixCatalogue: "PU Catalogue",
    mailDefault: "Email principal",
    mailPrecision: "Précisions email",
    mailPrecision1: "Emails spécifiques par type d’envoi (optionnel)",
    mailPrecision2: "Si non renseigné, l’email principal sera utilisé.",
    mailCommande: "Commandes envoyées au fournisseur",
    mailCommandeClient: "Commandes passées par le client",
    mailFacturation: "Factures client",
    mailLivraison: "Bons de livraison",
    coutMaterielUnitaire: "Coût matière unitaire",
    coutPersonnelUnitaire: "Coût personnel unitaire",
    desc_commerciale: "Description commerciale",
    microbio: "Critères microbiologiques",
    diametre: "Diamètre",
    densite: "Densité (kg/L)",
    coefficientUnite: "Coefficient",
    device: "Appareil JustUp Live",
    not_applicable: "Non applicable",
    applicable: "Applicable",
    bilanMatiere: "Bilan matière",
    chargements: "Expéditions et BL",
    quantiteAchat: "Quantité en unité d'achat",
    quantiteGestion: "Quantité en unité de gestion",
    uniteClient: "Unité de vente",
    uniteFournisseur: "Unité d'achat",
    uniteGestion: "Unité de gestion",
    quantiteIn: "Quantité en",
    quantiteTotaleIntegree: "Quantité totale intégrée",
    dates: "Dates",
    teams: "Equipes",
    team: "Equipe",
    horaires: "Horaires",
    declared_in_prod_plural: "Déclarés en cours de production",
    declared_in_prod: "Déclarés en cours de production",
    scoreMatiere: "Performance matière premières",
    scorePersonnel: "Performance main d'oeuvre",
    scoreTotal: "Performance économique totale",
    param_mail: "Paramétrage mail",
    signature_placeholder: "Votre signature ici...",
    born_on: "né le",
    entrepot_par_defaut: "Entrepôt par défaut",
    profile_page: "Page de profil",
    lotExpedie: "Quantité expédiée",
    codeGS1: "Code d'entreprise GS1",
    sans_identifiant: "Sans identifiant",
    poste_annule: "Supprimer l'opé de fabrication",
    MAIL_HOST: "Hôte SMTP",
    MAIL_USER: "Nom d'utilisateur",
    MAIL_PASSWORD: "Mot de passe",
    MAIL_FROM: "Adresse par défaut d'envoi",
    subject: "Objet",
    startAdresse: "Adresse de départ",
    endAdresse: "Adresse d'arrivé",
    user: "Utilisateur",
    delivery_adresse: "Adresse de livraison",
    received_by_singular: "Reçu par la commande suivante",
    received_by_plural: "Reçu par les commandes suivantes",
    produced_by_singular: "Produit par l'OF suivant",
    produced_by_plural: "Produit par les OFs suivants",
    receiveConfirmationCommandeClientMail:
      "Est en copie des mails des confirmations de commandes clients",
    receiveCommandeMail: "Est en copie des mails des commandes fournisseurs",
    receivePosteMail: "Est en copie des mails de fin de poste",
    receiveBilanMatiereMail: "Est en copie des mails de bilans matières",
    postes: "Opé. de fab.",
    isPhoto: "Enregistrement d'une photo",
    isValeur: "Enregistrement d'une valeur",
    type_fiche: "Format de fiche imprimable",
    quantiteRefuse: "Quantité refusée",
    unite_simple: "Unité",
    stocks: "Voir les stocks",
    lots: "Voir les stocks",
    info_generales: "Infos générales",
    dureePoste: "Durée de l'opé. de fab. (h)",
    valeurUnitairePonderee: "Valeur unitaire (dernier coût connu)",
    quantiteTotale: "Quantité totale",
    compteur: "Compteur",
    etat: "Etat",
    valeur: "Valeur",
    nb_articles: "Nombre d'articles",
    nb_lots: "Nombre de lots",
    to_compte: "Compter dans cette zone",
    comptage: "Comptages dans cette zone",
    compteRetenu: "Comptage retenu",
    zone: "Zone",
    valeurTotale: "Valeur totale",
    entrepot: "Entrepôt",
    plusieurs_entrepots: "Plusieurs entrepôts",
    sans_stock: "Sans stock",
    compte: "Comptage",
    comptages: "Comptages",
    valeurUnitaire: "Valeur unitaire par défaut",
    valeurUnitaireInventaire: "Valeur unitaire",
    complets: "Nombre de colis complets",
    complets_rouleaux: "Nombre de rouleaux complets",
    inventaire: "Inventaire",
    inventaires: "Inventaires",
    objectif_nominal: "Moyenne des enregistrements",
    evenement: "Evénement",
    bonLivraison: "Bon de livraison",
    bonsLivraison: "Bon de livraison",
    commentaire: "Commentaire",
    prefixArticleRef: "Préfixe référence article",
    prefixLot: "Préfixe numéro de lot",
    prefixCommande: "Préfixe numéro de commande fournisseur",
    prefixFactureCommandeClient: "Préfixe numéro de facture client",
    prefixAvoirClient: "Préfixe numéro d'avoir client",
    prefixOf: "Préfixe numéro d'OF",
    prefixBonLivraison: "Préfixe numéro de bon de livraison client",
    prefixBonRetour: "Préfixe numéro de bon de retour fournisseur",
    prefixCommandeClient: "Préfixe numéro de commande client",
    prefixDechargement: "Préfixe numéro de déchargement",
    prefixReception: "Préfixe numéro de réception",
    prefix_chargement: "Préfixe numéro d'expédition",
    prefix_transfert_entrepot: "Préfixe numéro de transfert entrepôt",
    prefix_bon_transfert: "Préfixe numéro de bon de transfert",
    autres_travaux: "Autres travaux",
    graphs: "Graphiques",
    titre: "Titre",
    resume: "Description",
    type_retour: "Type de remonté",
    pcb: "PCB",
    codeClient: "Code client",
    provisoire: "Provisoire",
    stockDispo: "Stock disponible",
    stockReappro: "Stock de réappro.",
    stockSecurite: "Stock de sécurité",
    quantiteOfDefault: "Quantité de fabrication par défaut",
    quantiteAchatDefault: "Quantité d'achat par défaut",
    stockParams: "Paramètres de stock",
    stockInfos: "Infos stock",
    stockInfosSubtitle: "Seuils de réapprovisionnement et de sécurité",
    commandeInfos: "Infos commande",
    commandeInfosSubtitle: "Paramètres par défaut pour les commandes d'achat",
    proprietaire: "Propriétaire",
    ingredients: "Liste des ingrédients (écrire les allergènes en majuscules)",
    allergenes: "Liste des allergènes",
    nombreFicheToPrint: "Nombre de fiche à imprimer",
    lots_infos: "Informations du lot",
    ean13: "EAN 13",
    ean14: "EAN 14",
    ean14prefix: "Préfixe EAN 14",
    ean128: "EAN 128",
    isDone: "Réalisé / pris en compte",
    gross_weight: "Poids brut",
    gross_weight_uc: "Poids brut / UG (kg)",
    net_weight_uc: "Poids net UC(kg)",
    longueur_uc: "Longeur UC(cm)",
    hauteur_uc: "Hauteur UC(cm)",
    largeur_uc: "Largeur UC(cm)",
    gross_weight_colis: "Poids brut colis(kg)",
    net_weight_colis: "Poids net colis (kg)",
    longueur_colis: "Longeur colis(cm)",
    hauteur_colis: "Hauteur colis(cm)",
    largeur_colis: "Largeur colis(cm)",
    weight_suremballage: "Poids suremballage",
    calculBesoin: "Calcul des besoins",
    quantiteDispo: "Quantité disponible (hors pieds de chaine)",
    version: "Version",
    specification: "Spécification",
    prixHT: "Prix HT",
    total: "Total",
    totalHT: "Total HT",
    recapitulatif: "Récapitulatif",
    dateEcheance: "Date d'échéance",
    transactions: "transactions",
    prixLibre: "Prix libre",
    reduction: "Réduction",
    avecRetour: "Avec retour des produits",
    returnOf: "Retour de",
    at: "à",
    on: "sur",
    numeroBL: "Numéro de BL",
    restant: "Quantité restante",
    compensation: "Compensation",
    avecReintegration: "Réintégration en stock",
    avoir_make: "Gestion des avoirs",
    avoirs: "Avoirs de la commande",
    ca: "Chiffre d'affaire",
    prixCommande: "Prix convenu",
    prixDeVente: "Prix facturé",
    facturation: "Facturation",
    fj: "Forme juridique",
    capital: "Au capital de (€)",
    rcsVille: "RCS (Ville)",
    rcsNumero: "RCS (Numéro)",
    codeAPE: "Code APE",
    tvaIntracom: "Tva Intracommunautaire",
    email: "Email",
    emailFacture: "Destinataires des factures",
    telephone: "Téléphone",
    telephone2: "Téléphone 2",
    adresse: "Adresse",
    adresses: "Adresses",
    rib: "RIB",
    infoBLClient:
      "Informations devant apparaitre sur les bons de livraisons des commandes clients",
    infoConfirmationCommandeClient:
      "Informations devant apparaitre sur les confirmations de commandes clients",
    infoRetourFournisseur:
      "Informations devant apparaitre sur les retours fournisseurs",
    infoBlClient:
      "Informations devant apparaitre sur les bons de livraison clients",
    infoCommandeFournisseur:
      "Informations devant apparaitre sur les commandes fournisseurs",
    infoFactureExpedition:
      "Informations devant apparaitre sur les factures client",
    infoAvoirClient: "Informations devant apparaitre sur les avoirs client",
    quantiteAReintegrer: "Quantité à réintégrer en stock",
    integrateInStock: "Intégrer en stock",
    enExpe: "Sur l'unité d'expédition",
    qttTotalCommande: "Quantité commandé",
    infosprix: "Infos commerciales",
    sousFamille: "Famille technique",
    correctAnswer: "Bonne réponse",
    typePeriode: "Type DDM",
    dluoJours: "DDM (Jours)",
    dluoMois: "DDM (Mois)",
    dluoAnnes: "DDM (Années)",
    historique: "Historique",
    schema: "Schéma",
    nb_schema: "Tolérance",
    mode: "Mode de fonctionnement",
    coutTotalReel: "Coût total",
    coutUnitaireReel: "Coût par unité produite",
    coutHoraireReel: "Coût moyen de l'heure",
    coutTotalTheorique: "Coût total",
    coutUnitaireTheorique: "Coût par unité produite",
    surcoutTotal: "Surcoût total (€)",
    surcoutUnitaire: "Surcoût unitaire (€)",
    surcoutUnitairePourcent: "Surcoût unitaire (%)",
    theorique: "Théorique",
    isEcart: "Calcul d'écart",
    valeur1: "Première valeur",
    valeur2: "Deuxième valeur",
    reel: "Réel",
    analyse: "Analyse",
    operator: "Opérateur",
    heures_saisies: "Heures saisies",
    heuresLigne: "Heures lignes",
    heuresTheorique: "Durée théorique",
    heuresTravailles: "Heures payées",
    heureAffectees: "Heures affectées",
    heuresFormation: "Heures formation",
    ecartHeuresTravailles: "Ecart heures",
    coutTotalPersonnel: "Coût humain total",
    ecartCoutTheorique: "Ecart coût théorique",
    ecartCoutTheoriquePourcent: "Ecart coût théorique (%)",
    productiviteTheorique: "Productivité théorique (u/h)",
    productiviteReel: "Productivité réelle (u/h)",
    productivitePourcent: "Performance productivité (%)",
    ecart: "Ecart",
    coutUnitaire: "Coût unitaire",
    coutTheorique: "Coût total théorique",
    coutReel: "Coût total réel",
    format: "Format",
    productivite: "Productivité",
    heures: "Heures",
    coutTotal: "Coût total",
    coutHoraire: "Coût horaire",
    mouvements: "Mouvements",
    controlesLiberatoires: "Contrôles libératoires",
    quantiteUnitaire: "Quantité unitaire",
    lotsPdc: "Lot démarrage",
    tracabilite: "Traçabilité",
    nouveauLot: "Nouveau lot",
    poste_when: "Opé. de fab. du ",
    dateChangement: "Date de changement",
    changement_lot: "Traçabilité et Consommations",
    quantiteProduite2: "Quantité produite",
    quantiteProduite: "Nombre de produits finis présents dans l'atelier",
    quantiteProduiteTotal: "Quantité restante à intégrer",
    produitsSurLigne: "Produits sur ligne",
    consoTheoriqueUnitaire: "Conso. théorique unitaire",
    consoTheorique: "Conso. théorique",
    consoTheoriqueTotalOf: "Conso. théorique totale OF",
    retourPdc: "Retour pied de chaine",
    piedDeChaine: "Pied de chaine",
    consoProd: "Conso. Prod.",
    pertes: "Pertes",
    pertesPourcent: "Pertes (%)",
    lot: "Lot",
    misEnPdc: "Mis en pied de chaine",
    emplacement: "Emplacement",
    identifiantObligatoire: "Identifiant obligatoire",
    commentairePositif: "Commentaire positif",
    commentaireNegatif: "Commentaire négatif",
    derniereUniteProduite: "Dernière unité produite",
    identifiant: "Identifiant",
    saisie: "Saisie",
    linkedFacture: "Facture liée",
    linkedAvoir: "Avoir lié",
    productions: "Productions",
    cadence: "Cadence nominale (/h)",
    nbPersonnes: "Nombre d'ouvriers",
    bilanProductivite: "Bilan productivité",
    tempsCalage: "Temps de calage (minutes)",
    tempsNettoyage: "Temps de nettoyage (minutes)",
    denomination: "Dénomination",
    profile: "Mon profil",
    infos: "Infos",
    colors: "Couleurs",
    minutes: "Minutes",
    nomenclature: "Nomenclature",
    stock: "Stock",
    detail_stock: "Stocks et lots ",
    of: "OF",
    of_title: "Ordres de fabrication (OF)",
    naf: "NAF",
    dateDebut: "Date de mise en action",
    dateStart: "Date de début",
    startedAt: "Démarrée le",
    fromDate: "du",
    toDate: "au",
    dateEnd: "Date de fin",
    tva_intracom: "TVA Intracom",
    planning: "Planning",
    majorationPercent: "Majoration salaire (%)",
    majorationSalaire: "Majoration salaire (€)",
    panier: "Panier (€)",
    detail_lot: "Détails du lot",
    personnel: "Personnel",
    tauxHoraire: "Taux horaire (Tout compris)",
    dluo: "Date limite",
    quantite: "Quantité",
    quantiteAProduire: "Quantité à produire",
    quantiteUniteGestion: "Quantité (unité de gestion)",
    siret: "Siret",
    numero: "Numéro",
    tva: "TVA (%)",
    actions: "Actions",
    mouvement: "Mouvement",
    date_mouvement: "Date du mouvement",
    dateCreation: "Date de passage",
    tailleEchantillon: "Taille de l'échantillon",
    nombreEnregistrement: "Nombre d'enregistrements minimum",
    choix: "Choix possible",
    dateReception: "Date de réception",
    dateLivraison: "Date de livraison prévue",
    lotFournisseur: "Lot fournisseur",
    quantiteReception: "Quantité reçue",
    dateValidation: "Date de validation",
    dateConfirmation: "Date de confirmation",
    dateFermeture: "Date de fermeture",
    type_mouvement: "Type de mouvement",
    francoPrix: "Franco (Prix)",
    francoQuantite: "Informations Franco",
    code: "Code article",
    commandes: "Commandes fournisseur",
    commandes_client: "Commandes client",
    commande_client: "Commande client",
    famille: "Famille",
    debut: "Début",
    fin: "Fin",

    numeroCommandeClient: "Numéro de commande client",

    quantiteAUtiliser: "Quantité à utiliser",
    quantiteARajouterPalette: "Quantité à rajouter sur l'unité d'expédition",
    quantiteReintegrer: "Quantité à réintégrer",

    heuresTravaillees: "Heures travaillées",
    heuresRTT: "Heures en RTT",
    heuresConges: "Heures en congés",
    heuresMaladie: "Heures en Maladie",
    heuresNonJustifiees: "Heures non justifiées",

    sous_famille: "Famille technique",
    delaiReglement: "Délai de réglement",
    typeReglement: "Type de réglement",
    unite: "Unité de gestion",
    unite_achat: "Unité d'achat",
    unite_vente: "Unité de vente",
    unite_base: "unité",
    reference: "Réference",
    reference_fournisseur: "Réf. fournisseur",
    reference_client: "Réf. client",
    coefficientUniteGestion: "Coef. unité de gestion",
    multipleAchat: "Multiple d'achat",
    multipleVente: "Multiple de vente",
    multiple_placeholder: "ex: 2045",
    poste: "Poste",
    role: "Rôle",
    modele: "Utiliser un modèle",
    quantiteMin: "Qtt Min.",
    quantiteMax: "Qtt Max.",
    prix: "Prix",
    prixTTC: "Prix TTC",
    delaiLivraison: "Délai de livraison (jours ouvrés)",
    ddmMiniJours: "Date limite mini contractuelle (jours)",
    ddmMiniJours_placeholder: "Ex : 60",
    ddmMiniJours_hint:
      "Durée minimale entre l'expédition et la date limite (DDM ou DLC selon le type d'article). Un lot est éligible uniquement si dateLimite ≥ date_expé + N jours.",
    ligne: "Ligne de prod.",
    lignes: "Lignes de prod.",
    type: "Type",
    type_list: "Type de liste",
    tiers: "Clients et fournisseurs",
    current: "Courant",
    changePassword: "Changer de mot de passe",
    password: "Mot de passe",
    confirmPassword: "Confirmer le mot de passe",
    passwordMismatch: "Les mots de passe ne correspondent pas",

    articles: "Articles",
    article: "Article",
    duree: "Durée",
    administration: "Administration",
    infos_perso: "Infos perso.",
    colorization: "Couleurs",
    label: "Libellé",
    description: "Description",
    description_variable: "Description du paramètre",
    settings: "Paramètres",
    informations_generales: "Informations générales",
    composants: "Composants",
    procede_article: "Procédé de l'article",
    procede: "Procédé",
    controls: "Contrôles",
    nom: "Nom",
    prenom: "Prénom",
    ddn: "Date de naissance",
    sexe: "Sexe",
    date: "Date",
    qte: "Qté",

    modeOperatoire: "Mode opératoire",

    limiteHaute: "Limite haute",
    limiteBasse: "Limite basse",
    nominal: "Nominal",

    limiteHauteString: "Limite haute",
    limiteBasseString: "Limite basse",
    nominalString: "Nominal",
    delivery_adress: "Adresse de livraison",
    billing_adress: "Adresse de facturation",
    entrepot_depart: "Entrepôt de départ",
    entrepots: "Entrepôts",
    add_entrepot: "Ajouter un entrepôt",
    assigner_entrepot: "Assigner un entrepôt",
    entrepot_stockage: "Entrepôt de stockage",
    quantityProdDefault: "Quantité de référence",
    quantityProdDialogTitle: "Modification de la quantité de référence",
    transfert: "Transfert",
    commande: "Commande",
    dechargement: "Déchargement",
    reception: "Réception",
    palettes: "Unités d'expédition",
    livraisons: "Livraisons",
    contacts: "Contacts",
    commercial: "Commercial",
    procedes: "Procédés",
    params_specification: "Paramètres de spécification",
    logistique: "Logistique",
  },
  models: {
    add_cta: "Ajouter un modèle",
    articles_linked: "Articles liés",
    no_articles_linked: "Aucun articles lié",
    articles_linked_dialog_title: "Articles liés à la spécification",
  },
  onboarding: {
    page_title: "Onboarding",
    page_subtitle: "Configurez et prenez en main JustUp, étape par étape.",
    sidenav_label: "Onboarding",
    guides: "guides",
    status_not_started: "À démarrer",
    status_in_progress: "En cours",
    status_learned: "Appris",
    status_done: "Configuré",
    status_complete: "Terminé",
    action_start_guide: "Démarrer le guide",
    action_watch_video: "Voir la vidéo",
    action_ask_justy: "Demander à Justy",
    data_check_ok: "Données présentes",
    data_check_missing: "Aucune donnée",
    refresh_checks: "Vérifier",
    next_step: "Prochaine étape",
    welcome_title: "Bienvenue sur JustUp !",
    welcome_subtitle: "Configurez et apprenez JustUp en suivant votre parcours de mise en route.",
    welcome_description: "Le parcours vous guide groupe par groupe, en combinant tutoriels interactifs et saisie de vos premières données.",
    welcome_start: "Commencer l'onboarding",
    welcome_later: "Plus tard",
    justy_prompt_module: "Comment faire : #module ? Explique-moi simplement, étape par étape.",
    justy_prompt_general: "Aide-moi à démarrer mon intégration sur JustUp : par où commencer ?",
    trophies_title: "Vos trophées",
    parcours_title: "Votre parcours",
    recommended: "Conseillé",
    cta_start: "Commencer",
    cta_resume: "Reprendre",
    level: "Niveau #n",
    xp: "#n XP",
    xp_to_next: "#n XP avant le niveau suivant",
    quickwin_goal: "Objectif",
    quickwin_reached: "Atteint !",
    concepts_ack: "J'ai compris la logique",
    concepts_acked: "Logique comprise",
    phases: {
      comprendre: { title: "Comprendre JustUp", verb: "Comprendre", subtitle: "5 min pour saisir la logique des données avant de configurer." },
      demarrage: { title: "Prends tes marques", verb: "Naviguer", subtitle: "Découvre l'interface, le menu et tes tâches du quotidien." },
      entreprise: { title: "Configure ton entreprise", verb: "Configurer", subtitle: "Société, activité et lignes de production." },
      catalogue: { title: "Construis ton catalogue", verb: "Construire", subtitle: "Articles, spécifications, nomenclatures et contrôles qualité." },
      approvisionnement: { title: "Approvisionne-toi", verb: "Acheter", subtitle: "Fournisseurs, commandes d'achat et réceptions en stock." },
      fabrication: { title: "Fabrique", verb: "Produire", subtitle: "Ordres de fabrication, planification et traçabilité." },
      vente: { title: "Vends & expédie", verb: "Vendre", subtitle: "Commandes clients, expéditions, bons de livraison et factures." },
      pilotage: { title: "Pilote ton activité", verb: "Piloter", subtitle: "Stock, traçabilité, tableaux de bord et rentabilité." },
    },
    quickwins: {
      logique: { title: "Logique comprise", desc: "Tu as compris comment JustUp structure tes données." },
      navigation: { title: "Navigation maîtrisée", desc: "Tu sais te repérer et naviguer dans JustUp." },
      usine: { title: "Usine configurée", desc: "Ton entreprise et tes lignes de production existent dans JustUp." },
      produit: { title: "Premier produit fabricable", desc: "Un article et sa spécification sont prêts à être produits." },
      matiere: { title: "Première matière reçue", desc: "Un fournisseur, une commande d'achat : ta première matière entre en stock." },
      of: { title: "Premier OF lancé", desc: "Tu as créé ton premier ordre de fabrication." },
      facture: { title: "Première vente facturée", desc: "Une commande client transformée en facture." },
      autonome: { title: "Pilote autonome", desc: "Tu maîtrises tout le cycle : tu pilotes JustUp en autonomie." },
    },
    justy: {
      welcome: "Bienvenue sur JustUp ! Je suis Justy, je t'accompagne. On commence par #phase. 🚀",
      progress: "Beau travail ! Prochaine étape conseillée : #phase. 💪",
      near_done: "Tu y es presque — encore un effort et tu pilotes en autonomie ! 🏆",
      done: "Bravo, ton intégration est complète. Tu es 100 % autonome sur JustUp ! 🎉",
    },
    celebration: {
      quickwin: "Trophée débloqué !",
      levelup: "Niveau atteint !",
    },
    concepts_title: "Comprendre JustUp avant de configurer",
    concepts_subtitle: "Avant de saisir vos données, prenez 5 minutes pour comprendre comment JustUp structure l'information.",
    logic_title: "La logique des données",
    glossary_title: "Glossaire",
    of_cycle: {
      title: "Le cycle de production",
      s1_t: "Article + Ligne", s1_c: "nomenclature & procédés · famille technique",
      s2_t: "Ordre de fabrication", s2_c: "fabriquer l'article sur la ligne · ± stock en entrée",
      s3_t: "Production", s3_c: "saisie des contrôles + traçabilité",
      s4_t: "Réintégration", s4_c: "la quantité produite entre en stock (produit fini)",
      s5_t: "Analyse de perf.", s5_c: "rendement, coûts réels et écarts de l'OF",
    },
    schema: {
      model: "Modèle de spécif",
      model_sub: "recette + procédé + contrôles + variables",
      inherit: "hérite",
      article_own: "+ valeurs propres",
      supplier: "Fournisseur",
      client: "Client",
      buy_price: "prix d'achat",
      sell_price: "prix de vente",
      component_cost: "Coût composant",
      nomenclature: "via nomenclature",
      finished_cost: "Coût produit fini",
      margin: "Marge",
      schema_model_caption: "Un modèle, autant d'articles que de variantes.",
      schema_cascade_caption: "Le coût remonte la recette ; comparé au prix de vente, il donne la marge.",
      schema_spec_caption: "Une spécification = nomenclature + procédé + contrôles, paramétrés par des variables.",
      nomenc_proc: "nomenclature + procédés",
      param_ligne: "paramétrage · famille technique",
      of_fabricate: "fabriquer l'article sur la ligne",
      of_stock_in: "± stock en entrée",
      prod_saisie: "saisie : contrôles + traçabilité",
      reintegration: "Réintégration",
      perf: "Analyse de perf.",
      pf_stock: "Produit fini → stock",
      production: "Production",
      ligne: "Ligne de prod",
      schema_of_caption: "Le cycle de production : article + ligne → OF → production → réintégration (stock + analyse).",
    },
    logic: {
      modele_to_article: {
        title: "Modèles de spécif → articles",
        body: "On crée d'abord des MODÈLES de spécification (recette + procédé + contrôles) avec des VARIABLES pour ce qui change. Chaque article fabriqué s'y rattache et renseigne ses variables : un modèle, autant d'articles que de variantes.",
      },
      familles: {
        title: "Familles & sous-familles",
        body: "Chaque article est classé par famille (et sous-famille) : c'est l'organisation commerciale, utilisée pour les statistiques, les analyses et les regroupements.",
      },
      famille_technique: {
        title: "Famille technique & ligne",
        body: "Un article fabriqué doit avoir une famille technique : elle le relie à une ligne de production. Sans elle, impossible de planifier ni de lancer un ordre de fabrication.",
      },
      lignes: {
        title: "Lignes de production",
        body: "Les lignes représentent vos outils de fabrication. On y rattache les familles techniques pour savoir où et comment chaque produit est fabriqué.",
      },
      tiers_fournis: {
        title: "Tiers & articles fournis",
        body: "Fournisseurs et clients sont des tiers. Pour chaque couple article × tiers, un « article fourni » porte le tarif, l'unité et la référence propres à ce partenaire (achat côté fournisseur, vente côté client).",
      },
      cascade_prix: {
        title: "Cascade des infos prix",
        body: "Les prix d'achat (articles fournis fournisseurs) donnent le coût des composants ; ce coût remonte la nomenclature jusqu'au produit fini, puis se compare au prix de vente (articles fournis clients) pour calculer la marge. Tout se met à jour en cascade.",
      },
    },
    glossary: {
      article: { term: "Article", def: "Une référence gérée dans JustUp : matière première, emballage, ou produit fabriqué/vendu." },
      specification: { term: "Spécification", def: "La fiche technique complète d'un produit fabriqué : recette, procédé et contrôles, versionnée." },
      modele_specif: { term: "Modèle de spécif", def: "Une spécification partagée et réutilisable : plusieurs articles s'y rattachent au lieu de tout refaire." },
      variable: { term: "Variable", def: "Un paramètre du modèle qui change d'un article à l'autre (ex : taux de sucre). Chaque article met sa valeur." },
      nomenclature: { term: "Nomenclature", def: "La recette : liste des composants et quantités pour fabriquer le produit." },
      procede: { term: "Procédé", def: "Les étapes de fabrication (mélange, cuisson, conditionnement…), certaines optionnelles." },
      controle: { term: "Contrôle", def: "Un point de contrôle qualité (conforme/non conforme, mesure, CCP…) rattaché à une étape." },
      famille: { term: "Famille", def: "Le classement commercial principal d'un article (ex : Confitures, Sauces)." },
      sous_famille: { term: "Sous-famille", def: "Une subdivision de la famille pour affiner le classement." },
      famille_technique: { term: "Famille technique", def: "Le regroupement de production d'un article fabriqué, lié à une ligne — indispensable pour produire." },
      ligne: { term: "Ligne de production", def: "L'outil/poste où l'on fabrique. Reliée aux familles techniques." },
      tiers: { term: "Tiers", def: "Un partenaire : fournisseur ou client." },
      article_fourni: { term: "Article fourni", def: "Le lien article × tiers : tarif négocié, unité et référence propres à ce partenaire (achat ou vente)." },
      infos_prix: { term: "Infos prix", def: "Les tranches de prix d'un article fourni (prix selon la quantité). Elles alimentent la cascade coûts/marges." },
      lot: { term: "Lot", def: "Un ensemble physique de produit tracé (réception ou production), avec DLC/DDM." },
      of: { term: "Ordre de fabrication (OF)", def: "Le lancement d'une production d'un article en quantité, sur une ligne." },
    },
  },
  routing: {
    onboarding: "Onboarding",
    back: "Retour",
    auth: "Authentification",
    justup_link: "JustUp Link",
    justup_link_qr: "JustUp Link Qr",
    administration: "Administration",
    entreprise: "Entreprise",
    stats: "Stats.",
    facturation: "Facturation",
    gestion_equipes: "Gestion des équipes",
    tracabilite: "Traçabilité",
    analyse_ca: "Analyse CA",
    checklists: "Checklists",
    expeditions: "Expéditions et BL",
    factures: "Factures",
    inventaire: "Inventaire",
    specification: "Spécification",
    parametrage_admin: "Paramétrage admin.",
    pied_de_chaine: "Pied de chaine",
    articles: "Articles",
    production: "Production",
    commandes: "Commandes",
    transferts_entrepot: "Transferts Entrepôt",
    commandes_clients: "Commandes clients",
    lot: "Lot",
    lignes_prod: "Lignes de prod.",
    saisie_heures: "Saisie des heures",
    planif_ofs: "Planif. OFs",
    planif_articles: "Planif. Articles",
    gestion_tiers: "Gestion des tiers",
    parametrage_activite: "Paramétrage activité",
    stocks: "Stocks",
    profil: "Profil",
    cost_impact: "Simulation de coûts",
    cost_impact_2: "Simulation de coûts (réf.)",
    connexion_ecommerce: "Connexion e-commerce",
    synchronisation_ecommerce: "Synchronisation e-commerce",
    ofs: "Ofs",
    suivi_production: "Suivi de production.",
    suivi_fabrication: "Suivi de fabrication.",
    suivi_prod: "Suivi de prod.",
    ope_fab: "Opé de fab.",
    bilan_matiere: "Bilan matière",
    mouvements: "Mouvements",
    statistiques: "Statistiques",
    heures_saisies: "Heures saisies",
    infos_generales: "Infos générales",
    logistique: "Logistique",
    nomenclature: "Nomenclature",
    procede: "Procédé",
    controles_article: "Contrôles de l'article",
    specification_article: "Spécification de l'article",
    parametres_specification: "Paramètres de spécification",
    commercial: "Commercial",
    article_infos: "Article infos.",
    specifications_produit: "Spécifications produit",
    commande: "Commande",
    dechargement: "Déchargement",
    reception: "Réception",
    dechargements: "Déchargements",
    commande_client: "Commande client",
    preparation: "Préparation",
    palettes: "Unités d'expédition",
    livraisons: "Livraisons",
    lot_infos: "Lot infos.",
    couts: "Coûts",
    transfert_entrepot: "Transfert Entrepôt",
    reception_transfert: "Réception Transfert",
    comptage: "Comptage",
    mon_entreprise: "Mon entreprise",
    exports_csv: "Exports CSV",
    adresses: "Adresses",
    documents: "Documents",
    numerotations: "Numérotations",
    parametres_avances: "Paramètres avancés",
    facturation_justup: "Facturation JustUp",
    tokens: "Tokens & Facturation IA",
    tiers: "Tiers",
    groupes: "Groupes",
    groupe: "Groupe",
    infos_generales_tiers: "Infos Générales",
    contacts: "Contacts",
    rib: "RIB",
    infos_perso: "Infos perso.",
    horaires: "Horaires",
    parametrage_mail: "Paramétrage mail",
    gestion_utilisateurs: "Gestion des utilisateurs",
    gestion_autorisations: "Gestion des autorisations",
    planning_defaut: "Planning par défaut",
    enumerations: "Enumérations",
    controles_generaux: "Contrôles généraux",
    parametrages_generaux: "Paramétrages généraux",
    unites_expedition: "Unités d'expédition",
    parametrage_commercial: "Paramétrage commercial",
    pdc: "PDC",
    reintegration_pdc: "Réintégration PDC",
    stock: "Stock",
    stats_of: "Stats. OF.",
  },
  fiche_palette: {
    dialog_title: "Impression d'une étiquette Logistique",
    add: "Ajouter un modèle de fiche",
    colis: "colis",
    nb_colis: "Nb colis",
    uc_label: "Quantité UC",
    colis_label: "Quantité colis",
    qty_required_uc: "Indiquez la quantité en UC",
    qty_required_any: "Indiquez la quantité en UC ou en colis",
    alert: {
      weight_missing: "Poids brut / UG manquant — l'étiquette affichera '—'",
    },
  },
  tooltip: {
    go_commande: "Consulter la commande",
    view_detail: "Voir le détail",
  },
  bl: {
    add_label: "Préparer une nouvelle expédition",
    add_palette_label: "Ajouter une unité d'expédition",
    no_linked_bl: "Aucun bon de livraison lié",
    link_bl: "Rattacher un BL",
    waiting_billing: "Bon de livraison en attente de facturation",
    multiple_waiting_billing: "Bons de livraison en attente de facturation",
    scan_already_scanned: "Vous avez déjà scanné cette unité d'expédition",
    scan_palette_ready: "Unité d'expédition prête pour l'expédition",
    mail_dialog_send: "Envoyer le bon de livraison",
    mail_show_pdf: "Voir le bon de livraison PDF",
    mail_subject_default: "Bon de livraison #numero",
    mail_html_default:
      "<p>Bonjour,</p><p>Vous trouverez ci-joint le bon de livraison <strong>#numero</strong>#ccPart.</p><p>Cordialement.</p>",
    mail_html_cc_part: " correspondant à votre commande #ccNumeros",
    numero_provisoire: "PROVISOIRE",
    send_action: "Envoyer par mail",
    send_all: "Envoyer tous les BL par mail",
    send_one: "Envoyer le BL #numero par mail",
    mail_sent: "Bon de livraison envoyé",
  },
  chargement: {
    expedition_title: "Expédition",
    expedition_finalize: "Expédier le chargement",
    no_controles_generaux: "Aucun contrôle général configuré pour cette étape",
    step2_hint: "Scannez ou sélectionnez les unités d'expédition à charger",
    step3_hint: "Récapitulatif du chargement et lettre de voiture",
    controls_deferred: "Contrôles en attente",
    scan_button: "Scanner",
    ctrl_unite_label: "Contrôles de l'unité d'expédition",
    ctrl_none: "Aucun contrôle",
    ctrl_todo: "Contrôles à faire",
    ctrl_in_progress: "En cours",
    ctrl_ok: "Contrôles OK",
    ctrl_nc: "NC détectées",
    scan_not_sscc: "Code non reconnu comme SSCC",
    scan_not_in_chargement: "Cette unité n'appartient pas à ce chargement",
    scan_already: "Unité déjà scannée",
    manual_confirm_title: "Sélection manuelle",
    manual_confirm_message: "Code-barres illisible ? Confirmer la sélection manuelle de cette unité.",
    lettre_voiture_doc: "Lettre de voiture (photo, PDF, scan...)",
    recap_title: "Récapitulatif du chargement",
    recap_palettes: "Unités d'expédition",
    recap_poids: "Poids brut total",
    recap_colis: "Nombre de colis",
    recap_quantite: "Quantité",
    recap_transporteur: "Transporteur",
    nc_detected: "non-conformité(s) détectée(s)",
    observations: "Observations / Réserves",
    observations_placeholder: "Observations, réserves transporteur...",
    signature_operateur: "Signature opérateur",
    signature_chauffeur: "Signature chauffeur",
    signature_clear: "Effacer",
    signature_optional: "Optionnel",
    filter_transporteur: "Transporteurs",
    filter_destinataire: "Destinataires (clients)",
    filter_unit_type: "Types d'unité d'expédition",
    filter_entrepot: "Entrepôts de départ",
  },
  chargement_detail: {
    charged: "Expédié",
    date_expedition: "Date d'expédition",
    entrepot: "Entrepôt de départ",
    controles_generaux: "Contrôles généraux du chargement",
    transfert: "Transfert entrepôt",
    print_bls: "Imprimer les BL",
    print_bts: "Imprimer les BT",
    print_fiches: "Imprimer les fiches",
    controles_palette: "Contrôles réalisés sur cette unité",
  },
  changement_lot: {
    cta: "Saisir la traçabilité",
    orphan_tooltip:
      "Lot rattaché par déduction (saisi hors d'une opération active). Vérifiez le poste auquel il appartient.",
    label: "Saisie de la traçabilité",
    label_conso: "Saisie de traçabilité et de consommation",
    used_from: "utilisé à partir de",
    take_from_pdc: "Prélever sur le stock de composants d'OF (PDC)",
    take_from_stock: "Prélever sur le stock général (entrepôt:",
    label_poste: "Opé. sur laquelle intervient cette saisie de traçabilité",
    quantite_consommation: "Saisir une quantité consommée",
    quantite_consomme: "Quantité consommée",
    already_declared_consommation: "Consommation déjà déclarée",
    declared_consommation: "Consommation déclarée",
    total_pdc: "Total en PDC",
    reste_disponible: "Quantité disponible en PDC",
    is_traca_obligatoire_missing_message_part1: "L'article",
    is_traca_obligatoire_missing_message_part2:
      "n'a aucun enregistrement de traçabilité. Ajoutez-en un pour continuer.",
    is_traca_obligatoire_missing_header:
      "Traçabilité manquante pour les articles suivants :",
    is_traca_obligatoire_missing_item: "traçabilité manquante",
    missing: "À compléter",
    why_cannot_no_ope:
      "Afin de pouvoir saisir une traçabilité, veuillez au préalable démarrer une opération de fabrication",
  },
  controles: {
    frequence_limit:
      "(la tolérance ne peut pas être supérieure à la moitié de la fréquence)",
    isCCP: "est un CCP (Point critique de contrôle)",
    isPRPO: "est un PrPO (Programme Prérequis Opérationnel)",
    isCalage: "Contrôle de calage",
    isJustupTodo: "Apparait dans dans les listes de tâche liée à l'OF ",
    isProd: "Contrôle de prod.",
    isFinPoste: "Contrôle de fin de poste",
    isFinProd: "Contrôle de fin de prod.",
    add_evenement: "Ajouter un événement",
    add_cta: "Ajouter un contrôle",
    add_choice: "Ajouter un choix",
    add_enregistrement: "Ajouter un enregistrement",
    correct_answer: "Réponse correcte",
    select_answer: "Cliquez sur la bonne réponse",
    reception: "Contrôles à receptions",
    reception_lot: "Contrôles à receptions du lot",
    ecartMinutes: "Ecart (minutes)",
    toleranceMinutes: "Tolérance (minutes)",
    poste_start: "Démarrer l'opé. de fab.",
    poste_end: "Terminer l'opé. de fab.",
    start_rattrapage: "Rattraper les heures",
    stop_rattrapage: "Arrêter le rattrapage",
    with_courbe: "Avec affichage courbe",
    with_dynamic: "Avec valeurs dynamiques",
    infos: "Infos générales",
    param_saisies: "Paramètres de saisie",
    configuration: "Configuration",
    quand: "Quand ?",
    quelles_lignes: "Ligne(s) à exclure",
    aucune_donnee: "Aucune donnée disponible pour ce contrôle",
    aucun_enregistrement: "Aucun enregistrement de contrôles",
    ajouter_reponse: "Ajouter une réponse...",
    familles_categories: "Familles / Sous-familles",
    ajouter_evenement: "Ajouter un évènement...",
    controles_generaux: "Contrôles généraux",
    saisir: "Saisir le contrôle",
    conforme: "Conforme",
    non_conforme: "Non conforme",
    a_faire: "À faire",
    realiser_controle: "Réaliser le contrôle",
    non_realise: "Non réalisé",
    valeur_placeholder: "Valeur",
    commentaire_placeholder: "Commentaire...",
    ajouter_evenement_placeholder: "Ajouter un évènement...",
    tips_form_timing:
      "Vous pouvez définir quand et comment le contrôle doit être réalisé :\n" +
      "\n" +
      "Contrôle à fréquence régulière : définissez un intervalle et une tolérance (ex. : toutes les 10 min ± 3 min).\n" +
      "\n" +
      "Événement : créez un ou plusieurs événements (ex. : changement de rouleau d’étiquette) qui permettront de déclencher manuellement le contrôle lorsqu’ils se produisent.\n" +
      "\n" +
      "👉 Les deux options peuvent être utilisées ensemble ou séparément.\n" +
      "👉 Si vous ne cochez aucune case, le contrôle sera effectué une seule fois.",
  },
  lot: {
    edit: "Modification du lot",
    actions: "Actions sur le lot",
    page: "Page du lot",
    goToOf: "OF de production",
    goToCommande: "Commande fournisseur",
    create: "Créer un lot",
    search: "Numéro de lot...",
    createAndSelect: "Créer un nouveau lot",
    unique: "Lot unique",
    emptyCantCreate:
      "Pouvoir séléctionner un lot, veuillez d'abord l'ajouter au pied de chaine",
    select: "Sélectionner un lot",
    count: "Inventorier",
    transferer: "Transférer",
    quick_transfer_title: "Transfert rapide",
    quantite_a_transferer: "Quantité à transférer",
    adresse_destination: "Entrepôt de destination",
    adresse_depart: "Adresse de départ",
    fusionner: "Fusionner les lots",
    stock_cumule_label: "Évolution du stock cumulé",
    stock_cumule_empty:
      "Sélectionnez un ou plusieurs lots pour afficher l'évolution du stock cumulé.",
    no_stock: "Aucun stock disponible pour ce lot selon les critères.",
    recalculer: "Recalculer la quantité",
    depart_mouvement: "Départ du mouvement",
    arrivee_mouvement: "Arrivée du mouvement",
    quantite_mouvement: "Quantité du mouvement",
    lots_sans_stocks: "Lots sans stocks",
    lot_not_in_pdc: "Ce lot n'est pas présent en pied de chaine",
    type_mouvement_filter: "Type de mouvement",
    date_filter: "Date",
    adresse_filter: "Adresse",
    comptage_title: "Comptage",
    methode_prefix: "Méthode :",
    compter_packs: "Compter le nombre de packs contenant",
    controles_liberatoires: "Contrôles libératoires",
    inherited_from: "Numéro hérité de",
    stock_edit_title: "Inventaire — #article - #adresse",
  },
  commande: {
    ligneEdit: "Edition d'une ligne de commande",
    commandeEdit: "Modifier la commande",
    dateManuelle: "Forcer une date de livraison",
    ligneCreate: "Ajouter une ligne de commande",
    missing_delivery_date: "Veuillez saisir la date de livraison prévue",
    consulter_tiers: "Consulter le tiers",
    dechargement: "Déchargement",
    desannuler: "Désannuler",
    fiche_palette: "Fiche Palette",
    declare_nc: "Déclarer une NC",
    total_recu: "Total reçu",
    total_depasse_commande: "Dépasse qté commandée",
    ajouter_lot: "Ajouter un lot",
    qte_superieure_zero: "La quantité reçue doit être supérieure à 0",
    conformite: "Conformité",
    etats_commande: "États de la commande",
    etats_reception: "État réception",
    marquer_terminee: "Marquer la commande terminée",
    reopen: "Remettre la commande en cours",
    desolder: "Désolder",
    facturer: "Facturer",
    ajouter_article_vendu: "Ajouter un article vendu",
    prix_libre: "Prix libre",
    adresse_livraison: "Adresse de livraison:",
    adresse_facturation: "Adresse de facturation:",
    numero: "Numéro",
    voir_bon_commande: "Éditer le bon de commande",
    ref_fournisseur: "Réf. fournisseur",
    receptions_title: "Réceptions",
    hist_numero_dechargement: "N° déchargement",
    no_receptions: "Aucune réception pour cette ligne",
  },
  production: {
    voir_qte_par_poste: "Voir les quantités par poste",
    matiere: "Matière",
    retour_liste: "Retour à la liste",
    cancelReinte: "Annuler la réintégration",
    cancelReinteWarning:
      "Souhaitez-vous vraiment annuler la réintégration du pied de chaine ?",
    preparePDC: "Préparer PDC",
    reintePDC: "Réintégrer PDC",
    integrationPF: "Intégration anticipée",
    declare_nc: "Déclarer une NC",
    canBeMoreProduit: "Peut-être supérieure car en cours de production",
    dashboard_report: "Tableau de bord machine",
    chose_ope_cta: "Sélectionner une opé. :",
    chose_ope_cta_big: "Veuillez sélectionner une opé. à consulter",
    create_ope_cta_big: "Aucune opé. n'a pour l'instant été créé sur cet OF",
    fill_bilan: "Saisir le bilan matière",
    consult_bilan: "Voir le bilan matière",
    select_ligne: "Sélectionner une ligne",
    select_of: "Sélectionner un of",
    start: "Démarrer la production",
    startNow: "Démarrer maintenant",
    continue: "Continuer la production",
    startNextOpe: "Démarrer l'opé. suivante",
    plan: "Planifier l'OF",
    add_poste: "Nouvelle opé. de fab.",
    end_poste: "Terminer l'opé. de fab.",
    add_prod: "Ajouter une production",
    end_prod: "Terminer la production",
    go_attente_reinte: "Attente réinté. PDC",
    poste_starting: "Démarrage de l'opé. de fab.",
    pdc_retour: "Réintégration pied de chaine",
    pdc: "Pied de chaine",
    restart_prod: "Relancer la production",
    restart_ope: "Repasser en cours",
    preview_poste: "Prévisualisation des infos de démarrage",
    please_start_ope: "Veuillez démarrer l'opé.",
    close_without_prod: "Clôturer l'opé sans production",
    add_hours: "Ajouter des heures de Main d'Oeuvre",
    ope_quantity_cta:
      "Pour effectuer certains calculs pendant le procédé, la spécification nécessite la quantité prévue.",
    ope_dialog: "Nouvelle opé.",
    create_first_ope: "Créer la première opé. de fab.",
    validation_of: "Validation de l'OF",
    validate_qualite: "Valider l'OF d'un point de vue qualité",
    validate_prod: "Valider l'OF d'un point de vue prod.",
    validate: "Valider l'OF",
    finOpe: {
      title: "Quantité produite",
      integre_cette_ope: "Déjà intégré sur cette opé",
      integrations_note:
        "Ces #qte #unite sont déjà pris en compte dans le calcul.",
      nc_already_declared: "Quantité NC déjà déclarée",
      nc_total_hint:
        "Saisissez ci-dessous la quantité conforme produite. Total fabriqué = #conforme + #nc = #total #unite (conforme + NC).",
      locked_title: "Saisie verrouillée",
      locked_desc_en_attente:
        "L'OF est en attente de validation. Pour modifier ces informations, annulez la réintégration depuis le panneau latéral.",
      locked_desc_valide:
        "L'OF est déjà validé. Pour modifier ces informations, annulez la réintégration depuis le panneau latéral.",
      sur_ligne: "Quantité sur ligne",
      sur_ligne_sub: "Ce que vous comptez",
      saisie_directe: "Saisie directe",
      calcule: "Calculé",
      produit_ope: "Produit sur cette opé",
      produit_ope_sub: "Ce que vous avez fabriqué",
      quantite_negative: "Quantité négative",
      erreur_prod: "Problème : production de",
      erreur_comptage_desc:
        "Vous avez compté #surLigne #unite sur ligne, mais il y avait déjà #avantSaisie #unite avant cette opé.",
      erreur_comptage: "Erreur de comptage sur la ligne",
      pertes_casses: "Pertes ou casses non déclarées",
      integration_double: "Intégration comptée en double",
      resultat: "Soit une quantité produite sur cette opé de :",
      total_apres_ope: "Total produit sur l'OF après cette opé",
      objectif_of: "Objectif de l'OF",
      ope_precedente: "Opé précédente",
      integre_sur_ope: "Intégré sur cette opé",
      produit_cette_ope: "Produit sur cette opé",
      votre_saisie: "votre saisie",
      total_apres: "Total après cette opé",
      reste_a_produire: "Reste à produire",
      of_termine: "OF terminé !",
      represente_objectif: "Cela représente",
      de_objectif: "de l'objectif de l'OF",
      aide_title: "Comment ça fonctionne ?",
      aide_desc:
        "Deux façons de renseigner : saisissez soit ce que vous comptez sur la ligne, soit ce que vous avez produit. L'autre valeur se calcule automatiquement.",
      formule_calcul: "Formule de calcul :",
      detail_of: "Détail pour cet OF",
      avant_saisie: "Avant votre saisie",
      produit_maintenant: "Produit sur cette opé",
      chiffres_collent: "Les chiffres ne collent pas ?",
      chiffres_collent_desc:
        "Vérifiez s'il y a eu des pertes, des casses non déclarées, ou des erreurs sur les opérations précédentes.",
      aide_sur_ligne:
        "Comptez tout ce qui est physiquement présent sur votre ligne de production.",
      formule: "Formule",
      aide_produit:
        "Ce que vous avez fabriqué pendant cette opération (hors intégrations).",
    },
    en_cours_production: "En cours de production",
    acceder_production: "Acceder à la production",
    aucun_of_en_cours: "Aucun OF en cours de production",
    of_suivant: "OF suivant",
    prevu_le: "Prévu le",
    consulter_of: "Consulter l'OF",
    aucun_of_prevu: "Aucun OF prévu",
    demarrer_ope: "Démarrer l'opé",
    quantite_atelier: "Quantité dans l'atelier en fin d'opération",
    quantite_produite_ope: "Quantité produite sur l'opération",
    generer_fiche: "Générer une étiquette logistique",
    etats_of: "États de l'OF",
    lignes_production: "Lignes de production",
    dluo_filter: "DLUO",
    date_filter: "Date",
    lot_pf_choix_title: "Numéro de lot du produit fini",
    lot_pf_choix_description:
      "Au démarrage de la production, un numéro de lot est attribué au produit fini. Vous pouvez en créer un nouveau, ou reproduire un lot déjà existant de ce produit (même numéro) — utile pour poursuivre une série ou un même lot de fabrication.",
    lot_pf_choix_new_title: "Créer un nouveau lot",
    lot_pf_choix_new_subtitle: "Un numéro de lot automatique sera généré.",
    lot_pf_choix_reproduce_title: "Reproduire un lot existant",
    lot_pf_choix_reproduce_subtitle:
      "Réutiliser le numéro d'un lot déjà produit pour ce produit fini.",
    lot_pf_choix_select: "Lot à reproduire",
    lot_heritier_title: "Héritage de lot",
    lot_heritier_description:
      "Une ligne de nomenclature requiert l'héritage d'un numéro de lot. Veuillez sélectionner le lot composant dont le numéro sera attribué au lot produit.",
    lot_heritier_empty: "Aucun lot disponible pour cet article.",
    lot_heritier_select: "Lot à hériter",
    lot_heritier_stock_positif: "Stock positif",
    lot_heritier_filter_adresse: "Adresse",
    lot_heritier_hide_dluo_depassee: "Masquer DDM/DLC dépassées",
  },
  pdc: {
    incomplete: "Pied de chaine incomplet",
    add_lot_cta:
      "Veuillez sélectionner le lot et la quantité à ajouter au pied de chaine",
    no_conso: "Aucune conso.",
  },
  cost: {
    create: "Création d'un coût",
    dateAlreadyExists: "Un coût est déjà existant pour cette date",
    edit: "Modification d'un coût",
    add: "Ajouter un coût",
    noCosts: "Aucun coût",
    title: "Suivi des coûts",
    locked: "Modifié",
    // Revalorisation (mai 2026)
    dialog_add_revalorisation: "Ajouter une revalorisation",
    dialog_edit_revalorisation: "Modifier la revalorisation",
    btn_add_revalorisation_tooltip: "Ajouter un nouveau coût daté pour ce lot (l'historique précédent reste intact)",
    btn_cascade_impact: "Voir les impacts cascade",
    btn_cascade_impact_tooltip: "Liste les lots et OFs qui utilisent ce lot — possibilité de relancer le recalcul manuellement",
    source: "Source",
    source_type_of: "OF",
    source_type_reception: "Réception",
    source_type_manuel: "Manuel",
    source_type_revalorisation: "Revalorisation",
    edit_origin_blocked: "Coût d'origine — à modifier via la source",
    delete_origin_blocked:
      "Suppression interdite : ce coût provient d'une source (OF / réception). Modifier ou supprimer la source pour le faire évoluer.",
    date_before_lot_creation: "La date ne peut pas être antérieure à la date de création du lot.",
    date_already_exists: "Un coût existe déjà pour cette date.",
    // Snacks contextuels (interpolation #source)
    warn_from_of_title: "Coût d'origine — calculé depuis l'OF #source",
    warn_from_of_action: "Pour ajuster ce coût d'origine, modifiez les consommations matière ou les temps de l'OF correspondant.",
    warn_from_reception_title: "Coût d'origine — issu de la commande fournisseur #source",
    warn_from_reception_action: "Pour ajuster ce coût d'origine, modifiez la commande fournisseur correspondante.",
    warn_alt_revalorisation: "Sinon, vous pouvez ajouter une revalorisation à une date ultérieure.",
    warn_no_source_label: "Ce coût a une origine système qui ne peut pas être modifiée directement. Vous pouvez ajouter une revalorisation à une date ultérieure.",
    btn_voir_of: "Voir l'OF",
    btn_voir_commande: "Voir la commande",
    // Dialog impacts cascade
    cascade_dialog_title: "Impacts cascade",
    cascade_loading: "Chargement…",
    cascade_error: "Impossible de charger les impacts pour ce lot.",
    cascade_empty: "Aucun élément aval. Ce lot n'est consommé nulle part — modifier son coût n'aura pas d'impact en cascade.",
    cascade_explanation: "Les éléments suivants utilisent ce lot dans leur chaîne de production. Une modification du coût se propage automatiquement à tous ces éléments. Le bouton ci-dessous permet de forcer le recalcul si vous avez corrigé une donnée source.",
    cascade_ofs: "Ordres de fabrication",
    cascade_lots: "Lots aval",
    cascade_open_of_tooltip: "Ouvrir l'OF",
    cascade_open_lot_tooltip: "Ouvrir le lot",
    cascade_trigger: "Lancer le recalcul cascade",
    cascade_triggered: "Recalcul cascade lancé — les éléments aval seront recalculés dans un instant.",
    cascade_trigger_error: "Échec du déclenchement du recalcul.",
    commentaire_label: "Commentaire",
    commentaire_placeholder: "Ex : ajustement après inventaire, correction prix matière flambée…",
    commentaire_hint: "Optionnel — sert à tracer la raison de la revalorisation pour les audits futurs",
  },
  vn: {
    search: "B12, Calcium...",
    add_cta: "Ajouter une constante",
  },
  entity: {
    articles: "Articles",
    administration: "Administration",
    group: "Société",
  },
  misc: {
    by: "par",
    from_right: "A partir des droits de",
    other: "Autres options",
    choice_scan: "Choix du mode de scan",
    use_camera: "Utiliser la caméra",
    deport_camera: "Déporter le scan",
  },
  adresse: {
    numero: "Numéro",
    numeroComplement: "Numéro complément",
    voie: "Voie",
    complement: "Complément de voie 1",
    complement2: "Complément de voie 2",
    cp: "Code postal",
    commune: "Commune",
    add_cta: "Ajouter une adresse",
    search: "Rechercher une adresse",
    pays: "Pays",
    livraisonDefaut:
      "Adresse de livraison par défaut pour les commandes fournisseur",
    disabled: "Désactivée",
    reactivate: "Réactiver",
    delai_expedition_jours_ouvres:
      "Délai logistique vers cette adresse (jours ouvrés)",
    delai_expedition_jours_ouvres_placeholder: "Ex : 2",
    delai_expedition_jours_ouvres_hint:
      "Surcharge le délai d'expédition par défaut paramétré au niveau de l'entreprise. Si vide, retombe sur la valeur d'entreprise.",
  },
  pass: {
    label: "Trousseau",
    choose_to_edit: "Choisir un trousseau",
    create: "Ajouter un trousseau",
    specifs: "Accès à la liste des articles et à la consultation des spécifs.",
    lignes: "Accès à la liste des lignes de prod. et leur édition",
    tiers: "Accès à la liste des tiers et leur édition",
    stocks: "Accès à la liste des stocks et leur édition",
    suivi_prod: "Accès au suivi de production",
    infos_journalieres: "Accès à la saisie des heures",
    prod: "Accès à la liste des OFs et leur édition",
    plannif_prod: "Accès à la plannification des productions",
    stats_prod: "Accès aux statistiques de production",
    commandes: "Accès à la liste commandes fournisseurs et leurs opérations",
    commandesClient: "Accès à la liste commandes clients et leurs opérations",
    redactionSpecif: "Peut rédiger des spécifications",
    validationSpecif: "Peut valider des spécifications",
    approbationSpecif: "Peut approuver des spécifications",
    section_modules: "Accès aux modules",
    section_other: "Autres droits",
    // Catégories de widgets
    widgets_section: "Droits par widget",
    cat_production: "Widgets production",
    cat_financier: "Widgets financier",
    cat_commandes: "Widgets commandes",
    cat_stock: "Widgets stock",
    cat_supervision: "Widgets supervision",
    cat_qualite: "Widgets qualité",
    cat_ligne: "Widgets ligne",
    cat_article: "Widgets article",
    cat_tiers: "Widgets tiers",
    cat_user_infos: "Widgets opérateur",
    // Production
    wProductiviteMoyenne: "Productivité moyenne",
    wOfEnCours: "OFs en cours",
    wHeuresTravailles: "Heures travaillées",
    wQuantiteOf: "Quantité d'OFs",
    wOfList: "Liste des OFs",
    wSpecificationList: "Liste des spécifications",
    wQuantiteProduitePeriode: "Quantité produite par période",
    // Financier
    wCaCumule: "CA cumulé",
    wCaParPeriode: "CA par période",
    wCaDelta: "CA delta",
    wCaNMoins1: "CA N-1",
    wRepartitionParClient: "Répartition par client",
    wCommandeFournisseurList: "Liste commandes fournisseur",
    wCommandeClientList: "Liste commandes client",
    wValeurParFamille: "Valeur par famille",
    // Stock
    wLotParEtat: "Lots par état",
    wEvolutionValeur: "Évolution valeur stock",
    // Supervision
    wPlanning: "Planning",
    wLiveProduction: "Production en direct",
    // Qualité
    wNcStats: "Statistiques NC",
    wNcClosureMetrics: "Métriques de clôture NC",
    wNcSupplierCompliance: "Conformité fournisseurs",
    wCertificatBioEcheance: "Certificats bio (échéance)",
    // Ligne
    wQuantiteProduiteLigne: "Quantité produite (ligne)",
    wMainOeuvreLigne: "Main d'œuvre (ligne)",
    wProductiviteLigne: "Productivité (ligne)",
    wCoutsLigne: "Coûts (ligne)",
    wOfsLigne: "OFs (ligne)",
    wArticlesProduitsLigne: "Articles produits (ligne)",
    // Article
    wConsosParArticle: "Consommations par article",
    wProductions: "Productions",
    wAchats: "Achats",
    wAchatsEvolution: "Évolution des achats",
    wVentes: "Ventes",
    wMarge: "Marge",
    wHeuresOfs: "Heures OFs",
    wCaPeriodeArticle: "CA par période (article)",
    wCaCumuleArticle: "CA cumulé (article)",
    wMouvementsArticles: "Mouvements articles",
    wStocksArticle: "Stocks article",
    wQuickWin: "Quick Win",
    // Tiers
    wAchatsEvolutionTiers: "Évolution achats (tiers)",
    wVenteEvolutionTiers: "Évolution ventes (tiers)",
    wCaCumuleTiers: "CA cumulé (tiers)",
    wCaParPeriodeTiers: "CA par période (tiers)",
    wMargeTiers: "Marge (tiers)",
    wAchatsTiers: "Achats (tiers)",
    wVentesTiers: "Ventes (tiers)",
    wCommandesTiers: "Commandes fournisseur (tiers)",
    wCommandesClientsTiers: "Commandes client (tiers)",
    // User Infos
    wHeuresUserInfos: "Heures (opérateur)",
    wRepartitionTravailUserInfos: "Répartition travail (opérateur)",
    wOfsUserInfos: "OFs (opérateur)",
    wProductiviteUserInfos: "Productivité (opérateur)",
    wLignesUserInfos: "Lignes (opérateur)",
    wArticlesProduitsUserInfos: "Articles produits (opérateur)",
    infoFinanciereOfLot: "Accès aux infos financières des OFs et Lots",
    factures: "Accès à la facturation",
    costImpact: "Accès à la simulation de coûts",
    viewCoutArbreContributeurs: "Voir les contributeurs nominatifs sur l'arbre des coûts",
    dossierProd: "Impression du dossier de production (Excel)",
    assistant: "Accès à l'assistant IA",
  },
  article_fourni: {
    list_title: "Tarifs négociés",
    sell: "Vente",
    buy: "Achat",
    buy_sell: "Tous",
    edit: "Modification d'un prix spécifique",
    create: "Création d'un prix spécifique",
    group: "Groupe",
    tiers: "Tiers",
    default: "Par défaut",
    link: "Lier le prix à un tiers ou un groupe",
    achetes: "Articles achetés",
    vendus: "Articles vendus",
    prices: "Prix",
    specific_articles: "Prix spécifiques articles",
    specific_default: "Prix de l'article",
    specific_link: "Prix liés à un tiers ou un groupe",
    add: "Ajouter un prix",
    no_specific_price: "Aucun prix spécifique paramétré pour ce tiers",
    show_prices: "Voir et éditer les prix",
    multiple_hint:
      "Multiple de saisie suggéré (ex: une palette complète). Si la quantité saisie n'en est pas un multiple, on proposera un arrondi. Laisser vide pour désactiver.",
    prix_par_tranche: "Prix par tranche",
    prix_fixe: "Prix fixe",
    apply: "Appliquer",
    type_prix_label: "Type de prix",
    type_prix_vente_hint:
      "Ce prix sera proposé lors de la création de commandes client",
    type_prix_achat_hint:
      "Ce prix sera proposé lors de la création de commandes fournisseur",
    link_label: "Appliquer ce prix à",
    link_default_hint:
      "Ce prix s'appliquera à tous les tiers (prix par défaut)",
    link_tiers_hint: "Ce prix ne s'appliquera qu'au tiers sélectionné",
    link_group_hint:
      "Ce prix s'appliquera à tous les tiers du groupe sélectionné",
    warning_prix:
      "Les paramètres du prix ont changé, voulez-vous appliquer les modifications ?",
    inherited_from: "Hérité de",
    inherited_placeholder: "Hérité : #value",
    inherited_prices: "Prix hérités (#level)",
    inherited_tooltip:
      "Ce champ n'est pas défini à ce niveau. La valeur « #value » est héritée du niveau #level. Laissez vide pour conserver l'héritage, ou saisissez une valeur pour surcharger.",
  },
  remise: {
    title: "Remise",
    add: "Ajouter une remise",
    edit: "Modification d'une remise",
    create: "Création d'une remise",
    tiers: "Tiers",
    group: "Groupe",
    list_title: "Remises",
    valeur: "Valeur",
    type: "Type de remise",
    date_debut: "Date de début",
    date_fin: "Date de fin",
    article: "Article",
    link: "Lier la remise à un tiers ou un groupe",
    default: "Par défaut",
    sans_limite: "Sans limite",
    periode: "Période",
    remises_appliquees: "Remises",
    ajouter_manuelle: "Remise manuelle",
    total_avant_remise: "Total avant remise",
    total_apres_remise: "Total après remise",
    montant_remise: "Montant remise",
    warning_remise: "Des remises disponibles ont changé",
    missing_remise: "Toutes les remises pour ce client ne sont pas appliquées",
    appliquer_remises: "Appliquer les remises",
    pourcentage: "Pourcentage",
    montant_fixe: "Montant fixe",
    manuelle: "Manuelle",
    ajouter_liee: "Remise liée à l'article",
    ajouter: "Ajouter",
    ajouter_remise: "Ajouter une remise",
    creer_liee: "Créer une remise liée",
    creer_tiers: "Remise tiers",
    creer_groupe: "Remise groupe",
    creer_liee_hint:
      "Crée une remise persistante liée au tiers ou groupe du client",
    disponibles: "Remises disponibles",
    appliquees: "Remises appliquées",
    ajouter_manuelle_cta: "Ajouter une remise manuelle",
    manuelle_hint: "Remise non persistée pour les commandes futures",
    montant_unitaire: "€/unité",
    remises: "Remises",
    aucune_remise: "Aucune remise",
    label: "Libellé",
    label_placeholder: "Ex: Remise fidélité, Promotion...",
    label_hint: "Description optionnelle affichée sur les documents",
    existing_group: "Remises existantes pour ce groupe",
    tous_articles: "Tous articles",
    new: "Nouvelle remise",
    sous_total_avant: "Sous-total avant remises",
    total_remises: "Total remises",
    type_label: {
      valeur_pct: "Valeur (%)",
      valeur_unitaire: "Montant par unité (€/u)",
      valeur_montant: "Montant fixe (€)",
      pourcentage_hint: "Ex : 10 pour une remise de 10%",
      montant_unitaire_hint: "Ex : 0.50 pour 0.50 € par unité commandée",
      montant_hint:
        "Ex : 50 pour une remise globale de 50 € (pied de commande)",
      montant_context: "Montant fixe (€) — pied commande/facture",
    },
  },
  contact: {
    contactOf: "Contacts de ",
    add_cta: "Ajouter un contact",
    emailConfirmationCommandeClient:
      "Destinataire lors d'une confirmation de commande client",
    emailBonCommandeFournisseur:
      "Destinataire pour bons de commande fournisseur",
  },
  infoPrix: {
    add_cta: "Ajouter un prix",
    create_cta: "Créer une grille tarifaire",
    prix_maison: "Il s'agit des prix de base de l'article en question",
  },
  calendar: {
    add_cta: "Créer un planning",
    nameless: "Planning sans nom",
  },
  calendar_event: {
    add_cta: "Ajouter un créneau",
  },
  article: {
    qty_in: "Quantité de l'article en",
    actions: "Actions sur l'article",
    select_new: "Sélectionner un article",
    showAll: "Afficher tous les articles",
    toolbox: "Actions rapides",
    rescan: "Scanner un nouvel article",
    scan_no_corresponding_article: "Aucun article correspondant n'a été trouvé",
    make_fiche: "Générer une étiquette logistique",
    bio: "Article BIO",
    ddmAsNumeroDeLot: "Utiliser la date limite pour le numéro de lot",
    ddmAsNumeroDeLot_hint:
      "À la création d'un lot en production (OF), le numéro est généré automatiquement à partir de la date limite formatée (ex : 311226 pour le 31/12/2026 si format JJ/MM/AA). Utile pour les produits où la date sert naturellement d'identifiant lot. Sinon, le numéro est un compteur séquentiel.",
    vn: "Valeurs nutritionnelles",
    add: "Ajouter un article",
    goToArticle: "Naviguer vers l'article",
    nbUnitePerPack: "Nombre d'unité par colis",
    uniteComptage: "Unité de comptage",
    coefficientComptage: "Coefficient de comptage",
    valeurUnitaire: "Valeur unitaire par défaut",
    quantiteParDimension: "Quantité par dimension",
    weight_suremballage: "Poids surremballage",
    refCalcul: "Référence calcul quantité",
    typeComptage: "Type de calcul",
    tailleEchantillon: "Taille échantillon inventaire",
    secable: "Produit sécable",
    new: "Nouvel article",
    code_auto: "Assignation automatique de la référence",
    ean_title: "Code-barres",
    ddm_title: "Dates limites",
    desc_title: "Descriptions",
    param_title: "Paramètres",
    details_title: "Caractéristiques",
    ean13_auto: "EAN13 automatique",
    ean14_auto: "EAN14 automatique",
    duplication: "Dupliquer un article existant",
    photo: "Photo de l'article",
    etiquette: "Etiquette de l'article",
    details: "Détails",
    article: "Article",
    add_label: "Ajout d'un article",
    add_cta: "Ajouter un article",
    associate_cta: "Associer l'EAN13/14 à un article supplémentaire",
    associate_cta_code: "Créer un article avec cette référence",
    edit_label: "Modification d'un article",
    search: "Dénomination ou code d'un article",
    search_add: "Rechercher ou ajouter un article",
    isPrestation: "Prestation de service pure",
    is_alimentaire: "Article alimentaire",
    with_stock: "Article géré en stock",
    withStockPositif: "Assurer un stock disponible pour les mouvements",
    withParallelOpe:
      "Possibilité de réaliser plusieurs opérations de fabrication simultanées",
    with_traca:
      "Traçabilité obligatoire lors des productions, lorsqu'utilisé en composant",
    with_lot: "Détail des quantités en stock pour chaque lot",
    with_lot_unique_warning:
      "Pour cet article, le lot unique a été selectionné par défaut",
    info_gestion_conso:
      "Veuillez sélectionner un mode de consommation lorsque cet article est utilisé en tant que composant:",
    with_pdc:
      "Saisie obligatoire des consommations avec mise à disposition dans le stock de composants de l'OF",
    with_conso_theoric: "Consommation théorique",
    with_conso_volee:
      "Saisie facultative des consommations (sera en consommation théorique si aucune consommation déclarée)",
    with_specif: "Article fabriqué",
    archived: "Article archivé",
    with_emplacement: "Avec emplacement en stock",
    isAchete: "Article achetable",
    isVendu: "Article vendable",
    withValeursNutritionnelles: "Article avec valeurs nutritionnelles",
    stock: "Stock de l'article",
    info_generales: "Infos générales",
    process: "Process",
    nomenclature: "Nomenclature de l'article",
    controles: "Contrôles",
    duplicate: "Dupliquer un article existant",
    model: "Spécification de l'article",
    missing_current_version: "En rédaction",
    select: "Sélectionner un article",
    select_for_traca: "Sélectionner un article pour afficher sa traçabilité",
    type_article: "Type d'article",
    type_article_sub:
      "Optionnel, ne rien sélectionner pour un composant standard",
    article_fabrique: "Article fabriqué",
    article_fabrique_sub: "Produit fini ou semi-fini",
    permet_creation_of:
      "Permet la création d'ordres de fabrication pour cet article",
    prestation_title: "Prestation",
    prestation_sub: "Service sans stock physique",
    pas_gestion_stock: "Pas de gestion de stock",
    facturable_service: "Facturable en tant que service",
    type_periode: "Type de periode",
    format_date: "Format de date",
    format_date_dlc_jour_obligatoire:
      "Une DLC doit être au jour près (obligation légale).",
    type_date_limite_label: "Type de date limite",
    duree_conservation: "Durée",
    type_date_limite: {
      ddm: "DDM — qualité (avertissement)",
      dlc: "DLC — sanitaire (blocage)",
      aucune: "Aucune (produit non périssable)",
      ddm_hint:
        "Date de Durabilité Minimale : après dépassement, qualité dégradée mais consommation possible.",
      dlc_warning:
        "DLC : blocage légal après dépassement (R. 412-21 Code Conso). Durée à justifier scientifiquement.",
      aucune_hint:
        "Pour les produits non périssables (visserie, emballage, fournitures…).",
      bascule_confirm_title: "Changer le type de date limite ?",
      bascule_confirm_message:
        "Vous passez cet article de #ancien à #nouveau.\n\nLes lots déjà en stock restent classés #ancien (cohérence audit IFS — un lot étiqueté physiquement ne peut pas être requalifié rétroactivement). Seuls les nouveaux lots créés à partir de maintenant seront traités comme #nouveau.\n\nConfirmer le changement ?",
    },
    dlc_format_auto_bascule:
      "Format basculé sur JJ/MM/AAAA — la DLC doit s'afficher au jour près.",
    mode_gestion_stock: "Mode de gestion du stock",
    stock_global: "Stock global",
    stock_global_sub: "Un compteur unique pour cet article",
    stock_lot_unique: "Stock géré dans un lot unique",
    lots_enregistres: "Numéros de lots fournisseurs/fabriqués enregistrés",
    traca_amont_aval: "Traçabilité amont/aval disponible",
    suivi_lot_par_lot: "Suivi lot par lot",
    suivi_lot_par_lot_sub: "Un stock distinct pour chaque lot",
    stock_lot_par_lot: "Stock géré lot par lot",
    conso_lot_par_lot: "Consommations lot par lot obligatoires",
    composant_titre: "Quand cet article est utilisé comme composant",
    traca_composant: "Traçabilité composant",
    impose_lots_conso: "Impose de déclarer les lots consommés",
    mode_consommation: "Mode de consommation",
    theorique_title: "Théorique",
    theorique_sub:
      "Consommation calculée automatiquement selon la nomenclature. Aucune saisie requise.",
    declaration_consos: "Déclaration des consommations",
    declaration_consos_sub:
      "L'opérateur déclare les quantités et lots consommés à chaque étape de fabrication.",
    suivi_precis_consos: "Suivi précis des consommations",
    suivi_precis_consos_sub:
      "Calcul par différence de stock : les matières sont transférées au pied de chaîne avant production, puis un inventaire en fin d'OF détermine la consommation réelle.\nIdéal pour détecter les pertes et écarts de rendement.",
    pour_100ml: "Pour 100 ml",
    pour_100g: "Pour 100 g",
    unite_bis: "Unité bis",
    unite_bis_placeholder: "Le sachet de 20g",
    constante: "Constante",
    teneur: "Teneur",
    donnees_article: "Données article",
    donnees_inventaire: "Données inventaire",
    photos_articles: "Photos articles",
    telecharger_modele: "Télécharger le modèle",
    generer_ean13: "Générer un EAN13",
    importation_partielle: "Importation partielles de données",
    selectionner_infos: "Sélectionner les infos",
    a_importer: "à importer",
    info_vn:
      "Afin de pouvoir saisir les valeurs nutritionnelles, veuillez renseigner les informations suivantes",
    diametre_mandrin: "Diamètre extérieur du mandrin",
    diametre_rouleau: "Diamètre d'un rouleau complet",
    epaisseur_produit: "Epaisseur du produit",
    laize: "Laize",
    non_suivi: "Non suivi",
    non_suivi_stock: "Article non suivi en stock",
    qte_unitaire: "Qté unitaire",
    informations_generales: "Informations générales",
    jours: "Jour(s)",
    mois_label: "Mois",
    annees: "Année(s)",
    impose_suivi_precis: "Impose le mode Suivi précis des consommations",
    mouvements_bloques:
      "Les mouvements sont bloqués si le stock est insuffisant",
    stocks_negatifs: "Les stocks négatifs sont autorisés (ex: -5000 kg)",
    mode_incompatible_lot:
      'Mode incompatible avec la traçabilité lot par lot. Choisissez "Déclaration" ou "Suivi précis (PDC)".',
    declarations_modifiables:
      "Les déclarations de consommations restent modifiables après clôture dans les stats OF",
    coefficient: "Coefficient",
    inventaire_heading: "Inventaire",
    prix_catalogue: "Prix catalogue par défaut",
    prix_vente_defaut: "Prix de vente par défaut",
    prix_achat_defaut: "Prix d'achat par défaut",
    prix_catalogue_subtitle:
      "Ces paliers de prix sont utilisés comme valeurs par défaut pour les commandes (client et fournisseur) lorsqu'aucun prix spécifique n'est défini pour un tiers.",
    ajouter_palier_vente: "Ajouter un palier vente",
    ajouter_palier_achat: "Ajouter un palier achat",
    logistique_heading: "Logistique",
    logistique_uc: "Unité de gestion",
    logistique_colis: "Colis",
    edit_weight_title: "Poids de l'article",
    edit_weight_main: "Poids brut par unité de gestion",
    edit_weight_main_subtitle:
      "Poids brut d'une unité de gestion (emballage inclus). Sert au calcul du poids logistique sur les BL et fiches d'expédition. Ne pas inclure le poids de l'unité d'expédition (palette, carton…).",
    edit_weight_more: "Plus de paramètres",
    enter_weight: "Saisir le poids brut / UG",
    stock_heading: "Stock",
    donc_1_colis: "Donc 1 colis =",
    donc: "Donc",
    comptage_simple_en: "Comptage simple en",
    etats: "États",
    infos: "Informations commerciales",
    denominationCommerciale: "Dénomination commerciale",
    tva: "TVA",
  },
  traca: {
    title_graph: "Visualisation de la traçabilité",
    lastUpdate: "Mis à jour le",
    why_no_graph:
      "Le graphique de traçabilité n'est pas encore disponible. Il sera visible quand le pied de chaine sera réintégré",
    go_graph_of:
      "Pour visualiser la traçabilité de ce lot veuillez vous rendre sur la page de l'OF correspondant",
  },
  nomenclature: {
    title: "Quantités nécessaires pour la fabrication d'une unité",
    empty: "Aucun article dans la nomenclature",
    add: "Ajouter un article",
    add_ligne: "Ajouter un article à la nomenclature",
    edit_ligne: "Edition de nomenclature",
    select_article: "Sélectionner un article",
    select_article_default: "Sélectionner un article par défaut",
    articleDynamic: "Article paramétrable",
    paramDynamic: "Quantité paramétrable",
    optional: "Optionnel",
    do: "Article utilisé",
    dontDo: "Article non utilisé",
    noNomenclature: "Aucun article dans la nomenclature",
    qttUndefined: "Quantité non définie",
    qttUnitaire: "Soit #qtt pour 1",
    perte_normale: "Perte normale",
    perte_maximale: "Perte maximale",
    lotHeritier: "Héritage de lot",
    lotHeritier_tooltip:
      "Au démarrage de l'OF, le numéro de lot du produit fabriqué reprendra automatiquement celui du lot sélectionné pour cet article composant.",
  },
  variable: {
    add_cta: "Ajouter un paramètre",
    edit_cta: "Editer un paramètre",
    name: "Nom du paramètre",
    type: "Type de paramètre",
    payload_default: "Valeur par défaut",
    reset_default: "Réinitialiser",
    payload: "Valeur",
    dontDo: "Ne pas réaliser",
    missing_warning:
      "Des paramètres sont manquantes, veuillez modifier la spécification",
  },
  ij: {
    add_travail: "Ajouter une saisie",
    all_hours_completed: "Toutes les heures ont été saisies",
    hours_mismatch:
      "Les heures payées et les heures saisies ne correspondent pas",
    hour_entry_for: "Saisie d'heure sur",
    type_of: "OF",
    type_conges: "Congés",
    type_rtt: "RTT",
    type_maladie: "Maladie",
    type_autres: "Autres",
    entry_type: "Type de saisie",
    deletion_title: "Suppression",
    deletion_confirm:
      "Vous êtes sur le point de supprimer les heures saisies. Ceci impactera potentiellement des rapports de productivité de différents OF. Confirmez-vous ?",
    unknown_operator: "Opérateur inconnu",
  },
  stock_article: {
    securite: "Stock de sécurité",
    maximum: "Stock maximum",
    reappro: "Seuil de réapprovisionnement",
  },
  inventaires: {
    show_pdc: "Voir les pieds de chaine qui contiennent cet article",
    raz_entrepot: "Remettre à 0",
    total_entrepot: "Stock total après inventaire de l'entrepot",
    par_entrepot: "par entrepôt",
    label: "Inventaire",
    add_cta: "Ajouter un inventaire",
    add_comptage: "Ajouter un comptage",
    total: "Total inventorié",
    search_associate: "Rechercher un article à associer",
    cloture: "Clôture de l'inventaire",
    confirm_raz:
      "Les quantités saisies remplaceront tout le stock de cet article.\n" +
      "Tous les lots et adresses non saisis seront remis à 0.\n" +
      "Voulez-vous continuer ?",
    confirm_only_those:
      "Seuls les stocks des lots saisis à leurs adresses seront mis à jour.\n" +
      "Tous les autres lots et adresses resteront inchangés.\n" +
      "Voulez-vous continuer ?",
    inventaire_confirm_raz:
      "Les quantités saisies remplaceront tout le stock.\n" +
      "Tous les lots et adresses non saisis seront remis à 0.\n" +
      "Voulez-vous continuer ?",
    inventaire_confirm_only_those:
      "Seuls les stocks des lots saisis à leurs adresses seront mis à jour.\n" +
      "Tous les autres lots et adresses resteront inchangés.\n" +
      "Voulez-vous continuer ?",
    with_lot: "Inventaire lot par lot",
    with_lot_desc:
      "Le comptage se fait par entrepôt et par lot. Le stock résultant sera exactement celui affiché sur cet écran.",
    with_lot_unique: "Inventaire global",
    with_lot_unique_desc:
      "L'article est inventorié au global pour chaque entrepôt. Le stock ira dans le lot unique de l'article. Le stock résultant sera exactement celui affiché sur cet écran.",
    supervision_parametres: "Supervision et paramètres",
    telecharger_csv: "Télécharger le CSV",
    stock_theorique: "Stock avant inventaire",
    stock_physique: "Stock après inventaire",
    ecart: "Écart",
    entrepots_comptes: "Entrepôts comptés",
    recap_title: "Récapitulatif de l'inventaire",
    recap_confirm: "Confirmer l'inventaire",
    confirm_raz_detail:
      "Le stock de chaque entrepôt sera remplacé par les quantités saisies. Les entrepôts non comptés seront mis à zéro.",
    inventaire_success: "Inventaire enregistré avec succès",
    comptage_adresse: "Comptage — #name",
    resultat_comptage: "Résultat",
    scroll_to_save: "Enregistrer",
    scan_inventory_title: "Inventaire scan — #name",
    scan_select_adresse: "Sélectionnez un entrepôt",
    scan_start: "Démarrer",
    scan_remote: "Scanner distant",
    scan_camera: "Caméra",
    scan_entrepot: "Scanner",
    scan_inventaire_cta: "Inventaire scan",
    go_to_count: "Compter",
    add_to_session: "Ajouter au comptage",
    session_counted: "Inventaire actuel",
    finish_session: "Terminer",
    close_dirty_title: "Attention",
    close_dirty_message:
      "Vous avez des comptages non sauvegardés, voulez-vous vraiment quitter ?",
    close_dirty_stay: "Rester",
    close_dirty_leave: "Quitter",
    scan_hint: "Scannez un code-barres pour identifier l'article",
    scan_manual_select: "Ou sélectionnez un article",
    scan_lot_auto: "Article et lot identifiés",
    scan_article_found: "Article identifié — sélectionnez le lot",
    scan_not_found: "Article non trouvé",
    scan_ean_mismatch: "Ce code-barres ne correspond pas à cet article",
    scan_no_ean_on_article: "Cet article n'a pas d'EAN associé",
    scan_associate_ean: "Associer cet EAN à l'article",
    scan_or_select_lot: "Ou sélectionnez un lot",
    scan_hint_lot: "Scannez un code-barres pour identifier le lot",
    edit_mouvement_title: "Modifier la quantité",
    add_incomplete_pack: "Ajouter un colis incomplet",
    add_incomplete_roll: "Ajouter un rouleau incomplet",
    add_measurement: "Ajouter une saisie",
    incomplete: "Incomplet",
    sample: "Échantillon",
    measurement: "Saisie",
    total_prefix: "Soit un total de",
    total_gross: "Mesure totale brute",
    total_net: "Mesure totale nette",
    total_count: "Soit un compte de",
    therefore: "Donc",
  },
  stock: {
    show_null_stock: "Afficher les lots à 0",
    createEmplacement: "Créer un nouvel emplacement",
    no_reinte: "Sans réintégration",
    total: "Stock total",
    label: "Stock",
    zoneExpedition: "Zone d'expédition",
    zoneNonConforme: "Zone non conforme",
    zoneQuarantaine: "Zone quarantaine",
    enDechargement: "En déchargement",
    enDechargementInfo:
      "#nb déchargement(s) en cours — non inclus dans le stock total. Réalisez la réception pour intégrer au stock.",
  },
  tiers: {
    tiers: "Tiers",
    reference: "Référence",
    reference_hint: "Laissez vide pour une attribution automatique",
    reference_format_error:
      "Seuls les lettres et les chiffres sont acceptés (sans espace ni caractère spécial)",
    search: "Propriétaire de l'article (si article possédé par un tiers)",
    add_label: "Ajout d'un tiers",
    add_cta: "Ajouter un tiers",
    edit_label: "Modification du tiers",
    abattement: "Abattement",
    page: "Fiche tiers",
    update_price: "Modifier le prix",
    update_mail: "Mettre à jour l'adresse du tiers",
    appartient: "Appartient à un tiers",
    default: "Défaut",
    tier_group: "Groupe",
    tier_groups: "Groupes",
    show_groups: "Voir les groupes",
    add_group: "Ajouter un groupe",
    edit_group: "Modifier un groupe",
    group_disabled: "Désactivé",
    avecArticlesVendus: "Tiers avec infos d'articles vendus",
    avecArticlesAchetes: "Tiers avec infos d'articles achetés",
    all: "Tous",
    showAll: "Voir tous",
    aucun_groupe: "Aucun groupe",
    est_transporteur: "Est un transporteur",
    rib_paiement_default: "RIB de paiement par défaut",
    rib_paiement_aide:
      "Ce RIB sera automatiquement affecté aux factures client créées pour ce tiers. Il restera modifiable depuis chaque facture.",
    code_label: "Référence",
    code_placeholder: "Ex: T2600042 — laissez vide pour auto-générer",
    code_hint:
      "Lettres et chiffres uniquement (A-Z, 0-9). Auto-générée si laissée vide.",
    code_invalid:
      "Seuls les caractères A-Z et 0-9 sont acceptés (pas d'espaces ni de caractères spéciaux).",
    code_copy: "Copier la référence",
    code_copied: "Référence copiée dans le presse-papiers",
  },
  inventaire: {
    associate: "Associer à un article existant",
    new_article: "Créer un nouvel article",
  },
  mail: {
    visualize_bon_commande: "Visualiser le bon de commande joint au mail",
  },
  document_list: {
    add_cta: "Ajouter un commentaire",
    edit_cta: "Editer un commentaire",
    add_doc: "Ajouter un document",
    new_doc: "Nouveau document",
    edit_doc: "Editer un document",
    element_deleted: "Élément supprimé",
    element_saved: "Enregistré",
    fullwidth_large: "Taille du document: grand",
    fullwidth_small: "Taille du document: petit",
    big_drop_title: "Glissez vos fichiers ici",
    big_drop_subtitle: "ou utilisez les boutons ci-dessous",
    big_browse: "Parcourir les fichiers",
  },
  dechargement: {
    pas_de_bl: "Pas de BL",
    hint_bl:
      "Scannez ou importez le bon de livraison, puis renseignez son numéro. Si vous n'avez pas de BL, passez à l'étape suivante.",
    hint_generaux:
      "Réalisez les contrôles qualité obligatoires liés à ce déchargement avant de saisir les quantités reçues.",
    hint_produits:
      "Saisissez les quantités reçues pour chaque article et réalisez les contrôles qualité associés.",
    previous: "Précédent",
    next: "Suivant",
    save_draft: "Enregistrer en brouillon",
    finalize: "Enregistrer le déchargement",
    edit: "Modifier",
    save_changes: "Enregistrer les modifications",
    articles_title: "Articles à décharger",
    fill_from_commande: "Quantités conformes à la commande",
    fill_conforme: "Quantités conformes",
    no_controles: "Pas de contrôles",
    controles: "Contrôles",
    in_progress: "En cours",
    ctrl_none: "Aucun contrôle",
    ctrl_todo: "Contrôles à réaliser",
    ctrl_in_progress: "Contrôles en cours",
    ctrl_ok: "Contrôles OK",
    ctrl_nc: "NC détectée(s)",
    docs_title: "Commentaires & documents :",
    docs_add: "Ajouter un commentaire ou un document",
    qty_ordered: "Commandé :",
    qty_already: "Déjà déchargé :",
    qty_unloaded: "Déchargé :",
    qty_remaining: "Restant :",
    label: "Déchargement",
    bl_prefix: "BL :",
    new_dechargement: "+ Déchargement",
    add_dechargement: "Ajouter un déchargement",
    etat_termine: "Terminé",
    etat_en_cours: "En cours",
    etat_reception_en_cours: "Réception en cours",
    n_articles: "articles",
    last_dech: "dernier déch. :",
    n_dech: "déch.",
    n_ref: "réf.",
    sort_newest: "Plus récent",
    sort_oldest: "Plus ancien",
    filter_in_progress: "En cours",
    filter_finished: "Terminés",
    filter_all: "Tous",
    snack_created: "Déchargement #numero créé",
    snack_created_hint: "Vous pouvez maintenant saisir les réceptions correspondantes.",
    snack_updated: "Déchargement #numero enregistré",
    snack_view: "Voir le déchargement",
    quit_title: "Quitter le déchargement",
    quit_message: "Les informations saisies n'ont pas été enregistrées et seront perdues.",
    quit_confirm: "Quitter sans enregistrer",
    quit_cancel: "Rester sur le déchargement",
    partial_delivery_title: "Livraison partielle",
    partial_delivery_message: "Les articles suivants n'ont pas de quantité renseignée :",
    partial_delivery_confirm: "Valider sans ces articles",
    delete_title: "Supprimer le déchargement",
    delete_message: "Le déchargement et toutes ses réceptions seront supprimés. Les mouvements de stock associés seront annulés. Confirmez-vous ?",
    warn_qty_inferior_title: "Attention — quantités inférieures aux réceptions",
    warn_qty_confirm: "J'ai compris, enregistrer",
    error_no_quantity: "Saisissez au moins une quantité pour finaliser le déchargement",
    controles_incomplete_title: "Contrôles incomplets",
    finalize_anyway: "Finaliser malgré tout",
    nc_detected_title: "Non-conformités détectées",
    nc_confirm: "Valider malgré les NC",
    back_to_form: "Revenir à la saisie",
    no_bl_title: "Aucun numéro de BL",
    no_bl_message: "Aucun numéro de bon de livraison n'a été renseigné. Voulez-vous continuer sans BL ?",
    no_bl_confirm: "Continuer sans BL",
    no_bl_cancel: "Renseigner un BL",
    save_and_continue: "Enregistrer et continuer",
    save_and_quit: "Enregistrer et quitter",
    step_bl: "Bon de livraison",
    step_generaux: "Contrôles généraux",
    step_produits: "Produits reçus",
    pod_nothing_done: "Rien de réalisé",
    pod_all_ok: "Tout est conforme",
    error_bl_required: "Renseignez un numéro de BL ou cliquez sur Pas de BL",
    error_generaux_required: "Réalisez tous les contrôles généraux avant de continuer",
  },
  reception: {
    qty_already: "Déjà réceptionné :",
    qty_remaining: "Reste à réceptionner :",
    qty_received: "Réceptionné :",
    add_lot: "Ajouter un lot",
    print_id_sheet: "Imprimer la fiche d'identification",
    edit_notice: "Modification d'une réception enregistrée. Les quantités et le lot seront corrigés, un mouvement de stock correctif sera généré automatiquement.",
    dechargement_nc_warning: "Les contrôles du déchargement sont non conformes",
    lot_required: "Le numéro de lot fournisseur est obligatoire pour cet article",
    controles_required: "Les contrôles qualité doivent être complétés avant l'enregistrement",
    incomplete: "Renseignez une quantité supérieure à 0",
    saved: "Réception enregistrée",
    deleted: "Réception supprimée",
    delete_title: "Supprimer cette réception",
    delete_message: "Les mouvements de stock associés seront annulés. Confirmez-vous la suppression ?",
    nc_title: "Contrôles non conformes",
    nc_message: "Des contrôles de réception sont non conformes. Voulez-vous déclarer les produits en non-conforme ?",
    nc_declare: "Déclarer non conforme",
    nc_correct: "Corriger la quantité",
    save_next: "Suivant",
    finalize_and_receive: "Réceptionner",
    tout_conforme: "Conforme",
    renseigner_lot: "Renseigner un lot",
    all_done: "Tous les articles ont été réceptionnés",
    label: "Réception",
    auto: "Auto",
    ddm_prefix: "DDM",
    new_reception: "Réception",
    pending_count: "réception(s) en attente",
    in_progress_count: "réception(s) en cours",
    done_count: "réceptionné(s)",
    received: "Réceptionné",
    to_receive: "À réceptionner",
    change_lot_title: "Changer le lot fournisseur",
    change_lot_confirm: "Changer le lot",
    controles_incomplete_title: "Contrôles incomplets",
    save_anyway: "Enregistrer quand même",
    back_to_form: "Revenir à la saisie",
    fiche_palette: "Fiche palette",
  },
  ligne: {
    add_label: "Ajout d'une ligne de prod.",
    add_cta: "Ajouter une ligne de prod.",
    edit_label: "Modification de la ligne de prod.",
    plannification: "Planification pour la ligne",
    plannification_select: "Choisir une ligne à planifier",
    search: "Ligne de prod.",
    nbOF: "Nombre maximum d'OF en parallèle",
    missing_param_ligne1: "Aucune ligne avec le nom: ",
    missing_param_ligne2: "n'a été paramétré pour la famille technique:",
    show_lignes: "Voir les lignes",
  },
  csv: {
    import: "Importer CSV",
    import_article_fourni: "Importer CSV pour les articles fournis",
  },
  cascade: {
    processing: "Recalcul en cours",
    uptodate: "Infos à jour",
    refresh: "Mettre à jour",
  },
  custom_enum: {
    add_option: "Ajouter une option",
    add_default: "Ajouter : #label",
  },
  taxRate: {
    title: "Taux de TVA",
    add: "Ajouter un taux",
    denomination: "Dénomination",
    rate: "Taux (%)",
    default: "Par défaut",
  },
  list: {
    empty: "Aucun élément",
    creer_liste: "Créer une liste",
    dupliquer: "Dupliquer",
    lignes_concernees: "Lignes concernées",
    ajouter_tache: "Ajouter une tâche",
  },
  ordering: {
    valid: "Valider l'ordre",
  },
  process: {
    article: "Procédés de l'article",
    articleSub:
      "Dans une production, les procédés de l'article seront à réaliser à la suite des procédés de la spécification",
    optional: "Procédé optionnel",
    do: "Réaliser le procédé",
    dontDo: "Ne pas réaliser le procédé",
    add_label: "Ajout d'un procédé",
    add_cta: "Ajouter un procédé",
    edit_label: "Modification du procédé",
    noProcess: "Aucun procédé",
    from_template: "Créer à partir d'un modèle",
    from_prompt_ai: "Créer à l'aide de l'IA",
    edit_mode_prompt_ai: "Modifier à l'aide de l'IA",
    edit_prompt_ai: "Editer les instruction à l'IA",
    exclude_lines: "Lignes exclues",
    timer: "Minuteur",
    minute: "minute(s)",
    second: "seconde(s)",
    exclude_lines_exp:
      "Sélectionnez les lignes de production pour lesquelles l'étape n'est pas à effectuer. (L'étape n'apparaîtra pas lors des productions effectuées sur les lignes sélectionnées.)",
  },
  processCopy: {
    quickCreate: "Création rapide",
    processModel: "Modèles de procédé",
    searchSpecif: "Rechercher dans les spécifications",
    processIncorporation: "Incorporation d'article",
    variableUsage: "utilisation",
    variableUsages: "utilisations",
    in: "dans",
    context: "contexte",
    contexts: "contextes",
    control: "Contrôle",
    processDescription: "Déscription du procédé",
    articleRef: "Article de nomenclature",
    articleVarRef: "Article paramétrable de nomenclature",
    varRef: "Variable",
    warn1:
      "Le procédé contient des référence a des variables ou des articles de nomenclature.",
    warn2:
      "Veuillez remplacer les éléments trouvé par des éléments de votre spécification.",
  },
  checklist: {
    all: "Voir toutes les listes",
    who: "Utilisateurs",
    frequence: "Fréquence",
    add_label: "Ajout d'une checklist",
    edit_label: "Modification de la checklist",
    tolerancePlusMois: "Tolérance future (en heures)",
    toleranceMoinsMois: "Tolérance passée (en heures)",
    tolerancePlusSemaine: "Tolérance future (en jours)",
    toleranceMoinsSemaine: "Tolérance passée (en jours)",
    tolerancePlusJours: "Tolérance future (en minutes)",
    toleranceMoinsJours: "Tolérance passée (en minutes)",
    deleted_suffix: "(supprimée)",
    step_of_ope: "Sélection de l'OF et de l'opé.",
    step_of: "Sélection de l'OF",
    step_ope: "Sélection de l'Opé.",
    step_controles_of: "Contrôles liés à l'OF",
    step_controles: "Contrôles",
    controle_saved: "Contrôle sauvegardé",
  },
  form: {
    select: "Sélectionner...",
    invalid: "Le formulaire n'est pas valide",
    multiCheckbox: {
      removeAll: "Efacer la sélection",
      select: "Sélectionner",
      selectLigne: "Ligne(s)",
      selectFamille: "Famille(s)",
      selectCategorie: "Sous-famille(s)",
    },
    minZero: "Doit être >= 0",
    validators: {
      required: "Ce champ est obligatoire.",
      minlength: "Ce champ ne peut comporter moins de #min caractères",
      maxlength: "Ce champ ne peut comporter plus de #max caractères",
      year: "L'année est invalide",
      range: "Les intervalles d'émission de CO2 se chevauchent",
      rangeLigne: "L'intervalle d'émission de CO2 est invalide",
      min: "Ce champ doit être supérieur ou égal à ",
      max: "Ce champ doit être inférieur ou égal à ",
      length: "Ce doit être #size #type",
      exactLength: "Ce champ doit comporter #exactLength caractères",
      email: "L'adresse email est invalide",
      adresse: {
        cityPattern: "Ce n'est pas le nom d'une ville",
      },
      min_quantite: "Ce champ doit être supérieur au minimum",
      stockSecuriteMax:
        "Le stock de sécurité ne peut pas être supérieur au stock de réappro.",
    },
  },

  filters: {
    label: "Filtres",
    no_data: "Aucune donnée sur la période / filtres.",
    reset: "Réinitialiser les filtres",
  },
  tracabilite: {
    lot_unique_display:
      "Attention : le stock de cet article n’étant pas suivi par lot, le graphique ci-dessous est construit uniquement à partir des traçabilités saisies sur les différents OF liés à ce lot. Il donne une vue des liens entre lots et OF, mais ne reflète pas précisément les mouvements réels de consommation ni les quantités exactes utilisées.",
    tips_form:
      "Vous pouvez sélectionner dès maintenant l’article dont vous souhaitez assurer la traçabilité.\n" +
      "\n" +
      "Si vous choisissez un article ici : il sera automatiquement utilisé lors de la saisie de la traçabilité.\n" +
      "\n" +
      "Si vous ne sélectionnez rien : vous devrez choisir l’article à tracer au moment de la saisie.\n" +
      "\n" +
      "👉 Cela vous laisse la flexibilité d’anticiper votre choix ou de le faire plus tard, selon vos besoins.",
  },
  planifComposant: {
    composants: "Composants",
    stockActuel: "Stock à date",
    avecProvisoire: "Avec commandes provisoires",
    weekEvents: "Événements de la semaine",
    dayEvents: "Événements du jour",
    commandes: "Commandes",
    commandesProvisoires: "Commandes provisoires",
    missingSeuil: "Seuil(s) non renseignés",
    displayModeFlux: "Mode d'affichage en flux",
    displayModeChart: "Mode d'affichage en graphique",
    editStock: "Editer les paramètres de stock",
    showStock: "Voir les stocks",
    createCommande: "Commander",
    showCommandes: "Voir les commandes",
    articlesWithStock: "Articles gérés en stock",
    articlesWithNoStock: "Articles non gérés en stock",
    articlesWithoutEvent: "Articles sans mouvements à venir",
    articlesWithEvent: "Articles avec mouvements à venir",
    articlesOnlyReappro: "Articles à réapprovisionner",
    triAlpha: "A-Z",
    triEvent: `Évenement`,
    priority: "Priorité",
    modeCommande: "Commande",
    modePlanif: "Planification",
    noStock: "Pas de stock",
    withoutStock: "Article non géré en stock",
    stock: "Stock",
    cumul: "Solde des mouvements prévues au",
    noEventWeek: "Aucun événement prévu pour cette semaine",
    noEventDay: "Aucun événement prévu pour ce jour",
    cancelCommandes:
      "Vous êtes sur le point supprimer votre brouillon de commande. Confirmez-vous ?",
    cancelCommandes_plural:
      "Vous êtes sur le point supprimer vos #nb brouillons de commande. Confirmez-vous ?",
    events: {
      expedition: "Expédition",
      commandesClient: "Commandes client:",
      commandes: "Commandes fournisseur:",
      ofsConso: "Consommé dans:",
      ofsProd: "Produit par:",
      reception: "Réception",
      prod: "Prod.",
      conso: "Conso.",
      expeditionShort: "E",
      receptionShort: "R",
      prodShort: "P",
      consoShort: "C",
      prevu: "Réception",
      prevuShort: "R",
    },
  },
  planif: {
    performance: "Coefficient de performance",
    addTacheCustom: "Ajouter une tâche",
    addCloseCreneau: "Ajouter une fermeture",
    dateDebut: "Date de début",
    dateFin: "Date de fin",
    customLigneName: "Catégorie",
    tacheLibelle: "Libellé",
    affichage: "Affichage",
    eventTypes: "Type d'évènements",
    others: "Autres filtres",
    ligneIncompatible: "Paramétrage de ligne incompatible",
    deployLigne: "Veuillez déployer cette ligne pour déposer le créneau",
    of: {
      enCours: "OF en cours",
      planify: "Planifier un OF",
      start: "Démarrer un OF",
      startButton: "Démarrer",
      planifyButton: "Planifier",
      prevu: "Prochain OF prévu",
      suivants: "OF(s) suivant(s)",
      select: "Sélectionner un OF",
      quantity_needed:
        "Pour effectuer certains calculs pendant le procédé, la spécification nécessite la quantité prévue.",
    },
    filter: {
      afficherHoraires: "Horaires d'ouverture",
      afficherFermeture: "Fermetures ponctuelles",
      hideLigneInactive: "Masquer les lignes inactive",
      ligne: "Lignes",
      famille: "Famille technique",
      displayDays: "Echelle",
      cacheWeeks: "Prévisionnel",
      articleOrder: "Articles commandés",
      articleConso: "Articles consommés",
      articleProd: "Articles produits",
      articleExpe: "Article expédiés",
      fab: "Articles fabriqués",
      nonFab: "Articles non fabriqués",
      fabNonFab: "Articles fabriqués et non fabriqués",
      yes: "Oui",
      no: "Non",
      all: "Tous",
      fabLabel: "Article fabriqué",
      stockLabel: "Géré en stock",
      eventLabel: "Mouvements prévus",
    },
  },
  peo: {
    start: "Démarrer les contrôles récurrents",
    stop: "Terminer les contrôles récurrents",
    restart: "Relancer les contrôles récurrents",
  },
  commandeClient: {
    associate_of: "Lier un OF",
    ref_client: "Réf. client",
    plus_de_parametres: "Plus de paramètres (entrepôt, date d'expédition, créneau)",
    entrepot_optionnel_hint:
      "Optionnel. Sans entrepôt assigné, la commande est visible par tous et peut puiser dans le stock de n'importe quel entrepôt.",
    eclatement_multi_entrepots:
      "Lignes éclatées sur plusieurs entrepôts (stock insuffisant dans un seul)",
    eclatement_multi_entrepots_hint:
      "L'auto-affectation a réparti les lots sur plusieurs entrepôts car aucun seul entrepôt ne couvrait l'intégralité des lignes. Coordonnez la prépa pour éviter les transferts.",
    eclatement_ligne: "Éclatée multi-entrepôts",
    eclatement_ligne_hint:
      "Cette ligne a été couverte par des lots de plusieurs entrepôts. Vérifie la faisabilité opérationnelle (transferts, équipes).",
    tous_entrepots_assignes:
      "Tous les entrepôts disponibles sont déjà assignés à cette commande.",
    aucun_entrepot_mode_global:
      "Aucun entrepôt assigné — mode global (visible par tous, stock puisé partout).",
    aucun_entrepot_mais_ue:
      "Pas d'entrepôt assigné explicitement. Les entrepôts ci-dessus sont détectés via les unités d'expédition (palettes) ou les réservations actives.",
    date_expedition_auto_hint:
      "Préremplie avec la valeur calculée (livraison − délai logistique). Modifier le champ pour forcer une autre date.",
    date_expedition_overridden_hint:
      "Date saisie manuellement (override). Cliquer sur Réinitialiser pour revenir au calcul automatique.",
    commentaires_et_pj: "Commentaires & pièces jointes",
    entrepots_detectes_ue_label: "Détectés (UE / réservation) :",
    entrepot_ue_tooltip:
      "Entrepôt utilisé par une UE (palette) liée à cette commande ou par une réservation active en zone-prepa, mais pas assigné explicitement.",
    entrepot_ue_tooltip_promote:
      "Entrepôt détecté via une UE liée ou une réservation active. Cliquer pour le promouvoir en entrepôt assigné explicitement.",
    include_sans_entrepot: "Inclure CC sans entrepôt",
    include_sans_entrepot_hint:
      "Les commandes sans entrepôt assigné sont visibles par tous (mode global). Décocher pour ne voir que les CC strictement assignées aux entrepôts sélectionnés.",
    entrepots_assignes: "Entrepôts assignés",
    aucun_entrepot_disponible:
      "Aucun entrepôt disponible. Crée des adresses d'entrepôt dans la fiche société.",
    livraison_sans_expedition: "Facturé — gardé en stock",
    livraison_directe_desc:
      "Facturez la marchandise au client sans expédition physique : les produits restent en stock, seul le propriétaire change. À distinguer de « Livraison directe (retrait) » qui sort réellement le stock de l'entrepôt.",
    desannuler: "Désannuler",
    confirmer: "Confirmer la commande",
    marquer_terminee: "Marquer la commande terminée",
    reopen: "Remettre la commande en cours",
    etats_commande: "États de la commande",
    etats_expedition: "État expédition",
    etats_facturation: "État facturation",
    etats_preparation: "Préparation",
    slot_horaire_enlevement: "Slot horaire d'enlèvement",
    slot_horaire_hint: "Heure prévue d'enlèvement transporteur (optionnel)",
    slot_horaire_format_error: "Format invalide (attendu : HH:mm)",
    slot_horaire_tooltip_title: "À quoi sert ce champ ?",
    slot_horaire_tooltip_content:
      "Heure à laquelle le transporteur passe récupérer les marchandises. Trois usages : trier les CC du jour par ordre d'enlèvement dans la vue Pilotage et Supervision Prépa, et imprimer l'heure cible sur la fiche picking remise au préparateur.",
    slot_horaire_tooltip_example:
      "Exemple : une CC à 08:00 sera affichée avant une CC à 14:00 dans la liste du jour. Si le champ est vide, la CC est triée en fin de liste.",
    date_expedition_tooltip_title: "Date d'expédition prévue",
    date_expedition_tooltip_content:
      "Date à laquelle les marchandises doivent partir de l'entrepôt pour être livrées à temps. Préremplie avec la valeur calculée automatiquement (date de livraison − délai logistique en jours ouvrés). Tu peux la modifier pour forcer une autre date — elle sera marquée comme override manuel. Vide la case pour revenir au calcul automatique.",
    date_expedition_tooltip_example:
      "Exemple : livraison prévue le 20/06, délai logistique = 3 jours ouvrés → date d'expédition calculée = 17/06.",
    remise_pied: "Remise pied de commande",
    remise_pied_type: "Type de remise pied",
    remise_pied_label: "Libellé de la remise",
    remise_pied_label_placeholder: "Ex: Remise fidélité, Promo été...",
    total_avant_remise_pied: "Total HT avant remise pied",
    montant_remise_pied: "Montant remise pied",
    total_apres_remise_pied: "Total HT après remise pied",
    delivery_overdue: "En retard",
    delivery_urgent: "Urgent",
    delivery_on_time: "À l'heure",
    delivery_planned_date: "Livraison prévue",
    delivery_first_date: "Première livraison",
    delivery_delta: "Écart",
    delivery_remaining: "Reste",
    delivery_days: "jours",
    preparation_commande: "Préparation de commande",
    date_livraison_ligne: "Date de livraison de cette ligne",
    date_livraison_ligne_heritee:
      "Hérite de la date commande : #date. Saisir une date pour cette ligne uniquement si elle diffère.",
    date_livraison_ligne_specifique:
      "Date spécifique à cette ligne (override de la date commande).",
    date_livraison_ligne_hint:
      "Laisser vide pour hériter de la date commande, ou saisir une date spécifique (cas frais + secs dans une même CC).",
    date_livraison_ligne_reset: "Réinitialiser",
    date_livraison_ligne_reset_tooltip:
      "Réinitialiser la date à celle de la commande (héritage)",
    date_expedition_prevue: "Date d'expédition prévue",
    date_expedition_prevue_info:
      "Date à laquelle les marchandises doivent partir. Calculée automatiquement à partir de la date de livraison et du délai logistique en jours ouvrés.",
    date_expedition_prevue_overridden:
      "Date d'expédition modifiée manuellement",
    date_expedition_prevue_reset_auto:
      "Recalculer automatiquement (livraison − délai)",
    date_expedition_prevue_lignes_heterogenes:
      "Plusieurs dates expé selon les lignes. Première à partir : #date.",
    date_livraison_ligne_badge: "📅 Date spécifique",
    prix_source_negocie: "Tarif négocié",
    prix_source_catalogue: "Catalogue",
    prix_source_manuel: "Manuel",
    multiple_info: "Multiple de #multiple #unite",
    multiple_ok: "#factor × #multiple #unite",
    multiple_hint: "Multiple de #multiple #unite — arrondir à :",
    multiple_keep: "garder #qty",
    pu_brut_ht: "PU brut HT",
    pu_net_ht: "PU net HT",
    remise_col: "Remise",
    montant_ht: "Montant HT",
    add_remise_pied: "Ajouter une remise",
    edit_remise_pied: "Modifier la remise",
    remise_pied_pct_label: "Pourcentage de remise",
    remise_pied_eur_label: "Montant de remise (€ HT)",
    remise_pied_pct_hint: "Appliqué sur le total HT",
    remise_pied_eur_hint: "Déduit du total HT",
    expeditions_title: "Expéditions",
    no_expeditions: "Aucune expédition pour cette ligne",
    aide_table:
      "Chaque ligne représente un article commandé. La quantité s'affiche en unité client et unité article. Le total tient compte des remises appliquées.",
    aide_prix:
      "Prix unitaire HT affiché en unité de gestion et unité article. Si des remises s'appliquent, le prix catalogue est barré et le prix remisé en gras.",
    aide_recap:
      "Total HT = somme des lignes. TVA ventilée par taux. TTC = HT + TVA.",
    aide_remise_pied:
      "Remise globale sur le total HT de la commande. Peut être en pourcentage ou en montant fixe.",
    prix_libre: "Prix libre",
    select_article_hint: "Recherchez et sélectionnez un article pour commencer",
    article_filter_tiers: "Articles du tiers",
    article_filter_all: "Tous les articles",
    article_filter_hint: "⋯ pour voir tous les articles",
    article_label_tiers: "Article (prix du tiers)",
    article_label_all: "Article (tous)",
    // Historique livraisons
    hist_no_deliveries: "Aucune livraison pour cette commande",
    hist_bl_singular: "bon de livraison",
    hist_bl_plural: "bons de livraison",
    hist_expe_singular: "expédition",
    hist_expe_plural: "expéditions",
    hist_article: "Article",
    hist_lot: "Lot",
    hist_dluo: "DDM",
    hist_quantite: "Quantité",
    hist_expediteur: "Expéditeur",
    hist_palette: "Unité d'expédition",
    hist_palette_singular: "unité d'expédition",
    hist_palette_plural: "unités d'expédition",
    hist_print_bl: "BL",
    hist_facture: "Facture",
    hist_no_lot: "Sans lot",
    hist_numero_expedition: "N° Expé",
    hist_poids: "Poids brut",
    hist_total_bl: "Total BL :",
    hist_articles_total: "articles",
    hist_vrac: "Expéditions vrac",
    units_section_title: "Unités d'expédition",
    enlevement_section_title: "En attente d'enlèvement",
    enlevement_hint:
      "Marchandises facturées et gardées en stock (déjà vendues, en dépôt). Sélectionnez-les pour générer un bon d'enlèvement lors de leur sortie physique (aucune nouvelle facture).",
    enlevement_item_sans_lot: "Marchandise gardée en stock",
    btn_generer_bon_enlevement: "Générer le bon d'enlèvement",
    adresse_livraison: "Adresse de livraison",
    adresse_facturation: "Adresse de facturation",
  },
  widget: {
    add: "Ajouter une widget",
    saveDashboard: "Sauvegarder le tableau de bord",
    production: "Production",
    financier: "Financier",
    of: "OF",
    commandeFournisseur: "Commande Fournisseur",
    commandeClient: "Commande Client",
    specif: "Specification",
    list: "Listes",
    stopEdition: "Quitter le mode edition",
    stock: "Stock",
    select: "Sélectionner un Widget",
    dluoDepassee: "DDM dépassée",
    dateValidation: "Date de validation",
    dateRedaction: "Date de rédaction",

    PRODUCTIVITE_MOYENNE: "Productivité moyenne",
    OF_EN_COURS: "OFs en cours",
    HEURES_TRAVAILLES: "Heures travaillées",
    ARTICLES_PAR_FAMILLE: "Articles par famille",
    QUANTITE_OF: "Quantité OF",
    CADENCE_REELLE: "Cadence réelle",
    //financier
    CA_CUMULE: "CA cumulé",
    CA_PAR_PERIODE: "CA par période",
    CA_DELTA: "CA delta",
    REPARTITION_PAR_CLIENT: "Répartition par client",
    REPARTITION_PAR_FAMILLE: "Répartition par famille",
    CA_N_MOINS_1: "CA année précédente",
    //stocks
    VALEUR_STOCK: "Valeur du stock",
    LOT_PAR_ETAT: "Lot par état",
    VALEUR_PAR_FAMILLE: "Valeur par famille",
    ETAT_STOCK: "État du stock",
    NB_LOT_DLC: "Nombre de lot en DLC",
    NB_COMMANDE_FOURNISSEUR: "Nombre de commande fournisseur",
    NB_COMMANDE_CLIENT: "Nombre de commande client",
    MOUVEMENTS: "Mouvements de stock",

    //subType
    OF_ATTENTE_REINTEGRATION: "Attente réintégration",
    OF_ATTENTE_PDC: "Attente pied de chaine",
    //commandeClient
    COMMANDE_CLIENT_EN_COURS_DE_TRAITEMENT:
      "Commandes client en cours de traitement",
    COMMANDE_CLIENT_EN_COURS_DE_PREPARATION:
      "Commandes client en cours de préparation",
    COMMANDE_CLIENT_PRETE: "Prête",
    COMMANDE_FOURNISSEUR_EN_ATTENTE_ENVOI:
      "Commande fournisseur en attente envoi",
    COMMANDE_FOURNISSEUR_EN_ATTENTE_CONFIRMATION:
      "Commandes fournisseur en attente confirmation",
    COMMANDE_FOURNISSEUR_EN_ATTENTE_LIVRAISON:
      "Commandes fournisseur en attente de livraison",
    COMMANDE_FOURNISSEUR_LIVREE_PARTIELLEMENT:
      "Commandes fournisseur livrée partiellement",
    SPECIFICATION_REDIGEE: "Spécifications rédigées",
    SPECIFICATION_VALIDEE: "Sécifications validées",
  },
  reinte: {
    recap: "Récap.",
    edit_pdc: "Modifier le PDC",

    goPageReinte: "Affiner le bilan matière",
    finProduction: "Fin de production",
    saisirQuantitePourVoirBilan:
      "Saisissez une quantité pour afficher le bilan matière",

    articlesConsommationManuelle: "Articles en consommation déclarée",
    articlesConsommationTheorique: "Articles en consommation théorique",
    consoTheoriqueUnitaire: "Conso. théorique unitaire",
    consoTheorique: "Conso. théorique",
    consoReelle: "Conso. réelle",
    ecart: "Écart",

    bilanOk: "Bilan OK",
    ecartDetecte: "Écart détecté",
    ecartImportant: "Écart important",

    bilanPrecis: "Consommations précises",
    bilanPrecisDescription:
      "Les consommations déclarées correspondent aux quantités théoriques. Aucune action requise.",

    ecartAVerifier: "Consommations à vérifier",
    ecartAVerifierDescription:
      "Certaines consommations s'écartent légèrement des quantités théoriques. Vous pouvez les corriger si nécessaire.",

    ecartImportantTitre: "Écarts importants détectés",
    ecartImportantDescription:
      "Les consommations déclarées sont significativement différentes des quantités théoriques. Vérifiez les saisies consommations.",

    corrigerConsommations: "Corriger les consommations",

    calculAuto: "Calcul auto",
    articlesTheoriquesInfo:
      "Ces articles sont consommés automatiquement selon la nomenclature. Aucune déclaration de saisie n'est requise.",
    consommationTotaleTheorique: "Consommation totale théorique",

    resumeConsommations: "Résumé des consommations",
    imprimerBilan: "Imprimer le bilan",
    quantiteRestanteAIntegrer: "Quantité restante à intégrer",
    quantiteIntegreeEnCours: "Quantité intégrée en cours de fabrication",
    quantiteTotaleProduiteSurOf: "Quantité totale produite sur l'OF",
    xEnregistrements: "enregistrement(s)",
    modifierInfosReinte: "Modifier les informations",
    quantiteDepasse:
      "La quantité saisie dépasse la quantité disponible sur la ligne",
    quantiteIncoherente: "Quantité incohérente",
    pfSurLigneCalcule: "PF disponible sur la ligne",
    aideQuantiteDepassee:
      "La quantité saisie est supérieure à la quantité de produits finis réellement présents sur la ligne. Veuillez corriger la valeur pour pouvoir valider.",
    aideQuantiteRestante:
      "Quantité produite restant sur la ligne de production, en attente d'être réintégrée en stock.",
    aideQuantiteIntegree:
      "Somme des quantités déjà transférées du pied de chaîne vers le stock au cours de la fabrication de cet OF.",
    aideQuantiteTotale:
      "Total de la production sur l'OF : quantité restante à intégrer + quantité déjà intégrée en cours de fabrication.",
    dateFinProduction: "Date de fin de production",
    quantite: "Quantité",
    date: "Date",
    article: "Article",
    articles: "articles",
    etat: "État",
    total: "Total",
    consommesAuTotal: "consommés au total",
    validerFinProduction: "Valider fin production",
    aideSaisieConsos: "Aide à la saisie des consommations",
    saisieConso: "Saisie de la consommation",
    saisirConsos: "Saisir consos",
    lotsSaisis: "lots saisis",
    saisi: "Saisi",
    aSaisir: "À saisir",
    // aSaisirOpe: "",
    // aSaisirReinte: "Veuillez saisir l",
    aucunLotPourCetArticle:
      "Aucun lot trouvé pour cet article dans le bilan de réintégration.",
    sauvegarderProgression: "Sauvegarder la progression",
    validerEtFermer: "Valider et fermer",
  },
  help: {
    stockReappro:
      "Seuil en dessous duquel une commande d'achat est recommandée. Doit être supérieur ou égal au stock de sécurité.",
    stockSecurite:
      "Stock minimum à toujours conserver. Ne peut pas être supérieur au stock de réapprovisionnement.",
    quantiteAchat:
      "Quantité par défaut proposée lors de la création d'une commande d'achat pour cet article.",
    net_weight_uc:
      "Poids net d'une unité de consommation (UC) en kg. Cette valeur est utilisée pour calculer automatiquement le poids net total des unités d'expédition.",
    gross_weight_uc_etiq:
      "Poids brut d'une unité de gestion (emballage inclus) en kg, tel que renseigné dans la fiche article. " +
      "Il est multiplié par la quantité en unités de gestion pour calculer le poids brut total affiché sur l'étiquette et encodé dans le code-barres. " +
      "Ne pas inclure le poids de l'unité d'expédition (palette, carton…).",
    weight_edit_article_warning:
      "Cette modification sera enregistrée définitivement dans la fiche article et s'appliquera à toutes les prochaines impressions d'étiquettes.",

    article:
      "Produit ou composant référencé dans l'entreprise, pouvant être fabriqué, acheté ou stocké. Il possède des caractéristiques précises (nom, code, unité de gestion, EAN, etc.).",

    tiers:
      "Entité extérieure avec laquelle l’entreprise interagit, comme un client, un fournisseur ou un sous-traitant.",

    specification:
      "Ensemble de critères définissant les caractéristiques attendues d’un article (nomenclature, procédé de fabrication, contrôles à réaliser, etc.). Sert de référence pour la fabrication et le contrôle qualité.",

    FAMILLE_ARTICLE:
      "Catégorie regroupant plusieurs articles aux caractéristiques similaires ou ayant une même finalité (ex : biscuits, sauces, emballages). Facilite l’organisation et la recherche des articles.",

    SOUS_FAMILLE_ARTICLE:
      "Catégorie regroupant les articles selon leurs spécificités de fabrication ou d’utilisation technique (ex : types de matières premières, procédés de transformation spécifiques). Permet de structurer les articles en fonction de leur compatibilité avec une ou plusieurs lignes de fabrication (cadence, nombre d'opérateurs, etc.).",

    TRAVAIL:
      "Libellé personnalisé permettant d’assigner des heures de travail à des opérations spécifiques (ex : nettoyage d’entrepôt, soutien administratif).",

    UNITE:
      "Unité de gestion personnalisée (ex : carton de 24 unités, bidon de 6L), basée sur une unité de base (Kg, Unitaire, Litre…) avec un coefficient de conversion associé.",

    OF: "Commande interne déclenchant la production d’un article, en précisant la quantité à fabriquer et la ligne de production assignée. Permet d’organiser, suivre et optimiser la fabrication.",

    ope: "Subdivision d’un Ordre de Fabrication (OF), permettant d’exécuter la production en plusieurs étapes. Correspond à une quantité spécifique fabriquée ou à une période définie de production.",

    controles_simplifie:
      "En mode classique, les contrôles sont regroupés par étapes de process (un step par étape, avec plusieurs contrôles dedans).\n" +
      "\n" +
      "En mode simplifié, chaque contrôle devient directement un step du stepper.\n" +
      "👉 L’opérateur enchaîne les contrôles un par un, sans passer par la notion d’étape.\n" +
      "\n" +
      "✅ Avantages : plus simple, plus fluide, moins de risque d’oubli.",
    customEnum: {
      FAMILLE_ARTICLE:
        "Permet de catégoriser les articles par famille (ex : composants, produits finis, emballages…).",
      SOUS_FAMILLE_ARTICLE:
        "Détermine sur quelle ligne un article peut être produit, chaque ligne ayant ses propres paramétrages adaptés aux sous-familles.",
      UNITE:
        "Désigne l’unité dans laquelle l’article est exprimé (ex : pièce, kilogramme, litre).",
      UNITE_PROD:
        "Représente l’unité spécifique à la production de l’article (ex : mètre pour des câbles).",
      EMPLACEMENT_STOCK:
        "Indique l’emplacement de stockage de l’article (ex : rayon A1, entrepôt B).",
      POSTE:
        "Représente le poste de l'utilisateur (ex : manager, opérateur, technicien).",
      TITRE:
        "Indique le titre ou la civilité de l'utilisateur (ex : Monsieur, Madame, Monsieur le Directeur).",
      TRAVAIL: "",
    },

    mode_conso:
      "Ces règles s’appliquent au moment de clôturer un OF.\n" +
      "Ensuite, les consommations restent toujours modifiables dans la page de statistiques de l’OF.\n" +
      "\n" +
      "───────────────────────────\n" +
      "1) Article géré lot par lot\n" +
      "───────────────────────────\n" +
      "Si l’article est configuré avec « Détail des quantités en stock pour chaque lot »,\n" +
      "alors le mode de consommation est imposé :\n" +
      "\n" +
      "« Analyse précise des consommations (bilans matières / article suivi en pied de chaîne) »\n" +
      "\n" +
      "Pourquoi ?\n" +
      "Pour maintenir un stock exact lot par lot, il faut pouvoir rattacher chaque consommation à un lot.\n" +
      "\n" +
      "Exemple :\n" +
      "Sucre (Lot S-001, Lot S-002) → consommation : 30 kg sur S-001 + 20 kg sur S-002.\n" +
      "\n" +
      "───────────────────────────\n" +
      "2) Article non géré par lot\n" +
      "───────────────────────────\n" +
      "Deux modes sont possibles :\n" +
      "\n" +
      "A. Consommation théorique\n" +
      "→ JustUp enregistre la consommation calculée automatiquement.\n" +
      "Exemple : théorique = 100 kg → consommation retenue = 100 kg.\n" +
      "\n" +
      "B. Saisie facultative des consommations\n" +
      "→ Si rien n’est saisi : JustUp applique le théorique.\n" +
      "→ Si une consommation est saisie : elle devient prioritaire et remplace le théorique.\n" +
      "\n" +
      "Exemples :\n" +
      "• Théorique = 100 kg, saisi = 96 kg → consommation retenue = 96 kg\n" +
      "• Théorique = 100 kg, rien saisi → consommation retenue = 100 kg\n",
  },
  variables: {
    modelRedaction: "Modèle non validé",
    operator: "Operateur",
    text: "Texte",
    number: "Nombre",
    document: "Document",
    nomenclatureArticle: "Nomenclature",
    processOptional: "Process optionnel",
    optional: "Optionnel",
    articleDynamic: "Article paramétrable",
    paramDynamic: "Quantité paramétrable",
    do: "Réaliser",
    dontDo: "Ne pas réaliser",
    math_formula: "Formule numérique",
    text_formula: "Formule textuelle",
  },
  nutrient: {
    calories: "Calories",
    total_fat: "Lipides",
    saturated_fats_sub: "– dont acides gras saturés",
    trans_fats_sub: "– dont acides gras trans",
    omega3_sub: "– dont Oméga-3",
    omega6_sub: "– dont Oméga-6",
    monounsaturated_fats_sub: "– dont acides gras monoinsaturés",
    carbohydrates: "Glucides",
    dietary_fibre_sub: "– dont fibres alimentaires",
    soluble_fibre_sub: "– dont fibres solubles",
    insoluble_fibre_sub: "– dont fibres insolubles",
    sugars_sub: "– dont sucres",
    polyalcohols_sub: "– dont polyalcools",
    starch_sub: "– dont amidon",
    protein: "Protéines",
    cholesterol: "Cholestérol",
    sodium: "Sodium",
    potassium: "Potassium",
    calcium: "Calcium",
    iron: "Fer",
    vitamin_a: "Vitamine A",
    vitamin_c: "Vitamine C",
    vitamin_d: "Vitamine D",
    vitamin_e: "Vitamine E",
    vitamin_k: "Vitamine K",
    thiamine: "Thiamine",
    riboflavin: "Riboflavine",
    niacin: "Niacine",
    vitamin_b6: "Vitamine B6",
    folate: "Folate",
    vitamin_b12: "Vitamine B12",
    biotin: "Biotine",
    pantothenate: "Pantothénate",
    choline: "Choline",
    phosphorus: "Phosphore",
    iodide: "Iode",
    magnesium: "Magnésium",
    zinc: "Zinc",
    selenium: "Sélénium",
    copper: "Cuivre",
    manganese: "Manganèse",
    chromium: "Chrome",
    molybdenum: "Molybdène",
    chloride: "Chlorure",
  },
  avoir: {
    add_cta: "Créer un avoir",
  },
  tts: {
    regenerate: "Regénérer la synthèse vocale",
    autoplay: "Lecture automatique",
    autoplayLabel: "Lecture automatique de la synthèse vocale",
  },
  connector: {
    title: "Connecteur e-commerce",
    manageSync: "Gérer la synchronisation",
    active: "Activé",
    endpoint: "Endpoint",
    apiKey: "Clé API",
    typeConnector: "Type de connecteur",
    clientId: "Client ID",
    state: "État de synchronisation",
    sync: "Synchroniser",
    loadingFrom: "Chargement des données depuis",
    params_title: "Direction de synchronisation",
    params_description: "Pour chaque type d'entité, choisissez la direction de synchronisation entre Justup et votre boutique en ligne.",
    direction_both: "Deux sens",
    direction_both_desc: "Les modifications dans Justup sont envoyées vers la boutique, et les modifications dans la boutique sont importées dans Justup. Le rapprochement initial se fait dans les étapes suivantes.",
    direction_pull: "Réception",
    direction_pull_desc: "Seules les modifications de la boutique sont importées dans Justup. Justup ne modifie rien sur la boutique.",
    direction_push: "Envoi",
    direction_push_desc: "Seules les modifications de Justup sont envoyées vers la boutique. Les changements faits sur la boutique ne sont pas importés.",
    direction_none: "Aucune",
    direction_none_desc: "Aucune synchronisation pour ce type d'entité.",
    monitoring: "Monitoring",
    errors: {
      necessite: "nécessite",
      compatible: "compatible",
      current: "actuel",
    },
    status: "Status",
    updated: "Dernière mise à jour",
    lastUpdateSource: "Par",
    webhooks: {
      title: "Paramétrage des automatismes",
      description1Prestashop:
        "Si vous souhaitez synchroniser automatiquement les éléments lors d'une modification, création ou suppression sur Prestashop.",
      description2Prestashop:
        'Veuillez configurer le module "Justup Webhooks" pour Prestashop.',
      download: "Télécharger le module Prestashop",
      generateApiClient: "Générer un client API",
      reInitApiClient: "Réinitialiser le client API",
      reInitApiClientMessage:
        "Cette action va générer un nouvel identifiant et désactiver immédiatement les anciens.\n" +
        "Vous devrez copier le nouveau secret et le coller dans le module MODULE pour rétablir la synchronisation.\n" +
        "L’ancien ne pourra pas être récupéré.",
      clientId: "Client ID",
      clientSecret: "Client Secret",
      webhookSecret: "Secret HMAC (signature webhooks)",
    },
    type: {
      customer: "Client",
      customer_plural: "Clients",
      address: "Adresse",
      address_plural: "Adresses",
      product: "Article",
      product_plural: "Articles",
      order: "Commande",
      order_plural: "Commandes",
      group: "Groupe",
      group_plural: "Groupes",
      tax: "Taux TVA",
      tax_plural: "Taux de TVA",
      carrier: "Transporteur",
      carrier_plural: "Transporteurs",
      payment: "Paiement",
      payment_plural: "Paiements",
      toCreate: "à créer",
      toReconcile: "à rapprocher",
      diff: "à modifier",
      synced: "déjà synchronisé",
    },
    orderState: {
      etat: "État logistique",
      etatPaiement: "État paiement",
      etatExpedition: "État expédition",
      default: "État par défault",
      custom: "État custom",
      defaultsReadOnlyTooltip:
        "Configuré automatiquement par PrestaShop — non modifiable",
      duplicateError: "Plusieurs mappings pointent vers le même état PrestaShop",
      orphanError:
        "État PrestaShop introuvable (supprimé ou désactivé). Retirez ce mapping pour continuer.",
      flagsFixed:
        "#count état(s) PrestaShop corrigé(s) — génération automatique de factures/BL désactivée : #names",
    },
    syncProgress: {
      title: "Synchronisation en cours",
      current: "Élément en cours :",
      done: "Synchronisation terminée",
      finalizing: "Chargement des données mises à jour…",
      errors: "erreur(s) rencontrée(s)",
      close: "Fermer",
    },
    ecommerce: "Connecteurs e-commerce",
    synchronisation: "Synchronisation des éléments",
    parametrage: "Paramétrage de la synchronisation",
    params: "Paramètres",
    recuperation: "Récupération des éléments",
    groups: "Groupes",
    clients: "Clients",
    addresses: "Adresses",
    articles: "Articles",
    orderStates: "États de Commande",
    orders: "Commandes",
    new: "Nouveau",
    select: "Sélectionner",
    ignore: "Ignorer",
    synced: "Synchronisé",
    notSynced: "Non synchronisé",
    justup: "Justup",
    syncPending: "Synchronisation en cours...",
    cancelModification: "Annuler la modification",
    edit: "Modifier",
    defaultPrices: "Prix par défaut",
    tiersPrices: "Tiers",
    groupPrices: "Groupe",
    article_non_lie_chip: "Article non lié",
    article_non_lie_tooltip: "Cet article n'est pas encore lié à #connectorName — la commande ne pourra pas être transmise tant que l'article n'est pas lié",
    tiers_non_lie_chip: "Tiers non lié",
    tiers_non_lie_tooltip: "#tiersName n'est pas encore lié — ce tarif ne sera pas transmis à #connectorName",
    sync_doublon: "Référence déjà synchronisée",
    sync_doublon_tooltip: "Tous les articles suggérés sont déjà liés à d'autres produits #connectorType. Ignorez cet élément, ou utilisez 'Associer' pour le lier manuellement à un article Justup différent.",
    sync_already_linked: "Déjà lié à #skuKey",
  },
  time: {
    instant: "À l'instant",
    ago: "Il y a #time",
    dayShort: "j",
    hourShort: "h",
    minuteShort: "min",
  },
  pdf: {
    generate: "Génération du PDF en cours...",
  },
  sso: {
    sync: "Synchroniser mon compte",
    configure_mail: "Configurer",
    no_mail_configured: "Aucun email n'est paramétré pour votre compte",
    refresh: "Rafraichir la connexion",
    active: "Actif",
    inactive: "Inactif",
    sendMail: "Envoi d'email",
    yes: "Oui",
    no: "Non",
    detail1:
      "Pour une configuration plus rapide et plus fiable, nous vous recommandons d’utiliser un compte Google ou Microsoft.",
    detail2:
      "Si vous préférez utiliser votre propre serveur mail, vous pouvez renseigner manuellement les paramètres SMTP ci-dessous.",
    alreadyConfigured:
      "Vous avez déjà une configuration mail, supprimez la pour en configurer une autre.",
  },
  "mouvements-stocks": {
    titre: "Mouvements de stocks",
    kpi: {
      entrees: "Entrées",
      sorties: "Sorties",
      "solde-net": "Solde Net",
      mouvements: "Mouvements",
      "derniere-activite": "Dernière activité",
      "sur-la-periode": "sur la période",
      "aucune-donnee": "Aucune donnée",
    },
    filtres: {
      "interval-date": "Interval de date",
      rechercher: "Rechercher par article, lot, lien...",
      "type-mouvement": "Type de mouvement",
      article: "Article",
      entrepot: "Entrepôt",
      "effacer-filtres": "Effacer les filtres",
    },
    periodes: {
      "1m": "1M",
      "3m": "3M",
      "12m": "12M",
      exercice: "Exercice en cours",
      "exercice-passe": "Exercice passé",
      tout: "Tout",
    },
    table: {
      type: "Type",
      date: "Date",
      article: "Article",
      lot: "Lot",
      lien: "Lien",
      quantite: "Quantité",
      valeur: "Valeur",
      entrepot: "Entrepôt",
      emplacement: "Emplacement",
      documents: "Doc.",
      "elements-par-page": "Éléments par page",
      sur: "sur",
      "aucun-mouvement": "Aucun mouvement trouvé",
      chargement: "Chargement des mouvements...",
    },
  },
  actions: {
    "exporter-csv": "Exporter CSV",
  },
  famille: {
    sousFamilles: "Sous-familles",
    sousFamille: "sous-famille",
    sousFamilles_plural: "sous-familles",
    addSousFamille: "Ajouter une sous-famille",
    noSousFamille: "Aucune sous-famille",
    emptyList: "Aucun élément",
    showDisabled: "Voir les éléments désactivés",
    disableWarn:
      "Cette famille est liée à des anciennes versions d'article, elle ne peut pas être supprimée définitivement.",
  },
  controle: {
    controlesGeneraux: "Contrôles généraux",
    scope: {
      title: "Périmètre d'application",
      all: "Ce contrôle s'applique à tous les éléments",
      filtered: "Ce contrôle s'applique aux éléments filtrés",
      famille: "Famille d'article",
      famille_plural: "Familles d'article",
      sousFamille: "Sous-famille d'article",
      sousFamille_plural: "Sous-familles d'article",
      tiers: "Tiers",
      allFeminin: "Toutes",
      allMasculin: "Tous",
      or: "ou",
      and: "et",
      selected: "#count sélectionnée",
      selected_plural: "#count sélectionnées",
      selectedMasculin: "#count sélectionné",
      selectedMasculin_plural: "#count sélectionnés",
      familleCategorie: "Familles et sous-familles",
    },
    applique_uniquement: "Appliqué uniquement pour:",
    form: {
      min: "Min",
      max: "Max",
      saisies: "saisies",
      minimumRequis: "minimum requis",
      ajouterSaisie: "Ajouter une saisie",
      realisePar: "Réalisé par",
      modifierRealisateur: "Modifier le réalisateur et la date",
      cible: "Cible",
    },
    matrix: {
      title: "Contrôles",
      controls_count: "contrôles",
    },
  },
  dynText: {
    // Categories
    general: "Généraux",
    variables: "Variables",
    documents: "Documents",
    // Mode toggle
    value: "Valeur",
    formula: "Formule",
    // Placeholders
    selectArticle: "Sélectionnez un article...",
    number: "Nombre",
    dragHere: "Glissez des éléments ici ou cliquez dessus...",
    selection: "Sélection :",
    addDynamicValue: "Ajouter une valeur dynamique",
    dynamicValues: "Valeurs dynamiques",
    // Expression labels
    ofQuantity: "Quantité OF",
    opeQuantity: "Quantité Opération",
    opeQuantityShort: "Quantité Opé",
    name: "Nom",
    reference: "Référence",
    code: "Code",
    quantity: "Quantité",
    quantityNomenclature: "Quantité nomenclature",
    unit: "Unité",
    unitManagement: "Unité de gestion",
    loss: "Perte",
    lossNormal: "Perte normale (%)",
    lossMax: "Perte max",
    lossMaxPercent: "Perte max. (%)",
    density: "Densité",
    photo: "Photo",
    // Short labels for formula display
    qtyOf: "Qté OF",
    qtyOpe: "Qté Opé",
    qty: "Qté",
    maxLoss: "P.max",
    // Validation errors
    errorParenthesisClose: "Parenthèse fermante sans ouvrante",
    errorStartOperator: "Ne peut pas commencer par un opérateur",
    errorConsecutiveOperators: "Deux opérateurs consécutifs",
    errorMissingOperator: "Opérateur manquant entre deux valeurs",
    errorOperatorAfterOpen: "Opérateur invalide après (",
    errorCloseAfterOperator: "Parenthèse fermante après opérateur",
    errorMissingOperatorAfterClose: "Opérateur manquant après )",
    errorMissingOperatorBeforeOpen: "Opérateur manquant avant (",
    errorUnbalancedParenthesis: "Parenthèses non équilibrées",
    errorEndOperator: "Ne peut pas finir par un opérateur",
    errorEndOpenParen: "Ne peut pas finir par (",
    selectElement: "Sélectionnez un élément",
    orSelectElement: "ou sélectionnez un élément",
  },
  bilanArticle: {
    declarations: "Déclarations",
    enregistrements: "enregistrement(s)",
    aideDeclarations:
      "Les enregistrements sont les déclarations de consommation saisies manuellement par les opérateurs sur la ligne.",
    tracaWarning: "⚠ Traçabilité activée mais aucune déclaration.",
    tracaWarningDetail:
      "Saisissez les consommations pour assurer la traçabilité.",
    theorique: "Théorique",
    aSaisir: "À saisir",
    aidePertes:
      "Écart entre la consommation réelle et la consommation théorique attendue par la nomenclature.",
    calculDesPertes: "Calcul des pertes",
    formulePertes: "Conso réelle − Conso théorique",
    soit: "Soit",
    dEcart: "d'écart",
    seuilsConfigures: "Seuils configurés",
    seuilNormal: "Normal",
    seuilAttention: "Attention",
    seuilCritique: "Critique",
    modeTheorique: "Mode théorique :",
    modeTheoriqueDetail: "pas d'écart calculé (conso = théorique).",
    enAttenteDeSaisie: "En attente de saisie.",
    completezLots: "Complétez les lots pour calculer les pertes.",
    entreePdc: "ENTRÉE PDC",
    aideEntreePdc:
      "Quantité totale transférée du stock vers le Pied de Chaîne pour cet OF. C'est la matière mise à disposition de la production.",
    mouvement: "Mouvement",
    stockVersPdc: "Stock → Pied de Chaîne",
    total: "Total",
    consommation: "CONSOMMATION",
    aideConso:
      "Quantité réellement consommée en production. Composée des déclarations opérateurs et du calcul automatique par lot.",
    repartition: "Répartition",
    declare: "Déclaré",
    calcule: "Calculé",
    theoriqueLabel: "Théorique",
    saisieIncomplete: "Saisie incomplète.",
    saisieIncompleteDetail: "Renseignez tous les lots pour obtenir le total.",
    theo: "théo.",
    retourPdc: "RETOUR PDC",
    aideRetourPdc:
      "Quantité non utilisée retournée du Pied de Chaîne vers le stock. Cette réintégration génère un mouvement 'Réintég. PDC' et permet de récupérer les matières excédentaires.",
    calcul: "Calcul",
    pdcVersStock: "Mouvement : PDC → Stock",
    formuleRetour: "Entrée − Conso = Retour",
    retourAttenteDetail:
      "Le retour sera calculé automatiquement une fois tous les lots renseignés.",
    reintegrationTitle: "Réintégration PDC → Stock",
    aideReintegration:
      "Pour chaque lot, saisissez la quantité réellement retournée au stock. L'écart avec l'entrée initiale déterminera la consommation réelle.",
    parLot: "Par lot",
    formuleConsoLot: "Conso = Entrée PDC − Retour",
    lotsASaisir: "lot(s) à saisir",
    pourCompleterBilan: "pour compléter le bilan.",
    saisieRetourPdc:
      "Saisissez la quantité retournée au stock depuis le Pied de Chaîne",
    ope: "Opé.",
    du: "du",
    qteProduite: "Qté produite:",
    qteConsommee: "Qté consommée",
    qteTheorique: "Qté théorique",
    lot: "lot",
    lot_plural: "lots",
  },
  bilanLot: {
    entreePdcLabel: "Entrée PDC",
    qteDisponible: "Qté disponible",
    aideQteInitialeReinte:
      "Quantité de ce lot transférée du stock vers le Pied de Chaîne au début de la production.",
    ceLot: "Ce lot",
    stockVersPdc: "Stock → PDC",
    aideQteInitiale:
      "Quantité disponible de ce lot au début de cette opération.",
    detail: "Détail",
    entreePdcDetail: "Entrée PDC :",
    reportPostePrec: "Report poste préc. :",
    total: "Total :",
    qteRestanteFinProd: "Quantité restante en fin de prod.",
    qteRestanteFinOpe: "Quantité restante en fin d'opé.",
    aideRestanteReinte:
      "Quantité non utilisée de ce lot, retournée au stock. Saisissez ce qui reste physiquement après production.",
    aideRestanteOpe:
      "Quantité non consommée de ce lot en fin d'opération. Ce restant sera reporté comme disponible pour l'opération suivante.",
    saisieAttendue: "Saisie attendue",
    entre: "Entre",
    et: "et",
    resultat: "Résultat",
    pdcVersStock: "PDC → Stock",
    retour: "Retour :",
    consommation: "Consommation",
    aideConsoLot:
      "Quantité réellement consommée pour ce lot, calculée automatiquement à partir de l'entrée et du retour.",
    calcul: "Calcul",
    formuleEntreeRetour: "Entrée − Retour = Conso",
    saisirRetourPourCalcul: "Saisissez le retour pour calculer",
    declarationsOperateur: "Déclarations opérateur",
    declaration_plural: "déclaration(s)",
    consosDifferentesDeclarations: "⚠ Conso différentes des déclarations",
    consoNegative: "Consommation négative",
    estDifferentDes: "est différent des",
    declaresEnCoursProd: "déclarés en cours de production",
    aideConsoDirecte:
      "Sans Pied de Chaîne, saisissez directement la quantité consommée de ce lot pendant la production.",
    declarations: "Déclarations",
    initiale: "INITIALE",
    disponible: "DISPONIBLE",
    restante: "RESTANTE",
    restanteFinOpe: "RESTANTE FIN OPÉ",
    consommee: "CONSOMMÉE",
    na: "N/A",
  },
  transfert_entrepot: {
    ajouterLigne: "Ajouter une ligne",
    modifierLigne: "Modifier la ligne",
    zoneDeTransfert: "Zone de transfert",
    palettes: "Unités d'expéditions",
    expedier: "Expédier",
    envoyerVersChargement: "Envoyer vers un chargement",
    creerNouvellePalette: "Ajouter une Unité d'Expédition",
    palettesEnPreparation: "Zone de préparation",
    ajouterLignesAvant: "Veuillez d'abord ajouter des lignes au transfert",
    ajouterDesLots: "Ajouter des lots",
    preparationVrac: "Préparation zone de transfert",
    enZone: "En zone",
    enZoneDeTransfert: "en zone",
    lignesDeTransfert: "Lignes de transfert",
    // Labels & headers
    article: "Article",
    quantite: "Quantité",
    numero: "Numéro",
    surPalette: "Sur unité d'expédition",
    expedie: "Expédié",
    demande: "Demandé",
    stockDispo: "Stock dispo",
    mode: "Mode",
    adresseDepart: "Adresse de départ",
    adresseArrivee: "Adresse d'arrivée",
    // Dialog titles
    nouveauTransfert: "Nouveau transfert d'entrepôt",
    modifierTransfert: "Modifier le transfert",
    creerPalette: "Créer une unité d'expédition",
    ajouterDesLotsTitle: "Ajouter des lots",
    voirAutresPalettes: "Voir les autres unités d'expédition",
    // Actions
    valider: "Valider",
    confirmerReception: "Confirmer réception",
    annuler: "Annuler",
    desannuler: "Désannuler",
    solder: "Solder",
    nouveauTransfertBtn: "Nouveau transfert",
    // Dates
    transfertDu: "Transfert du",
    // Filter
    etatsTransfert: "États du transfert",
    trierParModification: "Trier par modification",
    trierParCreation: "Trier par création",
    // Lot chooser
    choisirArticle: "Cliquez sur un article pour ajouter des lots",
    aide_expedition_maker:
      "Sélectionnez un article pour choisir les lots et quantités à ajouter sur l'unité d'expédition. La barre de progression indique l'avancement par rapport à la quantité demandée.",
    selectLotEtQuantite: "Sélectionnez un lot et une quantité à ajouter",
    quantiteAAjouter: "Quantité à ajouter",
    mouvementsEnAttente: "Mouvements en attente de sauvegarde",
    aucunMouvement: "Aucun mouvement à sauvegarder",
    sur: "sur",
    // Confirmation & errors
    annulationTitre: "Annulation du transfert",
    annulationMessage:
      "Vous êtes sur le point d'annuler le transfert #numero. Confirmez-vous ?",
    adressesIdentiques:
      "Les adresses de départ et d'arrivée ne peuvent pas être identiques",
    dluoDepassee:
      "La DLUO du lot #numero est dépassée, impossible de le sélectionner",
    modifNonSauvegardees:
      "Vous avez des modifications non sauvegardées, voulez-vous vraiment quitter la page ?",
    abandonnerModif: "Abandonner les modifications",
    resterSurPage: "Rester sur la page",
    attention: "Attention",
    paletteRequise:
      "L'unité d'expédition est requise pour ce mode de transfert",
    // Préparation
    preparation: "Préparation",
    // Bon de transfert
    imprimerBT: "Imprimer le BT",
    bonDeTransfert: "Bon de transfert",
    // Lot detail
    lot: "Lot",
    lots: "lots",
    expeditions: "Préparation du transfert",
    vrac: "Lots sans unités d'expéditions",
    // Dechargement transfert
    dechargement: "Déchargement",
    dechargementTitle: "Déchargement du transfert",
    nouveauDechargement: "Nouveau déchargement",
    terminerDechargement: "Terminer le déchargement",
    numeroBonTransfert: "N° bon de transfert",
    bonTransfert: "Bon de transfert",
    selectionnerBonTransfert: "Sélectionner un bon de transfert",
    // Reception transfert
    reception: "Réception",
    receptionTitle: "Réception du transfert",
    receptionsTitle: "Réceptions",
    quantiteAttendue: "Quantité attendue",
    quantitePresente: "Quantité présente",
    quantiteRecue: "Quantité reçue",
    conforme: "Conforme",
    nonConforme: "Non conforme",
    ecart: "Écart",
    recevoir: "Recevoir",
    recu: "Réceptionné",
    quantiteDechargee: "Quantité déchargée",
    // Warnings
    quantiteEnZone: "Quantité en zone de transfert",
    warningQuantiteSupZone:
      "La quantité saisie est supérieure à la quantité en zone de transfert",
    warningEcartQuantite:
      "Écart de quantité : #expected attendu, #actual présent",
    warningEcartDechargement:
      "Écart : #decharged déchargé, #present présent en zone",
    warningArticleManquant: "Article absent de la zone de transfert",
    warningArticleSupplementaire:
      "Article présent dans la zone de transfert mais non prévu dans le transfert",
    aucuneReception: "Aucune réception enregistrée",
    aucunDechargement: "Aucun déchargement enregistré",
    // Lot chooser refonte
    progression: "Progression",
    modificationsEnCours: "Modifications en cours",
    presentsSurPalette: "Présents sur l'unité d'expédition",
    choisirPalette: "Choisir une unité d'expédition",
    mettreSurPalette: "Mettre sur unité d'expédition",
    preparationDuTransfert: "Préparation",
    paletteDu: "Unité d'expédition ·",
    vracDu: "Vrac ·",
    titre: "Transferts entrepôt",
    titreDetail: "Transfert entrepôt",
    termine: "Terminé",
    enCours: "En cours",
    terminer: "Terminer",
    du: "Du",
    dechargementDuTransfert: "Déchargement du transfert",
    declarerLots: "Déclarer les lots",
    recevoirLigne: "Recevoir",
    terminerDechargementTitle: "Terminer le déchargement",
    terminerDechargementMessage: "Confirmez-vous la fin du déchargement ?",
    dechargementTermine: "Déchargement terminé",
    receptionsEnregistrees: "Réceptions enregistrées",
    receptionModifiee: "Réception modifiée",
    receptionSupprimee: "Réception supprimée",
    errorNoUserInfos: "Impossible de sauvegarder : utilisateur non chargé",
  },
  taux_horaire: {
    title: "Taux horaire",
    add: "Ajouter un taux horaire",
    date: "Date",
    rate: "Taux horaire (€/h)",
    override: "Saisie manuelle",
    no_data: "Aucun taux horaire enregistré.",
    delete_confirm: "Supprimer ce taux horaire ?",
    col_date: "Date",
    col_rate: "Taux (€/h)",
    col_override: "Type",
    col_actions: "Actions",
    type_manual: "Manuel",
    type_auto: "Automatique",
    edit: "Modifier le taux horaire",
    date_exists: "Un taux horaire existe déjà pour cette date.",
  },

  lot_stock_selector: {
    title: "Sélection du lot",
    titleStock: "Sélection du stock",
    ddm_depassee: "Périmé",
    ddm_force: "Durée de vie mini non tenue",
    consignation_badge: "Déjà vendu — à enlever",
    ddm_blocked_msg:
      "Ce lot ne respecte pas la durée de vie minimale exigée par le client (ou est périmé) — sélection bloquée.",
    ddm_warn_msg:
      "Ce lot est sous la durée de vie minimale exigée par le client : forçage motivé requis.",
    autres_entrepots_info: "Aussi disponible (autre entrepôt, non sélectionnable ici) :",
    placeholder: "Sélectionner un lot",
    placeholderStock: "Sélectionner un stock",
    selectionner: "Sélectionner",
    voirTousLesStocks: "Voir tous les stocks",
    quarantaine: "Quarantaine",
    dluoDepassee: "DDM dépassée",
    aucunLot: "Aucun lot disponible",
    aucunStock: "Aucun stock disponible",
    aideTitle: "Sélection",
    aideContent:
      "Les lots disponibles pour cet article sont affichés ci-dessous. Sélectionnez le lot souhaité puis validez.",
    aideAdresseFilter:
      "Seuls les stocks de l'adresse #adresse sont affichés. Activez le toggle pour voir tous les stocks.",
    lotUnique: "Lot unique",
    voirLesLots: "Voir les lots",
    scan: "Scanner",
    ajouter: "Ajouter",
    quantite: "Quantité",
    stockRestant: "Stock restant",
    resteAExpedier: "Reste à expédier",
    scanError: "Lot scanné introuvable dans les options disponibles",
    ddm: "DDM",
    rechercherLot: "Rechercher un lot",
    rechercherStock: "Rechercher un stock",
    dispo: "dispo",
    stocksFiltresAdresse:
      "Entrepôt de départ de l'unité d'expédition — seuls les lots disponibles ici sont affichés",
    lotsEnStock: "lot(s) en stock",
    labelLot: "Lot",
    labelStock: "Stock",
    editTitle: "Modifier la quantité",
    currentOnPalette: "Sur unité d'expédition",
    modifier: "Modifier",
  },
  parametrage: {
    expedition_unit_types: "Unités d'expédition",
    commercial: "Commercial",
  },
  expedition_unit_type: {
    add: "Ajouter un type d'unité d'expédition",
    new_chip: "Nouveau type",
    edit: "Modifier le type d'unité d'expédition",
    denomination: "Dénomination",
    denomination_hint: "Ex : Palette Europe, Roll, Demi-palette",
    tare: "Tare (kg)",
    tare_hint: "Poids à vide de l'unité",
    valeur: "Valeur (€)",
    valeur_hint: "Valeur unitaire de l'unité",
    article: "Article lié",
    article_aide:
      "Lier un article permet de suivre le stock d'unités disponibles dans l'entrepôt.",
    icon: "Icône",
    gradient: "Couleur",
    stock_available: "en stock",
    no_article: "Aucun article lié",
    delete_confirm: "Supprimer ce type d'unité ?",
    disabled: "Désactivée",
  },
  tax_rate: {
    title: "Taux de TVA",
    add: "Ajouter un taux de TVA",
    edit: "Modifier le taux de TVA",
    denomination: "Dénomination",
    denomination_hint: "Ex : TVA 20%, TVA 5.5%",
    rate: "Taux (%)",
    rate_hint: "Taux de TVA en pourcentage",
    is_default: "Par défaut",
    select: "Taux de TVA",
    custom: "Personnalisé",
    back_to_list: "Revenir à la liste des taux",
  },
  palette_display: {
    status: {
      empty: "Vide",
      preparing: "En préparation",
      preparing_on_chargement: "En préparation · sur chargement",
      ready: "Prêt",
      waiting_shipment: "En attente d'expédition",
      shipped: "Expédiée",
    },
    articles: "article(s)",
    weight: {
      produits: "Brut Produits",
      tare: "Tare",
      brut: "Brut Total",
      missing: "Poids brut / UG non renseigné",
      edit_weight: "Éditer le poids brut / UG",
      enter_weight: "Saisir le poids brut / UG",
    },
    action: {
      mark_ready: "Déclarer Prêt",
      prepare: "Préparer",
      prepare_hint: "Cliquez sur un article pour ajouter des lots",
      edit_palette: "Modifier l'unité d'expédition",
      fiche: "Fiche d'expédition",
      print_sscc: "Imprimer SSCC",
      edit_unit: "Modifier l'unité",
      resume_preparation: "Reprendre préparation",
      expedier: "Vers expédition",
      change_expedition: "Changer d'expédition",
      remove_from_expedition: "Retirer de l'expédition",
      link_expedition: "Lier à une expédition",
      remove_from_bl: "Retirer",
    },
    alert: {
      dlc_expired: "DLC dépassée",
      dlc_warning: "DLC proche",
      weight_missing: "poids brut / UG manquant",
    },
    timeline: {
      created_by: "Créé par",
      empty: "En attente de préparation",
    },
    expired_badge: "PÉRIMÉ",
    shipped_on: "Expédiée le",
    no_articles: "Aucun article",
    lots: "Lots",
    expedition_pending: "Expé. à prévoir",
    delete_confirm:
      "Vous êtes sur le point de supprimer cette unité d'expédition. Confirmez-vous ?",
    delete_title: "Suppression",
    controle_pod: "Voir le contrôle POD",
    controles: "Contrôles",
    print_bl: "Imprimer le BL",
    print_bt: "Imprimer le BT",
    route_shipped: "Expédié",
    route_waiting: "En chargement",
    no_expedition: "Pas encore d'expédition prévue",
    departure_planned: "Départ prévu :",
  },
  chargements: {
    historique_empty: "Aucun chargement dans l'historique",
    filter_search: "Rechercher (destinataire, unité d'expédition, produit...)",
    filter_transporteur: "Transporteur",
    filter_etat: "État",
    filter_dates: "Date",
    filter_clear: "Effacer",
    clear_selection: "Effacer la sélection",
    show_more: "Afficher plus",
  },
  chargement_timeline: {
    palettes: "unités d'expédition",
    colis: "colis",
    poids: "poids total",
  },
  expedies_filters: {
    transporteur: "Transporteur",
    etat: "État",
  },
  status_timeline: {
    start: "Créé",
    no_event_yet: "Aucun événement pour cette étape",
  },
  cc_timeline: {
    title: "Historique",
    empty: "Aucun événement enregistré pour cette commande.",
  },
  cf_timeline: {
    title: "Historique",
    empty: "Aucun événement enregistré pour cette commande.",
  },
  of_timeline: {
    title: "Historique",
    empty: "Aucun événement enregistré pour cet OF.",
  },
  specification_timeline: {
    title: "Historique de l'article",
    empty: "Aucune version enregistrée pour cet article.",
  },
  facture_timeline: {
    title: "Historique",
    empty: "Aucun événement enregistré pour ce document.",
    facture_created: "Facture créée",
    avoir_created: "Avoir créé",
    facture_emitted: "Facture émise",
    avoir_emitted: "Avoir émis",
    paiement: "Paiement reçu",
    avoir_linked: "Avoir émis",
    facture_parent: "Facture d'origine",
    open_facture_tooltip: "Cliquer pour ouvrir le PDF de la facture",
    settled: "Facture soldée",
    cancelled: "Facture annulée",
  },
  bls_filters: {
    state: "État",
    period: "Période",
    tiers: "Client / Tiers",
    entrepot_source: "Entrepôt de départ",
    adresse_destination: "Adresse destination",
    chargement: "Chargement",
    facture: "Facture",
    include_archived: "Inclure les BLs annulés",
  },
  bls_list: {
    export_excel: "Exporter vers Excel",
    export_excel_tooltip:
      "Exporter tous les BLs filtrés dans un fichier Excel formaté (totaux, formules, branding JustUp)",
    bulk_print: "Télécharger PDF",
    bulk_print_tooltip:
      "Télécharge un ZIP contenant un PDF par BL sélectionné (un fichier nommé par numéro de BL)",
    bulk_print_select_first:
      "Sélectionnez au moins un BL dans la liste (cochez la case à gauche) pour activer le téléchargement groupé",
    bulk_print_success: "{count} BLs téléchargés dans le ZIP",
    bulk_print_error: "Échec du téléchargement groupé. Réessayez ou consultez les logs.",
    clear_selection: "Désélectionner",
    column_numero: "N° BL",
    column_date: "Date",
    column_tiers: "Client",
    column_adresse: "Destination",
    column_entrepot: "Entrepôt départ",
    column_commandes: "Commandes",
    column_chargement: "Chargement",
    column_facture: "Facture",
    column_etat: "État",
    column_poids: "Poids brut",
    column_palettes: "Unités",
    column_actions: "",
    empty: "Aucun bon de livraison",
    open_detail: "Voir le détail",
    print_pdf: "Imprimer le BL",
  },
  chargement_display: {
    title: "Chargement du",
    transporteur: "Transporteur:",
    no_transporteur: "Transporteur non défini",
    print_fiches: "Imprimer les fiches d'unités d'expédition",
    add_palettes: "Ajouter des unités d'expédition",
    export_pdf: "Exporter en PDF",
    print_bls: "Imprimer les BL",
    print_bls_all: "Imprimer tous les BL",
    print_bl_single: "#numero",
    print_bts: "Imprimer les BT",
    declare_all_palettes_ready: "Tout déclarer Prêt",
    declare_all_palettes_ready_success: "Toutes les unités d'expédition sont déclarées prêtes",
    empty_units_title: "Aucune unité d'expédition",
    empty_units_message: "Ce chargement ne contient aucune unité d'expédition. Ajoutez-en au moins une avant de pouvoir le charger.",
    declare_ready: "Déclarer comme prêt",
    ready_to_load: "Prêt à charger",
    load: "Charger",
    resume_load: "Reprendre le chargement",
    loading_in_progress: "Chargement en cours",
    no_palettes: "Aucune unité d'expédition associée",
    departure_planned: "Départ prévu :",
    add_palette_short: "Unité d'Expédition",
    no_entrepot: "Entrepôt non défini",
    view_detail: "Voir le détail",
    cancel: "Annuler le chargement",
    cancel_title: "Annuler le chargement #num",
    cancel_message:
      "Le chargement repassera en préparation. Les unités d'expédition restent attachées et prêtes, et les numéros de bon de livraison sont conservés. Les contrôles généraux et palettes scannées dans l'étape d'expédition seront effacés. Confirmer l'annulation ?",
    cancel_confirm: "Confirmer l'annulation",
    delete_empty: "Supprimer le chargement",
    delete_title: "Supprimer le chargement #num",
    delete_message:
      "Ce chargement est vide (aucune unité d'expédition). Il sera supprimé définitivement. Confirmer ?",
    delete_confirm: "Supprimer",
    pret_title: "Déclarer prêt le chargement #num",
    pret_message:
      "Le chargement va passer en état \"Prêt à charger\". Les numéros de bons de livraison seront générés. Confirmer ?",
    pret_message_with_pending:
      "#count unité(s) d'expédition encore en préparation. En continuant, elles seront automatiquement marquées comme prêtes et le chargement passera en état \"Prêt à charger\".",
    pret_confirm: "Confirmer",
    pret_confirm_with_ready: "Marquer prêtes et continuer",
    livraisons_count: "#count livraisons",
    sites_count: "#count sites",
  },
  chargement_form: {
    title_new: "Nouvelle préparation d'expédition",
    title_edit: "Chargement du",
    today: "Aujourd'hui",
    tomorrow: "Demain",
    after_tomorrow: "Après-demain",
    next_monday: "Lundi",
    create_and_add: "Créer et ajouter des unités d'expédition",
    entrepot_source: "Entrepôt de départ",
    entrepot_readonly: "Retirez les unités d'expédition pour changer d'entrepôt",
  },
  navbar: {
    reconnect: "Veuillez vous reconnecter",
    reading_badge: "Lecture du badge en cours...",
    scan_badge: "Scanner un badge",
    dark_mode: "Mode sombre",
    light_mode: "Mode clair",
    all_warehouses: "Tous les entrepôts",
  },
  user_card: {
    my_profile: "Mon profil",
    report_problem: "Signaler un problème",
    bug_title: "Vous avez rencontré un bug ?",
    bug_desc1:
      "Nous faisons le maximum pour corriger les problèmes rapidement.",
    bug_desc2:
      "Pour cela, chaque information est précieuse. N'hésitez pas à nous signaler ce qui ne fonctionne pas.",
    recording_desc1: "Vous pouvez activer l'enregistrement de votre session",
    recording_desc2:
      "Une fois l'enregistrement activé, essayez de reproduire le bug : cela nous aidera à mieux comprendre ce qui s'est passé.",
    recording_desc3: "Ensuite, contactez-nous via le chat.",
    open_chat: "Ouvrir le chat de support",
  },
  substep_validation: {
    errors_title: "Vous avez des erreurs:",
    errors_blocking: "Les erreurs sont bloquante pour la validation de l'opé.",
    warnings_title: "Vous avez des avertissements:",
    warnings_not_blocking:
      "Les avertissements ne sont pas bloquants pour la validation de l'opé.",
    step_validation_title: "Validation de l'étape #name",
    no_record_for_control: "Aucun enregistrement pour le contrôle #name",
    control_matrix_in_progress:
      "La matrice de contrôle est toujours en cours, souhaitez vous la terminer ?",
    control_matrix_not_started: "La matrice de contrôle n'a pas été démarrée",
  },
  ips_input: {
    local: "locales",
    authorized: "autorisées",
    add_ip: "Ajouter une ip",
  },
  smtp_form: {
    delete_smtp: "Supprimer le SMTP",
  },
  search_bar: {
    no_result: "Aucun résultat",
    min_chars: "Saisir au moins 3 caractères",
  },
  qr_link: {
    creating: "Création du lien....",
  },
  arborescence_etape: {
    etapes: "Etapes",
  },
  tags: {
    add_placeholder: "Ajouter un tag ...",
  },
  user_infos_select: {
    label: "Utilisateurs:",
    add_user: "Ajouter un utilisateur",
  },
  widget_title: {
    theme: "Thème",
    remove: "Retirer",
  },
  week_loader: {
    week: "Semaine",
  },
  multi_date: {
    date_interval: "Interval de date",
  },
  multi_checkbox: {
    all: "Toutes",
  },
  input_search_dialog: {
    placeholder: "Rechercher...",
  },
  embedded_expression: {
    size: "Taille",
    alignment: "Alignement",
  },
  intext_embedded: {
    dynamic_values: "Valeurs dynamiques",
  },
  select_autocomplete: {
    suggestions: "Suggestions:",
  },
  chargement_selector: {
    title: "Sélectionner un chargement",
  },
  cursor_tooltip_dialog: {
    title: "Ajouter une valeur dynamique",
  },
  article_badges: {
    traca: "Traça",
    pdc: "PDC",
    consos: "Consos",
    auto: "Auto",
  },
  sankey: {
    zoom_in: "Zoom +",
    zoom_out: "Zoom -",
    recenter: "Recentrer",
    fullscreen: "Plein écran",
  },
  dynamic_text: {
    general_elements: "Éléments généraux",
    operators: "Opérateurs",
    nomenclature_elements: "Éléments liés à la nomenclature",
    nomenclature_variable_elements: "Éléments variables liés à la nomenclature",
    variables: "Variables",
    documents: "Documents",
    formula: "Formule",
    drop_in_formula: "Déposez l'élément dans la formule",
  },
  bon_livraison_display: {
    provisional: "Bon de livraison provisoire",
    provisional_short: "BL provisoire",
    print_bl: "Imprimer le BL",
    print_fiches: "Fiches",
  },
  bon_transfert_display: {
    provisional: "Bon de transfert provisoire",
    transfer_number: "Transfert N°",
    print_bt: "Imprimer le BT",
    print_fiches: "Fiches",
  },
  errors: {
    ARTICLE: {
      HAS_MOUVEMENTS: "Impossible de supprimer cet article : il possède des mouvements de stock",
    },
    EXPEDITION_UNIT_TYPE: {
      SAVE_FAILED: "Impossible de sauvegarder le type d'unité d'expédition",
      DELETE_FAILED: "Impossible de supprimer le type d'unité d'expédition",
      DENOMINATION_REQUIRED: "La dénomination est obligatoire",
      NOT_FOUND: "Type d'unité d'expédition introuvable",
    },
    FACTURE: {
      NOT_FOUND: "Facture introuvable",
      ALREADY_ISSUED: "Cette facture est déjà émise.",
      EMPTY: "Impossible de figer une facture vide.",
      ADDRESS_REQUIRED: "Veuillez sélectionner l'adresse de facturation",
      RIB_REQUIRED: "Veuillez sélectionner un RIB pour cette facture",
      CHRONOLOGICAL_INCONSISTENCY:
        "Incohérence chronologique (#kind) : la date d'émission #emissionDate est antérieure à celle du dernier document émis #lastNumero (#lastDate).",
      BL_INVALID: "BL invalide",
      BL_ID_MISSING: "BL id manquant",
      RECOMPUTE_LOCKED:
        "Impossible de recalculer une facture qui n'est plus en rédaction",
    },
    QR: {
      MISSING_EAN14:
        "Impossible de construire le code barre car il manque l'EAN14 dans l'article",
      MISSING_LOT_NUMBER:
        "Impossible de construire le code barre car il manque le numéro de lot",
      MISSING_PROD_DATE:
        "Impossible de construire le code barre car il manque la date de fabrication du lot",
      MISSING_DLUO:
        "Impossible de construire le code barre car il manque la DLUO du lot",
      MISSING_COUNT:
        "Impossible de construire le code barre car il manque la quantité contenue par l'unité d'expédition",
      MISSING_NET_WEIGHT:
        "Impossible de construire le code barre car il manque le poids net de l'article",
      MISSING_LOGISTIC_WEIGHT:
        "Impossible de construire le code barre car il manque le poids logistique de l'article",
    },
    PALETTE: {
      NOT_FOUND_SSCC: "Aucune unité d'expédition n'a été trouvée pour ce SSCC",
      ALREADY_IN_BL: "L'unité d'expédition est déjà présente dans un autre BL",
      EMPTY:
        "Impossible d'éditer la fiche d'expédition d'une unité d'expédition vide",
      SELECT_AT_LEAST_ONE:
        "Veuillez sélectionner au moins une unité d'expédition",
      TRANSFERT_NOT_FOUND: "Le transfert entrepôt est introuvable",
      ALREADY_SHIPPED: "L'unité d'expédition #sscc a déjà été expédiée",
    },
    TRANSFERT_ENTREPOT: {
      DUPLICATE_ARTICLE: "L'article (et le lot) est déjà dans le transfert",
      VALIDATION_DATE_REQUIRED: "Veuillez saisir la date de validation",
      EMPTY: "Le transfert doit contenir au moins une ligne",
      MUST_BE_AWAITING_SHIPMENT:
        "Le transfert doit être en attente d'expédition",
      MUST_BE_SHIPPED_OR_PARTIAL:
        "Le transfert doit être en état 'Expédiée' ou 'Transférée partiellement'",
      NO_RECEPTION:
        "Aucune réception saisie. Veuillez effectuer le déchargement et la réception avant de confirmer.",
      QUANTITY_REQUIRED: "Veuillez saisir une quantité pour chaque ligne",
      MISMATCH: "Erreur de transfert",
      NOT_FOUND: "Transfert introuvable",
      NO_MOVEMENTS: "Aucun mouvement à traiter",
      NO_LOTS_TO_SHIP: "Aucun lot à expédier",
      ZONE_NOT_FOUND: "Zone de transfert introuvable pour ce transfert",
      STOCK_NOT_FOUND: "Stock introuvable",
      ARTICLE_NOT_RESOLVED: "Impossible de déterminer l'article du stock",
    },
    CHARGEMENT_EMPTY:
      "Impossible de déclarer le chargement prêt : aucune unité d'expédition associée.",
    CHARGEMENT_PALETTES_NOT_READY:
      "Impossible de déclarer le chargement prêt : certaines unités d'expédition ne sont pas prêtes.",
    EXPEDITION_COMMANDE: {
      NOT_FOUND: "Commande client introuvable",
      NO_MOVEMENTS: "Aucun mouvement à traiter",
      NO_LOTS_TO_SHIP: "Aucun lot à expédier",
      COMMANDE_NOT_FOUND: "Commande client introuvable",
      STOCK_NOT_FOUND: "Stock introuvable",
    },
    LOT: {
      NOT_FOUND: "Lot introuvable",
      INVALID_PAYLOAD: "Aucun lot fourni pour la sauvegarde",
      DUPLICATE_NUMBER:
        "Un lot existe déjà avec ce numéro, veuillez en saisir un autre",
      ARTICLE_NOT_FOUND_BY_EAN:
        "Aucun article n'a pu être identifié avec cet EAN14",
      SPECIFICATION_NOT_FOUND:
        "La spécification pour cet article est introuvable",
      FICHE_PALETTE_NO_LOT:
        "Impossible de construire la fiche d'unité d'expédition, car aucun lot n'a été fourni",
    },
    LOT_MOUVEMENT: {
      NULL_MOVEMENT_LIST: "Aucun mouvement à traiter",
      NULL_MOVEMENT: "Il y a un mouvement NULL",
      MISSING_DESTINATION_ADDRESS: "Adresse de destination manquante",
      MISSING_LOT: "Lot manquant pour la réception",
      MISSING_ARTICLE: "Article manquant pour la réception",
      ZERO_QUANTITY: "Veuillez renseigner une quantité non nulle",
      MISSING_DEPARTURE_STOCK: "Stock de départ manquant",
      DEPARTURE_STOCK_NOT_FOUND: "Stock de départ introuvable",
      MISSING_ARTICLE_REGROUPEMENT: "Article manquant pour le regroupement",
      MISSING_STOCK_OR_ADDRESS:
        "Stock ou adresse + lot manquant pour l'inventaire",
      MISSING_OF_REFERENCE: "Référence OF manquante pour la fabrication",
      MISSING_ARTICLE_OR_LOT:
        "Article ou lot manquant pour la création/fabrication",
      MISSING_LOT_SELECTION: "Lot non sélectionné pour le transfert",
      MISSING_PALETTE_OR_ADDRESS:
        "Unité d'expédition ou adresse d'arrivée manquante",
      MISSING_COMMANDE_CLIENT:
        "Commande client manquante pour la préparation d'expédition",
      SAME_STOCK_TRANSFER: "Impossible de transférer vers le même stock",
      INSUFFICIENT_DEPARTURE_STOCK:
        "Stock de départ insuffisant pour le transfert",
      MISSING_DESTRUCTION_PARAMS: "Paramètres manquants pour la destruction",
      INSUFFICIENT_STOCK_DESTRUCTION: "Stock insuffisant pour la destruction",
      MISSING_DELIVERY_PARAMS: "Paramètres manquants pour la livraison",
      INSUFFICIENT_STOCK_DELIVERY: "Stock insuffisant pour la livraison",
      MISSING_SUPPLIER_RETURN_PARAMS:
        "Paramètres manquants pour le retour fournisseur",
      INSUFFICIENT_STOCK_SUPPLIER_RETURN:
        "Stock insuffisant pour le retour fournisseur",
      MISSING_CLIENT_RETURN_PARAMS:
        "Paramètres manquants pour le retour client",
      MISSING_CONSO_FAB_PARAMS:
        "Paramètres manquants pour la consommation fabrication",
      CONSO_FAB_STOCK_NOT_FOUND:
        "Stock de consommation fabrication introuvable",
      INSUFFICIENT_STOCK_CONSO_FAB:
        "Stock insuffisant pour la consommation fabrication",
      MISSING_EXPEDITION_PARAMS: "Paramètres manquants pour l'expédition",
      INSUFFICIENT_STOCK_EXPEDITION: "Stock insuffisant pour l'expédition",
      MISSING_EXPEDITION_TRANSFERT_PARAMS:
        "Paramètres manquants pour l'expédition transfert",
      MISSING_TRANSFER_ZONE_ADDRESS: "Adresse de zone de transfert manquante",
      MISSING_OWNER_CHANGE_QUANTITY:
        "Quantité manquante pour le changement de propriétaire",
      MISSING_NEW_OWNER:
        "Nouveau propriétaire manquant pour le changement de propriétaire",
      LOT_NOT_FOUND: "Lot introuvable",
      ARTICLE_NOT_FOUND: "Article introuvable pour ce lot",
      INSUFFICIENT_ARTICLE_STOCK: "Stock insuffisant pour cet article",
      MISSING_DEPARTURE_STOCK_FOR_LOT:
        "Stock de départ requis pour un article géré par lot",
      LOT_STOCK_NOT_FOUND: "Aucun stock trouvé pour ce lot à cette adresse",
      INSUFFICIENT_LOT_STOCK: "Stock insuffisant pour ce lot",
    },
    AUTH: {
      TOO_MANY_ATTEMPTS:
        "Vous avez dépassé le nombre de tentatives autorisées. Veuillez réessayer dans #remainingSeconds secondes",
      IP_NOT_ALLOWED: "Adresse IP non autorisée",
      LOGIN_REQUIRED: "Veuillez vous connecter avec vos identifiants",
      CREDENTIALS_REQUIRED: "Login et mot de passe requis",
    },
    TIERS: {
      IMPORT_MAINTENANCE: "Import ARTICLE FOURNI en maintenance",
      GROUPS_NOT_FOUND: "Groupe(s) introuvable(s)",
      CODE_INVALID_FORMAT:
        "Référence tiers invalide : seuls les lettres et les chiffres sont acceptés",
      CODE_DUPLICATE: "Cette référence est déjà utilisée par un autre tiers",
    },
    TRANSACTION: {
      NOT_FOUND: "Transaction introuvable",
      PAYMENT_NOT_FOUND: "Paiement introuvable",
      FACTURE_NOT_FOUND: "Facture introuvable",
      INVALID_AMOUNT: "Le montant de la transaction doit être supérieur à 0",
      INVALID_PAIEMENT_AMOUNT:
        "Le montant de chaque paiement doit être supérieur à 0",
    },
    BON_TRANSFERT: {
      NOT_FOUND: "Bon de transfert introuvable",
    },
    BON_LIVRAISON: {
      NOT_FOUND: "Bon de livraison introuvable",
    },
    COMMANDE: {
      DUPLICATE_ARTICLE: "L'article est déjà dans la commande",
      ERROR: "Erreur de commande",
    },
    POSTE: {
      CANNOT_DELETE_COMPLETED: "Impossible de supprimer un poste terminé",
    },
    INVENTAIRE: {
      EMPTY: "L'inventaire est vide",
    },
    INTEGRATIONS: {
      NOT_FOUND: "L'intégration n'existe pas",
    },
    CRENEAU: {
      NO_SCHEDULE_FOUND: "Aucun horaire trouvé",
    },
    TRAVAIL: {
      DURATION_REQUIRED: "Veuillez saisir la durée pour #label",
    },
  },
  stats: {
    ca_cumule: "CA cumulé",
    ca_par_periode: "CA par période",
    repartition_ventes: "Répartition des ventes par client",
    repartition_achats: "Répartition des achats par fournisseur",
    repartition_marges_client: "Répartition des marges par client",
    repartition_marges_article: "Répartition des marges par article",
    repartition_consos: "Répartitions des consommations par produit fabriqué",
    synthese_mouvements: "Synthèse des mouvements",
    heures_par_user: "Heures travaillées par utilisateur",
    liste_ofs: "Liste des OFs",
    stock_actuel: "Stock actuel",
    quick_wins: "Quick wins",
    evolution_prix_vente: "Évolution prix de vente (moyenne pondérée)",
    evolution_prix_achat: "Évolution prix d'achat (moyenne pondérée)",
    repartition_articles_achetes:
      "Répartition des articles achetés (par tiers)",
    date_interval: "Interval de date",
    no_article_matching: "Aucun article correspondant",
    commande_placeholder: "Commande n°…",
    client_placeholder: "Nom client…",
    fournisseur_placeholder: "Nom fournisseur…",
    reference_placeholder: "Référence / libellé…",
    of_placeholder: "OF n°, article, lot…",
  },
  dashboard_ui: {
    parametres: "Paramètres",
    actualiser: "Actualiser les widgets",
    ca_cumule_info:
      "Somme du total HT signé de toutes les factures émises (avoirs déduits). Les factures provisoires (non figées) sont exclues. Inclut les lignes saisies hors expédition (frais de port, prestations).",
    repartition_ca_info:
      "Le CA inclut toutes les lignes facturées (avoirs déduits). La marge n'est calculée que sur les lignes rattachées à une expédition (lot + coût traçables). Si une partie du CA vient de lignes hors expédition, le label marge précise la couverture.",
    modules: "Modules",
    ajoute: "ajouté",
    ajouter_widget: "ajouter",
    par_defaut: "Dashboard par défaut",
    mon_dashboard: "Mon Dashboard",
    reinitialiser: "Réinitialiser mon dashboard",
    specifications: "Spécifications",
    productivite: "Productivité",
    heures_travaillees: "Heures travaillées",
    ofs_en_cours: "OFs en cours",
    ca_par_periode: "CA par période",
    ofs_en_attente: "OFs en attente",
    valeur_stock: "Valeur stock:",
    ca_cumule: "CA cumulé",
    ca_nmoins: "CA N vs N-1",
    delta_treso: "Delta tréso",
    repartition_ca: "CA",
    commandes_clients: "Commandes clients",
    commandes_fournisseurs: "Commandes fournisseurs",
    status_ofs: "Status des OFs",
    lots_par_etat: "Lots par état",
    repartition_defauts: "Répartition des défauts",
    repartition_temps: "Répartition du temps",
    granularite: "Granularité",
    echelle: "Échelle",
    comparaison: "Comparaison",
    aucune: "Aucune",
    n_moins_1: "N-1",
    periode_precedente: "Préc.",
    jour: "j",
    semaine: "s",
    mois: "m",
    annee: "a",
    quantite_produite_periode: "Quantité produite par période",
    toutes_lignes: "Toutes",
    ligne: "Ligne",
    cf_envoi: "À envoyer",
    cf_confirmation: "À confirmer",
    cf_livraison: "À livrer",
    cf_livree_partiel: "Livrée partiel.",
    cc_traitement: "À traiter",
    cc_preparation: "À préparer",
    cc_partielle: "Expédition partielle",
    of_prod: "Prod.",
    of_en_prod: "En cours",
    of_planif: "Planification",
    of_validation: "Validation",
    of_bilan_matiere: "Bilan matière",
    of_reintegration: "Réintégration",
    spec_redigees: "Rédigées",
    spec_validees: "Validées",
    valeur_totale: "Valeur totale",
    concentration: "Concentration 80%",
    concentration_desc: "représentent 80% de la valeur",
    moyenne: "Moy.",
    top: "Top",
    export_excel: "Exporter vers Excel",
    cat_production: "Production",
    cat_financier: "Financier",
    cat_commandes: "Commandes",
    cat_stock: "Stock",
    cat_supervision: "Supervision",
    cat_ligne: "Ligne",
    cat_qualite: "Qualité",
    w_productivite_moyenne: "Productivité moyenne",
    w_productivite_moyenne_desc: "Score de productivité moyen par ligne, calculé sur les OFs réalisés",
    w_ofs_en_cours: "OFs en cours",
    w_ofs_en_cours_desc: "Ordres de fabrication en production, regroupés par ligne",
    w_heures_travaillees: "Heures travaillées",
    w_heures_travaillees_desc: "Heures cumulées par utilisateur, avec détail par travail",
    w_quantite_ofs: "OFs par état",
    w_quantite_ofs_desc: "Nombre d'ordres de fabrication par état et par mois",
    w_ofs: "Liste des OFs",
    w_ofs_desc: "Liste filtrable des OFs (en attente, planif, validation, réintégration…)",
    w_specifications: "Spécifications",
    w_specifications_desc: "Liste filtrable des spécifications (rédigées, validées)",
    w_quantite_produite_periode: "Quantité produite par période",
    w_quantite_produite_periode_desc: "Volumes produits par ligne et par période, avec comparaison N-1",
    w_ca_cumule: "CA cumulé",
    w_ca_cumule_desc: "Chiffre d'affaires HT cumulé sur la période sélectionnée",
    w_ca_par_periode: "CA par période",
    w_ca_par_periode_desc: "CA HT par période, comparable à N-1 ou à la période précédente",
    w_ca_delta: "Évolution CA (delta)",
    w_ca_delta_desc: "Variation du CA d'une période à l'autre (positif/négatif)",
    w_ca_n_moins_1: "Comparaison CA N vs N-1",
    w_ca_n_moins_1_desc: "Évolution du CA cumulé cette année comparé à l'année précédente",
    w_repartition_par_client: "Répartition par client",
    w_repartition_par_client_desc: "Part du CA par client (top clients en doughnut)",
    w_commandes_fournisseurs: "Commandes fournisseurs",
    w_commandes_fournisseurs_desc: "Liste des commandes fournisseurs filtrable par état",
    w_commandes_clients: "Commandes clients",
    w_commandes_clients_desc: "Liste des commandes clients filtrable par état",
    w_couverture_commandes: "Couverture des commandes",
    w_couverture_commandes_desc:
      "Ai-je assez de stock pour servir les commandes en attente ? (manque / à réserver / couvert)",
    w_valeur_par_famille: "Valeur stock par famille",
    w_valeur_par_famille_desc: "Répartition de la valeur stock par famille d'articles",
    w_evolution_valeur: "Évolution valeur stock",
    w_evolution_valeur_desc: "Suivi de la valeur globale du stock dans le temps (jour, semaine, mois)",
    evolution_valeur_title: "Évolution valeur stock",
    evolution_valeur_delta_30j: "Variation 30j :",
    evolution_valeur_partial_history: "Données disponibles depuis le #since",
    evolution_valeur_single_point: "Un seul snapshot pour l'instant — la courbe se construira dans les prochains jours",
    evolution_valeur_empty: "Pas encore de données d'évolution",
    evolution_valeur_empty_hint: "Cliquez sur l'icône Actualiser pour créer le premier snapshot.",
    evolution_valeur_refreshed: "Snapshot enregistré (#count lignes)",
    evolution_valeur_backfilled: "Historique reconstruit sur #days jours (#count lignes, #mouvements mouvements pris en compte)",
    evolution_valeur_refresh: "Recalculer l'historique sur la plage sélectionnée",
    evolution_valeur_partial_warning: "L'historique stocké est incomplet sur cette plage.",
    evolution_valeur_recompute: "Recalculer",
    evolution_valeur_field_range: "Plage",
    evolution_valeur_field_granularity: "Granularité",
    evolution_valeur_field_dimension: "Dimension",
    evolution_valeur_field_filter: "Filtrer",
    evolution_valeur_col_dim: "Dimension",
    evolution_valeur_col_current: "Valeur actuelle",
    evolution_valeur_col_delta: "Variation période",
    evolution_valeur_export: "Exporter en Excel (toutes dimensions, multi-feuilles)",
    w_lot_par_etat: "Lots par état",
    w_lot_par_etat_desc: "Lots non conformes et lots avec DLUO dépassée, avec stocks restants",
    w_planning: "Planning (Activité à venir)",
    w_planning_desc: "Vue calendaire transversale : commandes fournisseurs/clients, OF, réceptions, expéditions…",
    w_live_production: "Live Production",
    w_live_production_desc: "Supervision atelier en temps réel : état des lignes, cadence, OF, conducteurs. Bouton fenêtre détachée pour 2e écran.",
    w_quantite_produite: "Quantité produite",
    w_quantite_produite_desc: "Volumes produits par cette ligne au fil du temps",
    w_main_oeuvre: "Main d'œuvre",
    w_main_oeuvre_desc: "Heures de main d'œuvre par utilisateur sur cette ligne",
    w_productivite_ligne: "Productivité",
    w_productivite_ligne_desc: "Évolution mensuelle du score de productivité de la ligne",
    w_couts_matiere_personnel: "Coûts matière / personnel",
    w_couts_matiere_personnel_desc: "Décomposition mensuelle des coûts matière et personnel",
    w_ofs_ligne: "OFs de la ligne",
    w_ofs_ligne_desc: "Liste triable des OFs réalisés sur cette ligne",
    w_articles_produits: "Articles produits",
    w_articles_produits_desc: "Top 12 des articles produits sur cette ligne (en quantité)",
    w_nc_stats: "Non-conformités (synthèse)",
    w_nc_stats_desc: "Volume des NC, origine (fournisseur / interne) et gravité",
    w_nc_closure_metrics: "Taux de clôture NC",
    w_nc_closure_metrics_desc: "Taux de clôture, délai moyen et SLA J+30 des non-conformités",
    w_nc_supplier_compliance: "Conformité fournisseurs",
    w_nc_supplier_compliance_desc: "Top des fournisseurs avec le plus de NC sur la période",
    w_certificat_bio_echeance: "Certificats bio",
    w_certificat_bio_echeance_desc: "Certificats bio arrivant à échéance",
    nc_kpi_ouvertes: "Ouvertes",
    nc_kpi_critiques: "Critiques ouvertes",
    nc_kpi_total: "Total période",
    nc_kpi_cout: "Coût période",
    nc_kpi_taux_echappees: "Taux d'échappées",
    nc_kpi_taux_echappees_hint: "% NC détectées par un tiers externe — KPI ISO 9001",
    nc_kpi_taux_cloture: "Taux de clôture",
    nc_kpi_delai_moyen: "Délai moyen",
    nc_kpi_sla_j30: "SLA J+30",
    nc_kpi_sla_j30_hint: "% NC clôturées sous 30 jours sur le total créé",
    nc_kpi_taux_conformite: "Taux conformité",
    nc_origine_interne: "Interne",
    nc_origine_externe: "Externe",
    nc_origine_mixte: "Mixte",
    nc_origine_non_renseigne: "Non renseigné",
    nc_titre_origine: "Origine des NC",
    nc_titre_type_gravite: "Type × Gravité",
    nc_titre_evolution: "Évolution mensuelle",
    nc_titre_top_tiers: "Top tiers",
    nc_titre_top_articles: "Top articles",
    nc_titre_critiques: "NC critiques ouvertes",
    nc_titre_par_decision: "Délai par décision",
    nc_titre_pires: "Pires fournisseurs",
    nc_titre_meilleurs: "Meilleurs fournisseurs",
    nc_unite_jours: "j",
    nc_decision_acceptation_derogation: "Acceptation / dérogation",
    nc_decision_retouche: "Retraitement",
    nc_decision_rebut: "Rebut",
    nc_decision_retour_fournisseur: "Retour fournisseur",
    nc_decision_non_renseignee: "Non renseignée",
  },
  stats_ligne: {
    aucune_ligne: "Aucune ligne correspondante",
    interval_date: "Intervalle de date",
    aucune_donnee: "Aucune donnée",
    stats_ligne_exercice_en_cours: "Exercice en cours",
    stats_ligne_exercice_passe: "Exercice passé",
    stats_ligne_tout: "Tout",
    utilisateur: "Utilisateur",
    duree: "Durée",
    part: "Part",
    of: "OF",
    article: "Article",
    quantite: "Quantité",
    date_fin: "Date fin",
    score: "Score",
    quantite_produite_ligne: "Quantité produite",
    main_oeuvre_ligne: "Main d'œuvre",
    productivite_ligne: "Productivité",
    couts_ligne: "Coûts matière / personnel",
    ofs_ligne: "OFs de la ligne",
    articles_produits_ligne: "Articles produits",
    aide_quantite_produite:
      "Somme des <span class='bold'>quantités produites</span> de chaque OF clôturé sur la ligne, agrégée par période et regroupée par <span class='bold'>unité de gestion</span> de l'article.",
    aide_quantite_produite_formule:
      "Pour chaque période :<br/><span class='aide-formula'>Total = Σ quantiteProduite (OFs)</span><br/>Utilisez le sélecteur d'unité pour filtrer par type de produit (Kg, L, etc.).",
    aide_main_oeuvre:
      "Répartition du <span class='bold'>temps de travail</span> saisi par opérateur sur les OFs de la ligne.",
    aide_main_oeuvre_formule:
      "Pour chaque opérateur :<br/><span class='aide-formula'>Durée = Σ durées des travaux</span><br/>Le pourcentage est calculé sur le total cumulé.",
    aide_productivite:
      "Score de productivité par mois, calculé en <span class='bold'>moyenne pondérée</span> par les quantités produites. Filtrable par unité de gestion.",
    aide_productivite_formule:
      "<span class='aide-formula'>Score mois = Σ(score × qté) / Σ(qté)</span><br/>" +
      "Les OFs avec de gros volumes pèsent davantage.<br/>" +
      "<span class='valid bold'>Vert</span> ≥ 95% · " +
      "<span class='warning bold'>Orange</span> 85–95% · " +
      "<span class='error bold'>Rouge</span> &lt; 85%",
    aide_couts:
      "Coûts <span class='bold'>matière</span> et <span class='bold'>personnel</span> cumulés par mois, empilés.",
    aide_couts_formule:
      "<span class='aide-formula'>Matière = Σ coûtMatièreRéel (ou théorique)<br/>Personnel = Σ coûtPersonnelRéel (ou théorique)</span><br/>" +
      "Les coûts réels sont prioritaires ; si absents, les coûts théoriques sont utilisés.",
    aide_ofs:
      "Liste de tous les <span class='bold'>OFs clôturés</span> sur la ligne dans la période sélectionnée.",
    aide_ofs_formule:
      "Triable par date de fin, quantité produite ou score. Cliquez sur une ligne pour accéder aux statistiques de l'OF.",
    aide_articles:
      "Répartition des <span class='bold'>quantités produites</span> par article sur la ligne (top 12).",
    aide_articles_formule:
      "<span class='aide-formula'>Part article = Σ quantitéProduite (article) / Σ total</span>",
    toutes: "Toutes",
    calcul: "Calcul",
    score_moyen: "Score moyen (%)",
    quantite_produite_chart: "Quantité produite",
    n_moins_1: "N-1",
    prec: "Préc.",
    label_quantite: "Quantité",
    label_matiere: "Matière",
    label_personnel: "Personnel",
    tri_date: "Date",
    tri_quantite: "Quantité",
    tri_score: "Score",
    tri_desc: "Desc",
    tri_asc: "Asc",
    tri_heures: "Tri Heures",
    tri_alpha: "Tri Alpha",
    inconnu: "Inconnu",
    autres: "Autres",
    heures: "Heures",
  },
  stats_user_infos: {
    aucun_operateur: "Aucun opérateur correspondant",
    heures_travaillees: "Heures travaillées",
    total: "Total",
    repartition_travail: "Répartition par type de travail",
    ofs_realises: "OFs réalisés",
    ligne: "Ligne",
    productivite: "Productivité",
    lignes_travaillees: "Lignes travaillées",
    articles_produits: "Articles produits",
  },
  expedition_commande: {
    maj_client: "Mettre à jour dans le client",
    lots_prepares: "Lots préparés",
    lots_reintegres: "Lots retirés de l'expédition",
  },
  horaires_form: {
    lundi: "Lundi",
    mardi: "Mardi",
    mercredi: "Mercredi",
    jeudi: "Jeudi",
    vendredi: "Vendredi",
    samedi: "Samedi",
    dimanche: "Dimanche",
    planning_perso: "Planning personnalisé",
    planning_defaut: "Planning par défaut",
    annuler_modification: "Annuler la modification",
    modifier: "Modifier",
  },
  logs_ui: {
    enregistrement_en_cours: "Enregistrement en cours...",
    enregistrement_info:
      "L'enregistrement de la session peut servir à des fins de debugage",
    arreter_enregistrement: "Arreter l'enregistrement",
  },
  lignes_progress: {
    expedie: "Expédié",
    en_expedition: "En attente d'expédition",
    sur_palette: "En cours de préparation",
    a_preparer: "à préparer",
    rupture: "Rupture de stock",
    stock_limite: "Stock limité",
    sur_entrepot: "sur",
    voir_autres_stocks: "Voir les autres stocks",
    ddm_depassee: "DDM/DLC dépassée",
    over_expedition: "Sur-expédition : +#quantite excédentaire(s)",
  },
  stock_entrepot: {
    title: "Stock par entrepôt",
    depart: "Entrepôt de départ",
    aucun_stock: "Aucun stock disponible",
    total: "Stock total",
    rupture_warning: "Rupture dans cet entrepôt.",
  },
  enums: {
    remise_type: {
      POURCENTAGE: "Pourcentage (%)",
      MONTANT_UNITAIRE: "Montant / unité (€/u)",
      MONTANT: "Montant fixe (€)",
    },
    type_controle: {
      QCM: "QCM",
      CNC: "Conforme / Non conforme",
      QUANTITATIF: "Quantitatif",
      MARQUAGE: "Marquage ou comparaison",
      ENREGISTREMENT: "Enregistrement",
      TRACABILITE: "Traçabilité",
    },
    element_type_controle: {
      LOT_RECEPTION: "Réception d'un lot",
      PREPARATION_EXPE: "Préparation d'une expé.",
      DECHARGEMENT: "Déchargement",
      EXPEDITION: "Chargement",
      LIBERATOIRE: "Libératoire",
      CHARGEMENT: "Chargement",
      PRODUCTION: "Production",
      START_OPE: "Démarrage d'une opé.",
      END_OPE: "Fin d'une opé.",
      START_OPE_GENERAUX: "Au démarrage de chaque opé.",
      END_OPE_GENERAUX: "A la fin de chaque opé.",
      LOT_RECEPTION_GENERAUX: "A chaque réception de lot",
      PREPARATION_EXPE_GENERAUX: "A chaque préparation d'expé.",
      DECHARGEMENT_GENERAUX: "A chaque déchargement",
      DECHARGEMENT_ARTICLE_GENERAUX: "A chaque article au déchargement",
      EXPEDITION_GENERAUX: "A chaque chargement",
      LIBERATOIRE_GENERAUX: "A chaque libération",
      CHARGEMENT_GENERAUX: "A chaque chargement",
      CHARGEMENT_ARTICLE_GENERAUX: "A chaque article au chargement",
      CHARGEMENT_UNITE_GENERAUX: "A chaque unité d'expédition au chargement",
      PRODUCTION_GENERAUX: "A chaque production",
      PROCESS: "Procédé",
      SUIVI_LOT: "Suivi de la vie du lot",
      CHECKLIST: "Checklist",
    },
    type_nominal: {
      SUP: "Supérieur à",
      INF: "Inférieur à",
      BETWEEN: "Entre minimum et maximum",
    },
    etat_specification: {
      ARCHIVED: "Archivée",
      EN_COURS: "Courante",
      EN_REDACTION: "En rédaction",
      REDIGEE: "Rédigée",
      VALIDEE: "Validée",
      APPROUVEE: "Approuvée",
    },
    specification_variable_type: {
      NUMBER: "Nombre",
      STRING: "Texte",
      DOCUMENT: "Document / Photo",
      NOMENCLATURE_ARTICLE: "Nomenclature optionnel",
      PROCESS_OPTIONAL: "Procédé optionnel",
    },
    transfert_entrepot_etat: {
      EN_REDACTION: "En rédaction",
      EN_ATTENTE_EXPEDITION: "En attente d'expédition",
      EXPEDIEE: "Expédiée",
      TRANSFEREE_PARTIELLEMENT: "Transférée partiellement",
      TERMINEE: "Terminée",
      ANNULEE: "Annulée",
      SOLDEE: "Soldée",
    },
    transfert_entrepot_mode: {
      SIMPLE: "Simple",
      AVEC_EXPEDITION: "Avec expédition",
    },
    commande_etat: {
      EN_REDACTION: "En rédaction",
      EN_ATTENTE_ENVOI: "En attente d'envoi",
      EN_ATTENTE_CONFIRMATION: "En attente de confirmation",
      EN_ATTENTE_LIVRAISON: "En attente de livraison",
      ANNULEE: "Annulée",
      LIVREE_PARTIELLEMENT: "Livrée partiellement",
      TERMINEE: "Terminée",
      SOLDEE: "Terminée (Soldée)",
    },
    commande_client_etat: {
      EN_REDACTION: "En rédaction",
      EN_ATTENTE_CONFIRMATION: "En attente de confirmation",
      EN_ATTENTE_CONFIRMATION_MODIFIED: "En attente de confirmation",
      EN_COURS_DE_TRAITEMENT: "En cours de traitement",
      EN_COURS_DE_PREPARATION: "En cours de préparation",
      PRETE: "Prête",
      EXPEDIE: "Expédiée",
      EXPEDIE_PARTIELLEMENT: "Expédiée partiellement",
      FACTURE_PARTIELLEMENT: "Facturée partiellement",
      FACTURE: "Facturée",
      ANNULEE: "Annulée",
      // Phase 4 : `TERMINE` = lifecycle clôturé. Règlement / facturation
      // sont des axes parallèles, ne pas mélanger dans le libellé.
      TERMINE: "Terminée",
    },
    etat_facture: {
      EN_REDACTION: "En rédaction",
      EMISE: "Émise",
      PARTIELLEMENT_REGLEE: "Partiellement réglée",
      REGLEE: "Réglée",
      ANNULEE: "Annulée",
      LITIGE: "Litige",
      PARTIELLEMENT_CONSOMME: "Partiellement consommé",
      CONSOMME: "Consommé",
    },
    etat_transaction: {
      NON_AFFECTE: "Non affecté",
      PARTIELLEMENT_AFFECTE: "Partiellement affecté",
      AFFECTE: "Affecté",
    },
    type_transaction: {
      CB: "Carte",
      VIREMENT: "Virement",
      CHEQUE: "Chèque",
      ESPECES: "Espèces",
      AUTRE: "Autre",
    },
    famille_article: {
      FINI: "Fini",
      SEMIFINI: "Semi-fini",
    },
    unite_gestion: {
      KG: "Kilo",
      G: "Gramme",
      T: "Tonne",
      ML: "Millilitre",
      L: "Litre",
      M3: "Mètre cube",
      UNITE: "Unité",
    },
    numero_complement: {
      BIS: "Bis",
      TER: "Ter",
      QUATER: "Quater",
    },
    periode_type: {
      FIN_DE_PERIODE: "Fin de période",
      NET: "Net",
    },
    type_tiers: {
      CLIENT: "Client",
      FOURNISSEUR: "Fournisseur",
      CLIENT_FOURNISSEUR: "Client et Fournisseur",
    },
    type_reglement: {
      ESPECE: "Espèce",
      VIREMENT: "Virement",
      PRELEVEMENT: "Prélèvement",
      TRAITE: "Traite",
      LCR: "LCR",
    },
    delai_reglement: {
      LIVRAISON: "A la livraison",
      COMMANDE: "A la commande",
      JOUR: "jours",
      FDM: "fin de mois",
      FDD: "fin de décade",
    },
    of_etat: {
      ANNULE: "Annulé",
      EN_ATTENTE_PLANNIF: "En attente de planification",
      EN_ATTENTE_PROD: "En attente de production",
      EN_ATTENTE_BILAN_MATIERE: "En attente du bilan matière",
      EN_PROD: "En production",
      EN_ATTENTE_REINTE_PDC: "En attente de réintégration",
      EN_ATTENTE_VALIDATION: "En attente de validation",
      VALIDE: "Terminé",
    },
    etat_poste: {
      CALAGE: "En cours de calage",
      EN_COURS: "En cours",
      TERMINEE: "Terminée",
      PENDING: "En attente",
      EN_ATTENTE_BILAN_MATIERE: "En attente du bilan matière",
    },
    type_mouvement: {
      RECEPTION: "Réception",
      RECEPTION_LOT_UNIQUE: "Réception (lot unique)",
      RECEPTION_NON_CONFORME: "Réception non conforme",
      INVENTAIRE: "Inventaire",
      FABRICATION_LOT_UNIQUE: "Fabrication (lot unique)",
      FABRICATION: "Fabrication",
      TRANSFERT: "Transfert",
      LIBERATION: "Libération",
      CREATION: "Création",
      LIBERATION_RECEPTION: "Libération réception",
      DESTRUCTION: "Destruction",
      LIVRAISON: "Livraison",
      RETOUR_FOURNISSEUR: "Retour fournisseur",
      RETOUR_CLIENT: "Retour client",
      CONSO_FAB: "Conso. fabrication",
      PIED_DE_CHAINE: "Mise en pied de chaîne",
      REINTE_PIED_DE_CHAINE: "Réintégration pied de chaîne",
      PREPA_EXPEDITION: "Préparation à l'expédition",
      REINTE_EXPEDITION: "Réintégration expédition",
      EXPEDITION: "Expédition",
      PREPA_TRANSFERT: "Préparation au transfert",
      REINTE_TRANSFERT: "Réintégration transfert",
      EXPEDITION_TRANSFERT: "Expédition transfert",
      REGROUPEMENT: "Regroupement",
      RAZ: "Remise à zéro",
      CHANGEMENT_PROPRIO: "Changement de propriétaire",
      INTEGRATION_EN_FABRICATION_LOT_UNIQUE:
        "Intégration en cours de fab. (Lot unique)",
      INTEGRATION_EN_FABRICATION: "Intégration en cours de fab.",
      REFUS_RECEPTION: "Refus de réception",
      CONSO_SUPPORT: "Consommation support expédition",
      REINTE_SUPPORT: "Réintégration support expédition",
      ENGAGEMENT_PREPA: "Réservation prépa",
      LIBERATION_PREPA: "Libération prépa",
      NC_TRANSFERT: "Mise en zone non conforme",
      NC_PDC: "Mise en zone NC (pied de chaîne)",
      FABRICATION_NC: "Fabrication non conforme",
      LIBERATION_NC: "Libération zone non conforme",
    },
    type_mouvement_short: {
      RECEPTION: "Réception",
      RECEPTION_LOT_UNIQUE: "Réception",
      RECEPTION_NON_CONFORME: "Réception NC",
      INVENTAIRE: "Inventaire",
      FABRICATION_LOT_UNIQUE: "Fabrication",
      FABRICATION: "Fabrication",
      TRANSFERT: "Transfert",
      LIBERATION: "Libération",
      CREATION: "Création",
      LIBERATION_RECEPTION: "Libération réception",
      DESTRUCTION: "Destruction",
      LIVRAISON: "Livraison",
      RETOUR_FOURNISSEUR: "Retour fournisseur",
      RETOUR_CLIENT: "Retour client",
      CONSO_FAB: "Conso. fab.",
      PIED_DE_CHAINE: "PDC",
      REINTE_PIED_DE_CHAINE: "Réinté. PDC",
      PREPA_EXPEDITION: "Prép. l'expé.",
      REINTE_EXPEDITION: "Réinté. expé.",
      EXPEDITION: "Expé.",
      PREPA_TRANSFERT: "Prép. transfert",
      REINTE_TRANSFERT: "Réinté. transfert",
      EXPEDITION_TRANSFERT: "Expé. transfert",
      REGROUPEMENT: "Regroupement",
      RAZ: "RAZ",
      CHANGEMENT_PROPRIO: "Changement de propriétaire",
      INTEGRATION_EN_FABRICATION_LOT_UNIQUE: "Inté. en fab.",
      INTEGRATION_EN_FABRICATION: "Inté. en fab.",
      REFUS_RECEPTION: "Refus réception",
      CONSO_SUPPORT: "Conso. support",
      REINTE_SUPPORT: "Réinté. support",
      ENGAGEMENT_PREPA: "Réservation",
      LIBERATION_PREPA: "Libération",
      NC_TRANSFERT: "Mise en zone NC",
      NC_PDC: "Zone NC (PDC)",
      FABRICATION_NC: "Fabrication NC",
      LIBERATION_NC: "Libération NC",
    },
    etat_palette: {
      PRETE: "Prête",
      EXPEDIEE: "Expédiée",
      EN_PREPARATION: "En cours de préparation",
    },
    etat_chargement: {
      EN_PREPARATION: "En cours de préparation",
      PRET: "Prêt pour le chargement",
      CHARGE: "Chargé",
    },
    sexe: {
      HOMME: "Homme",
      FEMME: "Femme",
    },
    type_comptage: {
      POIDS_SURREMBALLAGE: "Poids avec surremballage",
      DIMENSION: "Dimension / Poids",
      COMPTABLE_PACK: "Comptable (pack/colis)",
      SIMPLE: "Simple",
      ROULEAU_SURFACE: "Surface de rouleau",
      ROULEAU_LONGUEUR: "Longueur de rouleau",
    },
    ref_calcul: {
      LONGUEUR_UC: "Longueur (Unité conditionnée)",
      LARGEUR_UC: "Largeur (Unité conditionnée)",
      HAUTEUR_UC: "Hauteur (Unité conditionnée)",
      LONGUEUR_COLIS: "Longueur (Colis)",
      LARGEUR_COLIS: "Largeur (Colis)",
      HAUTEUR_COLIS: "Hauteur (Colis)",
      POIDS_NET_COLIS: "Poids net (Colis)",
      POIDS_BRUT_COLIS: "Poids brut (Colis)",
      POIDS_NET_UC: "Poids net (Unité conditionnée)",
      POIDS_BRUT_UC: "Poids brut (Unité de gestion)",
    },
    type_list: {
      MOIS: "Par jour",
      JOUR: "Par heure",
    },
    type_quick_inventaire: {
      RAZ_OTHER: "Remettre à 0 les autres lots",
      ONLY_THOSE: "Compter seulement ces lots",
    },
    date_schema: {
      JJMMAA: "JJ/MM/AA",
      JJMMAAAA: "JJ/MM/AAAA",
      MMAA: "MM/AA",
      MMAAAA: "MM/AAAA",
    },
    type_marquage_elem: {
      NUM_LOT: "Numéro de lot du produit fabriqué",
      DLUO: "DLUO du produit fabriqué",
      NUMBER: "Chiffres",
      VARIABLE_STRING: "Caractères variables",
      DATE_FAB: "Date de fabrication du produit fabriqué",
      SPACE: "Espace",
      EAN13: "EAN 13 du produit fabriqué",
      EAN14: "EAN 14 du produit fabriqué",
      EAN128: "EAN 128 du produit fabriqué",
    },
    ai: {
      GTIN: "GTIN (01)",
      BATCH_LOT: "Lot (10)",
      PROD_DATE: "Date de production (11)",
      BEST_BEFORE: "Meilleur avant (15)",
      USE_BY: "A consommer avant (17)",
      NET_WEIGHT: "Poids net (3100)",
      LOGISTIC_WEIGHT: "Poids brut (3300)",
      REF: "Référence (240)",
    },
    role: {
      ADMIN: "Administrateur",
      UTILISATEUR: "Utilisateur",
    },
    type_fiche: {
      STANDARD: "Fiche Unité d'Expédition",
      CARTON: "Carton",
      CARTON_EAN13: "Carton EAN 13",
      LONG: "Barquette",
    },
    type_connector: {
      PRESTASHOP: "PrestaShop",
    },
    state_connector: {
      WAITING_SYNC: "Attente de synchronisation",
      SYNCING: "Synchronisation en cours",
      SYNC_ERROR: "Erreur de synchronisation",
      OK: "Synchronisation OK",
    },
    sync_direction: {
      BOTH: "Deux sens",
      PULL: "Réception",
      PUSH: "Envoi",
      NONE: "Aucune",
    },
    validation_specif: {
      VALIDATION: "Approbation et Validation",
      NONE: "Sans Validation",
    },
    validation_of: {
      SIMPLE: "Validation",
      DOUBLE: "Validation production et qualité",
      NONE: "Sans validation",
    },
    validation_facture: {
      NUMEROTATION_AUTO: "Numérotation automatique à l'expédition",
      CREATION_SANS_NUMEROTATION: "Création de la facture sans numérotation",
      NONE: "Facturation manuelle",
    },
    type_idea: {
      BUG: "Bug",
      IDEA: "Idée",
    },
    type_custom_enum: {
      FAMILLE_ARTICLE: "Famille",
      CATEGORIE_ARTICLE: "Sous-famille",
      SOUS_FAMILLE_ARTICLE: "Famille technique",
      UNITE: "Unité de gestion",
      UNITE_PROD: "Unité",
      EMPLACEMENT_STOCK: "Emplacement en stock",
      POSTE: "Poste",
      TITRE: "Titre",
      TRAVAIL: "Travail",
      TYPE_REGLEMENT: "Mode de règlement",
      NC_NATURE: "Nature de NC",
    },
    dyn_text: {
      OF_QUANTITY_: "Quantité OF",
      OPE_QUANTITY_: "Quantité Opé.",
      FAB_DENOMINATION_: "Dénomination article fabriqué",
      FAB_UNITE_: "Unité article fabriqué",
      FAB_REF_: "Référence article fabriqué",
      NAME_: "Dénomination",
      DENSITY_: "Densité",
      REF_: "Référence",
      QUANTITY_: "Quantité nomenclature",
      VAR_QUANTITY_: "Quantité nomenclature",
      LOSS_: "Perte normale (%)",
      MAXLOSS_: "Perte max. (%)",
      UNIT_: "Unité de gestion",
      VAR_NAME_: "Dénomination",
      VAR_DENSITY_: "Densité",
      VAR_REF_: "Référence",
      VAR_LOSS_: "Perte normale (%)",
      VAR_MAXLOSS_: "Perte max. (%)",
      VAR_UNIT_: "Unité de gestion",
      VAR_STRING_: "Variable texte",
      VAR_N_: "Variable nombre",
      N_: "Quantité",
      X_: "×",
      DOC_: "Document",
      VAR_DOC_: "Variable document",
      ARTICLE_DOC_: "Document article",
      VAR_ARTICLE_DOC_: "Document article",
    },
  },
  training: {
    start_btn: "Me guider",
    quit_btn: "Quitter la formation",
    completed_badge: "Complété",
    step_counter: "Étape #current / #total",
    prev: "Précédent",
    next: "Suivant",
    finish: "Terminer",
    demo_title: "Comment voulez-vous suivre cette formation ?",
    demo_fake_title: "Données fictives",
    demo_fake_desc:
      "Apprenez avec un exemple pâtisserie sans toucher à vos données",
    demo_real_title: "Mes données réelles",
    demo_real_desc:
      "Suivez la formation sur vos propres données (+20 XP bonus)",
    xp_toast: "+#xp XP — Niveau #level",
    rating_title: "Comment évaluez-vous ce parcours ?",
    rating_subtitle: "Votre retour améliore la formation",
  },
  cost_impact: {
    title: "Simulation de coûts",
    description:
      "Simulez l'impact d'une variation de prix sur vos matières premières et visualisez la répercussion sur vos produits finis et vos marges clients.",
    scenario: "Scénario",
    depth: "Profondeur",
    depth_help: "Nombre de niveaux de nomenclature à remonter (∞ = illimité)",
    include_sf: "Semi-finis",
    include_sf_help: "Inclure les semi-finis dans les résultats",
    include_mo: "Main-d'œuvre",
    include_mo_help: "Inclure les coûts de main-d'œuvre dans la simulation",
    add_component: "Ajouter un composant",
    articles_impacted: "articles impactés",
    without_cost: "sans coût",
    col_component: "Composant",
    col_type: "Type",
    col_unit: "Unité",
    col_method: "Méthode",
    col_sim_mode: "Mode sim.",
    col_value: "Valeur",
    col_base_cost: "Coût base",
    col_sim_cost: "Coût sim.",
    col_delta_unit: "Δ unit.",
    col_delta_pct: "Δ %",
    tab_cascade: "Impact cascade",
    tab_direct: "Impact direct",
    tab_margin: "Impact marge",
    col_article: "Article",
    col_delta_combined: "Δ unit. combiné",
    col_drivers: "Composants",
    col_depth: "Prof.",
    no_impact: "Aucun article impacté — ajoutez un composant et une variation",
    col_driver: "Composant",
    col_qty_u: "Qté/u",
    col_delta_driver: "Δ unit. composant",
    col_contribution: "Contribution",
    combined_impact: "Impact unitaire combiné",
    sum_contributions: "Somme de #count contribution(s)",
    of_impact: "de l'impact",
    step_cost_varies: "Le coût du composant varie",
    step_qty_used: "Quantité utilisée dans la nomenclature",
    per_unit_of: "par unité de",
    step_impact: "Impact sur le coût unitaire",
    total_impact: "Impact total",
    drivers_combined: "drivers cumulés",
    margin_period: "Période",
    clients: "clients",
    loading_margins: "Chargement des données marges...",
    no_client_data: "Aucune donnée client pour les articles impactés",
    total_all_clients: "TOTAL TOUS CLIENTS",
    load_scenario: "Charger un scénario",
    save_scenario: "Sauvegarder",
    new_scenario: "Nouveau",
    empty_scenario: "Ajoutez un composant pour simuler l'impact d'une variation de coût",
    calculate: "Calculer l'impact",
  },
  relance: {
    dialog_title: "Relancer — facture",
    btn_send: "Envoyer",
    btn_record: "Enregistrer la relance",
    btn_cancel: "Annuler",
    btn_next: "Suivant",
    btn_preview: "Aperçu courrier",
    btn_relancer: "Relancer",
    mail_dialog_title: "Rédiger la relance —",
    step1_title: "Choisir le modèle",
    step2_title: "Canal d'envoi",
    field_canal: "Canal d'envoi",
    field_destinataires: "Destinataires",
    field_cc: "Copie (CC)",
    field_objet: "Objet",
    field_corps: "Message",
    edit_target_mail: "E-mail",
    edit_target_courrier: "Courrier",
    edit_target_hint: "Le texte de l'e-mail et du courrier peuvent être personnalisés indépendamment. Utilisez le sélecteur ci-dessus pour basculer.",
    field_commentaire: "Note interne (non envoyée au client)",
    canal_mail: "Mail",
    canal_courrier: "Courrier papier",
    canal_both: "Mail + Courrier",
    niveau_rappel: "Rappel cordial",
    niveau_rappel_desc: "Envoyé 1 semaine avant l'échéance — ton très courtois",
    niveau_1: "1re relance",
    niveau_1_desc: "J+7 après échéance — courtois mais ferme",
    niveau_2: "2e relance",
    niveau_2_desc: "J+21 — ferme, demande un engagement",
    niveau_3: "3e relance",
    niveau_3_desc: "J+45 — pressant, annonce procédure",
    niveau_demeure: "Mise en demeure",
    niveau_demeure_desc: "J+60 — formel juridique, mentions légales",
    delai_label: "J",
    suggested_badge: "Suggéré",
    history_title: "Historique des relances",
    no_history: "Aucune relance envoyée",
    sent_success: "Relance envoyée",
    destinataires_required:
      "Au moins un destinataire est requis pour l'envoi par mail",
    courrier_preview_tooltip: "Ouvrir l'aperçu du courrier PDF",
    courrier_only_hint: "Le courrier PDF sera généré et téléchargeable. La relance sera enregistrée dans l'historique pour assurer le suivi.",
    warn_not_due:
      "Cette facture n'est pas encore échue (échéance dans #days jour(s)). Le niveau de relance sélectionné est normalement destiné aux factures en retard de paiement.",
    warn_already_overdue:
      "Cette facture est en retard de #days jour(s). Un simple rappel pourrait ne pas suffire — un niveau supérieur serait peut-être plus adapté.",
  },
  non_conformite: {
    title: "Non-conformités",
    title_singular: "Non-conformité",
    list_title: "Liste des non-conformités",
    new: "Nouvelle non-conformité",
    declarer: "Déclarer une NC",
    builder_create: "Déclarer une non-conformité",
    builder_edit: "Modifier une non-conformité",
    type: "Type",
    gravite: "Gravité",
    cause_5m: "Cause (5M)",
    cause_5m_optional: "Cause (5M) — optionnel",
    description: "Description du défaut observé",
    description_placeholder:
      "Décrivez précisément l'écart constaté (état, quantité, mesure, photos déjà jointes...).",
    cout_estime: "Coût supplémentaire (€)",
    cout_estime_hint:
      "Surcoûts induits par la NC en plus de la valeur du stock : gestion, retraitement, pertes indirectes… S'ajoute au coût matière.",
    cout_nc_total: "Coût total NC",
    scope_label: "Portée",
    scope_tout: "Tout le lot",
    scope_partiel: "Quantité précise",
    scope_quantite: "Quantité concernée",
    heures_retouche: "Heures de retraitement",
    heures_retouche_hint:
      "Temps total passé à retraiter la NC. Multiplié par le taux horaire moyen de l'OF pour estimer le coût personnel imputé à la NC.",
    aide_move_zone_nc:
      "Si coché et qu'un lot/palette est lié à la NC, le stock concerné est immédiatement déplacé en zone NC PDC dédiée à cet OF (ou en zone NC entrepôt si pas en PDC). À la clôture, le mouvement final dépend de la décision : rebut → destruction, retour fournisseur → mouvement de retour, retraitement/dérogation → retour vers le PDC. À la réintégration finale de l'OF, tout résidu en zone NC PDC est apuré vers la zone NC entrepôt globale.",
    aide_scope:
      "Indique si la NC concerne tout le lot/palette lié, ou seulement une quantité précise. La quantité partielle est utilisée pour le mouvement de stock et les agrégats coût NC.",
    aide_nature:
      "Catégorie macro de la non-conformité, complémentaire de la description libre. Sert à grouper et filtrer les NC dans la liste et les statistiques.<br><br>Exemples : <em>Casse, Manquant, Salissure, Hors-spec, DLUO trop courte, Étiquette manquante, Mauvaise référence, Conditionnement abîmé</em>.<br><br>La liste est personnalisable depuis les paramètres custom enums, ou directement via le bouton + du sélecteur.",
    nature_hint:
      "Ex. Casse, Manquant, Salissure, Hors-spec, DLUO trop courte…",
    aide_decision:
      "Décision finale qui détermine le mouvement de stock à la clôture. Pour un PF (produit fini de l'OF), la décision RETOUR_FOURNISSEUR n'a pas de sens et est masquée.",
    aide_heures_retouche:
      "Saisir le temps réel passé à retraiter la non-conformité. Utilisé pour estimer le coût MO induit. Le taux horaire moyen est dérivé du `coutPersonnelTotalReel / heuresProfondesTotalReel` de l'OF.",
    aide_pf_quantite_nc:
      "Si une ou plusieurs NC ont déjà été déclarées sur le PF de cet OF, leur quantité est rappelée ici. La quantité saisie correspond uniquement aux pièces conformes — la quantité fabriquée totale = conforme + NC est calculée automatiquement.",
    aide_reception_nc_button:
      "Cliquez pour déclarer une non-conformité sur cette ligne de réception. La NC est liée à la ligne via <code>receptionCommandeId</code> et le mouvement de stock part en zone NC de l'entrepôt. Quantité totale reçue = saisie conforme + somme des NC déclarées.",
    reception_nc_will_prompt:
      "Une non-conformité sera demandée pour cette ligne à la validation de la réception.",
    reception_nc_required_message:
      "Validation annulée — chaque ligne avec une quantité NC doit être documentée par une non-conformité.",
    controle_ko_title: "Contrôle qualité échoué",
    controle_ko_message:
      "Un ou plusieurs contrôles qualité ont échoué sur cette réception. Souhaitez-vous déclarer une non-conformité (recommandé) ?",
    abandon_provision_action: "Abandonner la provision",
    abandon_provision_title: "Abandonner la provision avoir ?",
    abandon_provision_warning:
      "Le fournisseur n'émettra pas l'avoir attendu. La provision sera basculée en charge définitive : coutNcRecuperable est décrémenté et le coût NC reste imputé. Action idempotente (peut être posée une seule fois).",
    abandon_provision_success: "Provision abandonnée — charge définitive imputée",
    provision_abandoned_label: "Provision abandonnée le",
    decision: "Décision",
    decision_optional: "Décision — optionnel",
    move_to_zone_nc: "Déplacer le lot en zone non conforme après validation",
    move_to_zone_nc_hint:
      "Le lot reste comptabilisé au stock total mais n'est plus disponible pour la production ou la préparation d'expédition.",
    move_zone_nc_confirm_title: "Déplacer en zone non conforme ?",
    move_zone_nc_confirm_message:
      "Cette non-conformité est mineure. Voulez-vous déplacer le stock concerné en zone non conforme ? Il restera comptabilisé au stock total mais ne sera plus disponible pour la production ou l'expédition.",
    move_zone_nc_auto_info:
      "Non-conformité majeure ou critique : le stock concerné va être déplacé en zone non conforme.",
    source_stock_label: "Emplacement source",
    source_stock_hint:
      "Ce lot a du stock à plusieurs endroits — choisissez d'où prélever les unités non conformes.",
    cout_unitaire_matiere_label: "Coût matière unitaire (€)",
    cout_unitaire_matiere_hint:
      "Coût pris en compte pour valoriser la non-conformité (pré-rempli depuis le lot, ajustable).",
    cout_unitaire_matiere_close_hint:
      "Coût matière unitaire appliqué au rebut. Ajustez-le si besoin — il recalcule le coût NC.",
    cout_nc_matiere_total: "Coût matière NC total",
    cout_nc_mo_total: "Coût main-d'œuvre NC total",
    go_to_lot: "Ouvrir la fiche du lot",
    whole_lot_warning:
      "Tout le lot : #count emplacement(s) seront mis en zone non conforme (total #total).",
    type_RECEPTION: "Réception",
    type_PRODUCTION: "Production",
    type_EXPEDITION: "Expédition",
    type_RETOUR_CLIENT: "Retour client",
    type_RECLAMATION_CLIENT: "Réclamation client",
    type_AUDIT_INTERNE: "Audit interne",
    origine_label: "Origine — qui est responsable ?",
    origine_hint: "Pré-rempli selon le type, modifiable",
    origine_INTERNE: "Interne",
    origine_EXTERNE: "Externe",
    origine_MIXTE: "Mixte",
    origine_non_renseigne: "Non renseignée",
    origine_repartition_title: "Origine ce mois",
    detection_label: "Détection — où / par qui détectée ?",
    detection_hint:
      "Détection externe = échappée du filet qualité (indicateur ISO 9001)",
    detection_INTERNE: "Interne",
    detection_EXTERNE: "Externe (client / autorité)",
    date_occurrence_label: "Date d'occurrence",
    date_occurrence_hint:
      "Quand le défaut s'est réellement produit (production, livraison...). Optionnel.",
    date_constatation_label: "Date de constatation",
    date_constatation_hint:
      "Quand le défaut a été observé pour la première fois (contrôle, plainte). Optionnel.",
    aide_dates_metier:
      "Trois dates différentes :<br/>• <b>Occurrence</b> : quand le défaut s'est produit<br/>• <b>Constatation</b> : quand vous l'avez observé<br/>• <b>Enregistrement</b> : quand vous le saisissez (auto)<br/><br/>Les écarts entre ces dates servent à mesurer la réactivité qualité (ISO 9001).",
    delai_detection_kpi: "Délai détection moyen",
    delai_enregistrement_kpi: "Délai enregistrement moyen",
    echappee: "Échappée",
    echappee_tooltip:
      "Cette NC a été détectée par un tiers externe — échappée du système qualité",
    taux_echappees: "Taux d'échappées",
    taux_echappees_tooltip:
      "% NC détectées en externe sur le mois (ISO 9001). Cible : < 5%.",
    gravite_MINEURE: "Mineure",
    gravite_MAJEURE: "Majeure",
    gravite_CRITIQUE: "Critique",
    cause_MATIERE: "Matière",
    cause_MACHINE: "Machine",
    cause_METHODE: "Méthode",
    cause_MAIN_OEUVRE: "Main-d'œuvre",
    cause_MILIEU: "Milieu",
    cause_MESURE: "Mesure",
    etat_OUVERTE: "Ouverte",
    etat_EN_TRAITEMENT: "En traitement",
    etat_CLOTUREE: "Clôturée",
    etat_ANNULEE: "Annulée",
    decision_ACCEPTATION_DEROGATION: "Acceptation par dérogation",
    decision_RETOUCHE: "Retraitement",
    decision_REBUT: "Rebut",
    decision_RETOUR_FOURNISSEUR: "Retour fournisseur",
    close_title: "Clôturer la non-conformité",
    close_decision: "Décision finale",
    close_comment: "Commentaire de clôture (optionnel)",
    close_action: "Clôturer",
    cancel_title: "Annuler cette non-conformité",
    cancel_comment: "Raison de l'annulation",
    cancel_action: "Annuler la NC",
    filter_search_placeholder: "Rechercher (n°, description, lot, fournisseur)",
    filter_etat: "État",
    filter_type: "Type",
    filter_gravite: "Gravité",
    filter_nature: "Nature",
    filter_origine: "Origine",
    filter_detection: "Détection",
    filter_period: "Période",
    no_data: "Aucune non-conformité",
    saved_success: "Non-conformité créée",
    updated_success: "Non-conformité mise à jour",
    closed_success: "Non-conformité clôturée",
    cancelled_success: "Non-conformité annulée",
    link_required:
      "Au moins un lien est requis (lot, palette, commande, chargement ou tiers).",
    description_required: "Une description est requise.",
    link_label: "Lien (article, lot, palette, commande, chargement, fournisseur)",
    required_missing: "Champs obligatoires manquants :",
    related_nc: "NC liées",
    related_count: "#count NC",
    stats_open: "NC ouvertes",
    stats_critical_open: "NC critiques ouvertes",
    stats_count_month: "NC ce mois",
    stats_cost_month: "Coût NC ce mois",
    aside_kpi_title: "Indicateurs",
    aside_warehouse_title: "Stock NC par entrepôt",
    aside_warehouse_count: "entrepôts",
    aside_warehouse_empty: "Aucun stock non conforme actif.",
    aside_warehouse_empty_title: "Aucun stock non conforme",
    aside_warehouse_empty_sub: "Tout est en zone conforme.",
    aside_warehouse_no_stock_title: "Aucun stock NC actif actuellement",
    aside_warehouse_no_stock_sub: "Les NC ouvertes ne sont pas rattachées à un stock courant (lot consommé, NC sur commande/article sans lot…).",
    aside_warehouse_nc: "NC",
    aside_warehouse_critical: "critiques",
    aside_warehouse_emplacements: "emplacements",
    aside_hero_label: "NC ouvertes",
    aside_hero_ok: "Aucune NC ouverte — bon état !",
    aside_hero_critical: "#count critique(s) à traiter",
    aside_hero_no_critical: "Aucune NC critique en cours",
    aside_short_month: "ce mois",
    aside_short_cost: "coût mois",
    aside_short_cost_short: "coût",
    aside_short_escapees: "taux échap.",
    aside_period_label: "Période",
    aside_count_period_tooltip: "Nombre de NC créées #period",
    aside_cost_period_tooltip: "Coût total des NC créées #period",
    aside_origine_title: "Origine — #period",
    aside_title: "Non-conformités",
    aside_count_singular: "NC liée",
    aside_count_plural: "NC liées",
    aside_loading: "Chargement…",
    aside_empty: "Aucune non-conformité liée.",
    aside_kpi_open: "Ouvertes",
    aside_kpi_critical: "Critiques",
    aside_kpi_cost: "Coût estimé",
    aside_no_numero: "(brouillon)",
    aside_expand: "Voir #count autres",
    aside_collapse: "Masquer",
    aside_see_all: "Voir tout",
    badge_open: "Ouverte",
    badge_in_progress: "En traitement",
    badge_closed: "Clôturée",
    badge_cancelled: "Annulée",
    no_lien_suggested: "Aucun élément lié",
    save: "Enregistrer",
    cancel: "Annuler",
    section_express: "Déclaration",
    section_detail: "En détail",
    section_detail_hint: "Gravité, cause, coût (optionnel)",
    section_operational: "Et maintenant ?",
    section_operational_hint: "Actions à appliquer après création",
    section_comments_attachments: "Commentaires & pièces jointes",
    section_comments_attachments_hint: "Discussion qualité, photos, rapports d'audit, mails fournisseur…",
    print_fiche_nc: "Imprimer fiche NC",
    linked_to: "À quoi est-ce lié ?",
    linked_from_context: "Contexte pré-rempli depuis l'écran d'origine. Ajoutez d'autres éléments si nécessaire.",
    search_placeholder: "Tapez le n° du lot, palette, commande, chargement ou un nom de fournisseur (2 lettres min.)",
    search_hint: "Cliquez un résultat dans la liste pour l'attacher à la NC. Le texte tapé seul n'est pas enregistré.",
    search_no_results: "Aucun élément correspondant — vérifiez le numéro saisi.",
    actions_phase2_hint: "Blocage du lot, sortie en rebut et retour fournisseur arrivent en Phase 2.",
    lot: "Lot",
    other_link: "Autre lien",
    other_link_hint: "Palette, commande, chargement, fournisseur (optionnel)",
    link_optional_audit: "Pour un audit interne, le lien est facultatif. Vous pouvez juste décrire l'écart observé.",
    lot_pick_article_first: "Sélectionnez un article pour choisir un lot",
    detail_title: "Non-conformité",
    detail_history: "Historique",
    detail_links: "Éléments liés",
    detail_no_links: "Aucun élément lié",
    detail_section_what: "Caractéristiques",
    detail_section_when: "Chronologie",
    detail_creator: "Créée par",
    detail_closed_by: "Clôturée par",
    detail_close_action: "Clôturer la NC",
    detail_cancel_action: "Annuler la NC",
    detail_edit_action: "Modifier",
    detail_edit_restricted_action: "Modifier (limité)",
    detail_edit_restricted_tooltip:
      "Édition limitée : description, photos, coût, cause… La décision et les liens lot/palette/article restent verrouillés. Pour les modifier, réouvrez la NC.",
    detail_reopen_action: "Réouvrir",
    reopen_title: "Réouvrir cette non-conformité ?",
    reopen_warning:
      "La NC repassera en EN_TRAITEMENT — vous pourrez modifier la décision et les liens. ⚠️ Si un mouvement de stock a été émis à la clôture (libération zone NC ou destruction), il restera tel quel ; vous devrez créer un transfert manuel pour aligner la position physique du stock après modification.",
    reopen_success: "NC réouverte — vous pouvez maintenant modifier la décision",
    reopen_success_with_movement:
      "NC réouverte. Un mouvement de stock avait été émis à la clôture — pensez à aligner manuellement la position physique si vous changez la décision.",
    restricted_banner_title: "Édition limitée — NC clôturée",
    restricted_banner_desc:
      "Vous pouvez corriger description, photos, coût, cause, dates. Les champs verrouillés (gravité, type, décision, liens) nécessitent de Réouvrir la NC depuis la fiche.",
    confirm_close_title: "Clôturer cette non-conformité",
    confirm_close_decision: "Quelle décision finale ?",
    confirm_close_comment: "Commentaire (optionnel)",
    confirm_close_cout: "Coût supplémentaire (€)",
    confirm_cancel_title: "Annuler cette non-conformité",
    confirm_cancel_warning: "L'annulation est utilisée quand la NC a été créée par erreur. Elle reste tracée dans l'historique.",
    confirm_cancel_comment: "Raison de l'annulation",
    cant_close_already_closed: "NC déjà clôturée ou annulée",
    nature: "Nature",
    detail_close_dialog: "Fermer",
    analytics_title: "Analyse des non-conformités",
    analytics_btn: "Analyse",
  },
  prepreparation: {
    tab_label: "Préparation",
    aide_intro:
      "Réservation logique des lots avant placement physique sur palette. L'algorithme respecte la DDM mini contractuelle paramétrée sur le tarif client (cascade Tier > Groupe > Générique).",
    auto_affecter_commande: "Pré-réserver toutes les lignes",
    valider_toutes: "Valider toutes (#count)",
    liberer_toutes: "Libérer toutes (#count)",
    preparer_ligne: "Pré-préparer cette ligne",
    reaffecter: "Pré-réserver à nouveau",
    affecter_manuel: "Pré-réserver manuellement",
    valider: "Valider",
    liberer: "Libérer",
    consommes: "consommés",
    lots_affectes: "Lots pré-réservés",
    lignes_total: "Lignes",
    nb_couvert: "Couvertes",
    nb_a_revoir: "À revoir",
    a_revoir_chip: "Reliquat",
    a_revoir_tooltip:
      "Le stock disponible n'a pas suffi à couvrir la quantité demandée — ajuster la commande, attendre une réception, créer un OF, ou demander un transfert.",
    alerte_ddm_chip: "Alerte DDM",
    alerte_ddm_tooltip:
      "Au moins un lot a été pré-réservé avec une DDM < contrainte contractuelle. À valider avec le commerce.",
    aucun_lot_dispo:
      "Aucun lot disponible respectant la contrainte DDM contractuelle.",
    statut_aucune: "Aucune pré-prépa",
    lot_ddm_alerte: "DDM < contrat",
    journal_show: "Voir l'historique",
    journal_hide: "Masquer l'historique",
    empty: "Aucune ligne dans cette commande à pré-préparer.",
    consommer: "Consommer #qty",
    consommer_tooltip:
      "Marque ce lot comme placé physiquement en palette. Le statut de la pré-prépa passe en CONSOMMEE_PARTIELLE ou CONSOMMEE selon la couverture.",
  },
  cout_theorique: {
    title: "Coût théorique",
    open_btn: "Coût théorique",
    open_btn_hint:
      "Projeter le coût de revient de l'article selon sa nomenclature (matière + main d'œuvre) — avec export Excel.",
    empty:
      "Cet article n'a pas de nomenclature — aucun coût théorique à projeter.",
    matiere: "Matière",
    mo: "Main d'œuvre",
    mo_none: "Non estimée (pas d'historique)",
    mo_source_hint:
      "Source de l'estimation MO. Réel = constaté sur ventes/production ; Théorique = analogique (famille · ligne) ou bilan de productivité.",
    mo_realise_lots: "Moyenne #n derniers lots",
    mo_realise_lots_hint:
      "Le réalisé MO affiché est la moyenne pondérée des #n derniers lots produits — le même échantillon que la matière réalisée, pour un coût réalisé cohérent.",
    total: "Coût total / u",
    total_mat_mo: "Matière + main d'œuvre",
    total_mat: "Matière seule (MO exclue)",
    ecart: "Écart matière",
    ecart_hint: "Réalisé − théorique (dérive de la nomenclature)",
    reel: "réel",
    theorique_tag: "Théorique",
    realise_tag: "Réalisé",
    toggle_mo: "Inclure la MO",
    toggle_mo_hint:
      "Inclure (ou non) la main d'œuvre estimée dans le coût total affiché.",
    missing:
      "#count composant(s) sans coût exploitable — le coût théorique est partiel.",
    col_composant: "Composant",
    col_qty: "Qté / u",
    col_cout_unit: "Coût retenu",
    col_theorique: "Théorique",
    col_source: "Source",
    col_contribution: "Contribution",
  },
  preparateur: {
    title: "Préparateur de commandes",
    refresh_tooltip: "Actualiser la liste",
    search_placeholder: "Rechercher commande, client…",
    horizon_today: "Aujourd'hui",
    horizon_tomorrow: "Demain",
    horizon_week: "Cette semaine",
    horizon_all: "Toutes",
    urg_no_date: "Sans date",
    urg_today: "Aujourd'hui",
    urg_tomorrow: "Demain",
    urg_retard: "Retard #count j",
    urg_jplus: "J+#count",
    empty: "Aucune commande à préparer",
    empty_filter: "sur ce filtre",
    lignes_engagees: "ligne(s) engagée(s)",
    a_revoir: "à revoir",
    loading: "Chargement…",
    empty_lots: "Aucun lot engagé pour cette commande.",
    ref: "Réf.",
    lot: "Lot",
    ddm: "DDM",
    lots_count: "lot(s)",
    scan_tooltip: "Scanner un lot avec la caméra",
    scan: "Scanner",
    action_title: "Action sur le lot",
    mettre_ue: "Mettre sur unité d'expédition",
    mettre_ue_sub: "Palette existante ou nouvelle",
    livrer_sans_expe: "Livrer sans expédition",
    livrer_sans_expe_sub: "Crée un BL direct sans palette",
    snack_lot_reconnu: "Lot #lot reconnu",
    snack_lot_inattendu: "Lot « #lot » non attendu pour cette commande",
    snack_lot_palette: "Lot #lot placé sur palette",
    snack_livraison_directe: "Vente enregistrée (facturé — gardé en stock)",
  },
  preparation_pilotage: {
    total_commandes: "Commandes",
    couvertes: "Couvertes",
    a_revoir: "À revoir",
    alertes_ddm: "Alertes DDM",
    en_retard: "En retard",
    sans_date: "Sans date",
    empty:
      "Aucune commande dans cet horizon. Modifier le filtre ou créer / dater une commande.",
    search_placeholder: "Rechercher une commande, un client, un article…",
    total_produits: "Produits",
    couverts: "Couverts",
    rupture: "Rupture / partiel",
    besoin_total: "Besoin total",
    stock_dispo: "Stock dispo / total",
    reserve: "Réservé",
    premier_depart: "Premier départ",
    // Refonte 30/05/2026 — KPI badge produit
    kpi_aucun_lot_eligible_label: "Aucun lot éligible",
    kpi_aucun_lot_eligible_tooltip:
      "Le stock physique brut couvrirait le besoin, mais aucun lot n'est éligible pour les commandes consommatrices (DDM/DLC trop courte ou lots hors des entrepôts assignés). Ouvre la grille produit pour arbitrer — un forçage motivé reste possible.",
    // Refonte 30/05/2026 — Toggle UV non fractionnée (grille pilotage produit)
    uv_non_fractionnee_label: "UV non fractionnée",
    uv_non_fractionnee_tooltip_active:
      "Affectation auto par unité de vente entière uniquement. Un lot dont la quantité disponible restante est inférieure à une unité de vente complète est ignoré.\n\nDécocher : autorise les queues partielles d'un lot court — utile pour vider les lots à DDM courte sans gaspiller, principe juste-assez.",
    uv_non_fractionnee_tooltip_inactive:
      "Fractionnement autorisé : un lot court avec une queue résiduelle inférieure à une unité de vente complète sera affecté pour préserver la logique juste-assez DDM.\n\nCocher pour repasser en mode strict (unités de vente entières uniquement).",
    // 2026-05-30 — Confirmation reset avant auto + spinner
    auto_running: "Pré-réservation automatique en cours…",
    auto_confirm_title: "Lancer la pré-réservation automatique ?",
    auto_confirm_message:
      "Toutes les pré-réservations courantes des commandes non réservées seront remises à zéro avant d'appliquer le calcul automatique. Les commandes déjà réservées ne sont pas impactées.",
    auto_confirm_btn: "Lancer la pré-réservation auto",
    // 2026-05-30 — Saisie cell over-allocated
    cell_max_warn: "Quantité ramenée au max dispo restant du lot.",
  },
  achatAnalysis: {
    title: "Analyse achats",
    btn: "Analyse achats",
    btn_tooltip:
      "Analyse achats : KPIs réceptions, distribution prix payé, comparaison fournisseurs vs catalogue, conformité, délais et simulateur d'économie.",
    excel_tooltip: "Télécharger l'analyse complète en Excel",
    loading: "Chargement de l'analyse…",
    period_label: "Période :",
    period_3m: "3 mois",
    period_6m: "6 mois",
    period_12m: "12 mois",
    period_24m: "24 mois",
    view_label: "Vue :",
    view_prix: "Prix",
    view_qty: "Quantités",
    inclure_nc: "Inclure non conformes",
    inclure_nc_tooltip:
      "Par défaut le coût et le volume comptent uniquement la part conforme.",
    inclure_annulees: "Inclure annulées",
    filter_fournisseur_placeholder: "Filtrer fournisseur / groupe…",
    perimetre:
      "#nbReceptions réception(s) · #nbCommandes commande(s) · #nbFournisseurs fournisseur(s) · #nbLots lot(s) fournisseur. Périmètre : #scope. Tous les agrégats prix sont en €/#unit pour rester homogènes entre fournisseurs (l'unité d'achat varie).",
    perimetre_scope_all: "tous reçus (conforme + NC)",
    perimetre_scope_conforme: "conforme uniquement",
    kpi_volume_recu: "Volume reçu",
    kpi_volume_dont_nc: "dont #qty #unit non-conforme",
    kpi_volume_100_conforme: "100 % conforme",
    kpi_cout_total: "Coût d'achat total",
    kpi_cout_tous_recus: "tous reçus : #value €",
    kpi_cout_nb_receptions: "#nb réception(s)",
    kpi_prix_moyen: "Prix moyen pondéré",
    kpi_prix_minmax: "min #min · max #max · méd #med",
    kpi_dispersion: "Dispersion prix",
    kpi_dispersion_sub: "écart-type sur le prix payé €/#unit",
    kpi_evolution: "Évolution prix",
    kpi_evolution_dernier_mois: "dernier mois : #value €/#unit",
    kpi_evolution_too_short: "période trop courte",
    kpi_conformite: "Conformité",
    kpi_conformite_nc: "#qty #unit NC",
    kpi_conformite_aucune_nc: "aucune NC sur la période",
    kpi_delai: "Délai livraison moyen",
    kpi_delai_sub: "commande → 1ʳᵉ réception",
    kpi_delai_unit: "jours",
    kpi_frequence: "Fréquence d'appro",
    kpi_frequence_unit: "cmd/mois",
    kpi_frequence_sub: "#nb commande(s) sur la période",
    kpi_volume_moyen_cmd: "Volume moyen / commande",
    kpi_volume_moyen_par_rec: "par réception : #qty #unit",
    kpi_taux_realisation: "Taux de réalisation",
    kpi_taux_realisation_sub: "qty reçue / qty commandée",
    kpi_concentration: "Concentration sourcing",
    kpi_concentration_top: "top : #name · indice #herfindahl",
    kpi_concentration_indice: "indice #herfindahl",
    kpi_tarif_generique: "Tarif catalogue (générique)",
    kpi_tarif_ecart_paye: "écart payé : #ecart",
    kpi_tarif_no_data: "fiche article — pas de tarif saisi",
    chart_evolution_prix: "Évolution mensuelle du prix payé (€/#unit)",
    chart_evolution_prix_sub:
      "Prix moyen pondéré par mois (par qty conforme) avec min/max observés. Permet de détecter une dérive de prix (inflation ou négociation).",
    chart_evolution_volumes: "Évolution mensuelle des volumes (#unit)",
    chart_evolution_volumes_sub:
      "Total achats par mois (pointillés noirs) + une courbe par top 6 fournisseurs. Permet de comparer les tendances et détecter une disparition / un nouveau fournisseur.",
    nego_title: "Simulateur d'économie",
    nego_sub:
      "Volume annualisé estimé : #volume #unit/an.",
    nego_prix_cible: "Prix cible €/#unit :",
    nego_btn_meilleur: "meilleur",
    nego_btn_meilleur_tooltip:
      "Aligner sur le meilleur fournisseur observé : #name",
    nego_btn_catalogue: "catalogue",
    nego_btn_catalogue_tooltip: "Aligner sur le tarif catalogue générique",
    nego_economie: "Économie annuelle estimée",
    nego_surcout: "Surcoût annuel estimé",
    nego_compare:
      "(#actuel €/#unit actuel → #cible €/#unit cible)",
    nego_constats: "Constats :",
    consommateurs_title: "Principaux produits utilisateurs",
    consommateurs_mode_direct: "Direct",
    consommateurs_mode_final: "Final",
    consommateurs_mode_client: "Par client",
    consommateurs_sub_direct:
      "Produits finis qui consomment ce composant sur la période (source : pied de chaîne). Cliquer sur une ligne pour voir, en cascade, qui consomme ce produit.",
    consommateurs_sub_final:
      "Produits finis « feuilles » — articles consommateurs (in)directs qui ne sont eux-mêmes consommés par personne. Le pourcentage est propagé sur toute la chaîne (profondeur max 5).",
    consommateurs_sub_client:
      "Clients qui reçoivent ce composant via la chaîne de production. Le pourcentage est propagé : composant → cascade conso → produits feuilles → expéditions au client.",
    consommateurs_empty: "Aucune consommation enregistrée sur la période.",
    consommateurs_empty_final:
      "Aucun produit fini consommateur identifié sur la période.",
    consommateurs_empty_client:
      "Aucun client expéditaire identifié sur la période.",
    consommateurs_loading_final: "Calcul de la cascade…",
    consommateurs_loading_client: "Calcul des consommateurs clients…",
    consommateurs_loading_kids: "Chargement…",
    consommateurs_kids_empty: "Aucun produit utilisateur sur la période.",
    consommateur_meta_count: "#nb OF · #qty #unit",
    consommateur_meta_qty: "#qty #unit",
    consommateur_pct_parent_tooltip:
      "Part dans la consommation du produit parent",
    consommateur_pct_root_tooltip:
      "Part dans la consommation totale du composant",
    consommateur_pct_propage_tooltip:
      "Part propagée dans la consommation totale du composant",
    consommateur_pct_client_tooltip:
      "Part dans le total client",
    consommateur_client_meta:
      "#nb produit(s) · #qty #unit",
    consommateur_client_total_tooltip:
      "Part propagée totale attribuée à ce client",
    distribution_title: "Distribution du prix payé (€/#unit)",
    distribution_sub:
      "Volume reçu par tranche de prix unitaire payé. Identifie les paliers tarifaires effectifs et les anomalies (réceptions à prix outliers).",
    repartition_volume_title: "Répartition du volume par fournisseur",
    repartition_volume_sub:
      "Part de chaque fournisseur dans le volume conforme total (#unit). Permet de visualiser la concentration sourcing.",
    comparaison_prix_title: "Comparaison des prix par fournisseur",
    comparaison_prix_sub:
      "Prix moyen payé vs tarif catalogue, top 8 fournisseurs triés du moins cher au plus cher (€/#unit).",
    groupes_title: "Comparaison par groupe de tiers",
    groupes_col_groupe: "Groupe",
    groupes_col_volume: "Volume #unit",
    groupes_col_cout: "Coût",
    groupes_col_prix_moyen: "Prix moyen €/#unit",
    groupes_col_min: "Min",
    groupes_col_max: "Max",
    groupes_col_fournisseurs: "Fournisseurs",
    groupes_col_receptions: "Réceptions",
    fournisseurs_title: "Détail par fournisseur — vue #mode",
    fournisseurs_mode_prix: "prix",
    fournisseurs_mode_qty: "quantités",
    fournisseurs_sub:
      "Cliquer sur une ligne pour déplier le détail des réceptions et conditions commerciales.",
    fournisseurs_sub_prix_help:
      "Hausse de prix vs catalogue = rouge (mauvais), baisse = vert (bon).",
    fournisseurs_col_fournisseur: "Fournisseur",
    fournisseurs_col_prix_moyen: "Prix moyen",
    fournisseurs_col_tarif_cat: "Tarif catalogue",
    fournisseurs_col_ecart_cat: "Écart cat.",
    fournisseurs_col_evolution: "Évolution",
    fournisseurs_col_cout_part: "Coût (part)",
    fournisseurs_col_volume: "Volume #unit",
    fournisseurs_col_cmd_recu: "Cmd / Reçu",
    fournisseurs_col_vol_moy_cmd: "Vol moy/cmd",
    fournisseurs_col_freq: "Fréq.",
    fournisseurs_col_n_rec: "N° rec.",
    fournisseurs_col_conformite: "Conformité",
    fournisseurs_col_delai: "Délai",
    fournisseurs_rang_tooltip: "Rang volume ##rang",
    fournisseurs_score_fiabilite_tooltip: "Score fiabilité (conformité × délai)",
    fournisseurs_fiab: "fiab. #pct",
    fournisseurs_cmd_count: "#nb cmd · #lots lot(s)",
    fournisseurs_freq_unit: "cmd/mois",
    fournisseurs_vol_par_rec: "/rec : #qty",
    fournisseurs_empty_period:
      "Aucune réception sur la période sélectionnée.",
    conditions_title: "Conditions commerciales :",
    conditions_reduction: "Réduction #pct %",
    conditions_franco_qty: "Franco qty : #value",
    conditions_franco_prix: "Franco prix : #value €",
    conditions_delai_jours: "(#nb j)",
    conditions_multiple: "Multiple achat : #value",
    conditions_coef: "1 #ua = #coef #ug",
    receptions_col_date: "Date",
    receptions_col_commande: "Commande",
    receptions_col_bl: "BL",
    receptions_col_lot: "Lot fournisseur",
    receptions_col_qty: "Qty #unit",
    receptions_col_conforme: "Conforme",
    receptions_col_prix_unit: "€/#unit",
    receptions_col_cout: "Coût",
    receptions_nc_badge: "−#qty",
  },
  fabricationAnalysis: {
    title: "Analyse fabrication",
    btn: "Analyse fabrication",
    btn_tooltip:
      "Analyse fabrication : KPIs coûts matière+MO unitaires, écart théorique vs réel pied de chaîne, composants matière, distribution coût par OF, simulateur d'amélioration.",
    excel_tooltip: "Télécharger l'analyse fabrication complète en Excel",
    loading: "Chargement de l'analyse fabrication…",
    perimetre:
      "#nbOfs OF(s) · #nbLots lot(s) produits · #qty #unit produit(s). Périmètre : lots fabriqués sur la période avec coût enregistré.",
    period_label: "Période :",
    period_3m: "3 mois",
    period_6m: "6 mois",
    period_12m: "12 mois",
    period_24m: "24 mois",
    granularite_day: "Jour",
    granularite_week: "Semaine",
    granularite_month: "Mois",
    granularite_jour: "jour",
    granularite_semaine: "semaine",
    granularite_mois: "mois",
    kpi_volume_produit: "Volume produit",
    kpi_volume_lots: "#nb lot(s)",
    kpi_cout_total: "Coût total unitaire",
    kpi_cout_total_sub: "cumul #value",
    kpi_cout_matiere: "Coût matière unitaire",
    kpi_cout_matiere_sub: "composants directs",
    kpi_cout_mo: "Coût MO unitaire",
    kpi_cout_mo_sub: "MO profonde cascade",
    kpi_evolution: "Évolution coût total",
    kpi_evolution_sub: "1ᵉʳ → dernier mois",
    kpi_ecart_conso: "Écart conso matière",
    kpi_ecart_conso_sub: "réel vs théorique BOM",
    kpi_productivite_mo: "Productivité MO",
    kpi_productivite_mo_tooltip:
      "Unités produites par heure de main-d'œuvre cumulée (cascade complète). Si plusieurs ouvriers travaillent en parallèle, leurs heures s'additionnent — ce n'est pas la cadence machine.",
    kpi_concentration_ligne: "Concentration ligne",
    kpi_concentration_ligne_sub: "part du top 1",
    chart_evolution_couts: "Évolution mensuelle des coûts unitaires",
    chart_evolution_couts_sub:
      "Coûts matière (orange) et MO (teal) par mois, avec total en pointillés noirs.",
    chart_distribution_couts: "Distribution coûts unitaires par OF",
    chart_distribution_couts_sub:
      "10 tranches de coût total unitaire — repérez les OFs hors tendance (incidents, recettes modifiées).",
    chart_volume: "Évolution du volume produit",
    chart_volume_sub:
      "Volume produit (#unit) par #gran. Les périodes sans production apparaissent à zéro pour préserver la continuité visuelle.",
    chart_repartition_lignes: "Répartition production par ligne",
    chart_repartition_lignes_sub:
      "Poids en volume de chaque ligne de production sur la période. Permet de visualiser la concentration ligne et la rotation entre équipements.",
    chart_evolution_productivite: "Évolution de la productivité MO",
    chart_evolution_productivite_sub:
      "Unités produites par heure de main-d'œuvre cumulée (#unit/h MO), mois après mois. Une pente positive révèle une amélioration ; une pente négative signale une dérive à investiguer.",
    chart_evolution_productivite_warn:
      "À ne pas confondre avec la cadence ligne (vitesse machine) — ici c'est bien la MO qui compte.",
    composants_title: "Composants matière",
    composants_mode_direct: "Direct",
    composants_mode_profond: "Profond",
    composants_mode_fournisseur: "Par fournisseur",
    composants_sub_direct:
      "Composants directs de la nomenclature, agrégés sur la période. Comparaison théorique BOM vs réel pied-de-chaîne — l'écart mesure les pertes matière.",
    composants_sub_profond:
      "Composants feuilles de la cascade ascendante (matières achetées en bout de chaîne).",
    composants_sub_fournisseur:
      "Agrégation par fournisseur d'origine — quel tiers amont influence le plus le coût matière.",
    composants_empty: "Aucun composant identifié sur la période.",
    composants_empty_fournisseurs: "Aucun fournisseur identifié sur la période.",
    composants_col_composant: "Composant",
    composants_col_qty_theo: "Qty théo. #unit",
    composants_col_qty_reelle: "Qty réelle #unit",
    composants_col_ecart: "Écart",
    composants_col_cout_mat: "Coût mat. €/UG",
    composants_col_cout_mo: "MO profond €/UG",
    composants_col_cout_total: "Coût total",
    composants_col_part: "Part %",
    composants_col_feuille: "Composant feuille",
    composants_col_qty_propagee: "Qty propagée",
    composants_col_cout_propage: "Coût propagé",
    composants_col_fournisseur: "Fournisseur amont",
    composants_col_nb_composants: "Nb composants",
    composants_meta: "#code · #nbOfs OF",
    of_link_tooltip: "Ouvrir l'OF",
    simulator_title: "Simulateur d'amélioration",
    simulator_sub:
      "Volume annualisé estimé : #volume #unit/an. Coût annuel actuel : #cout. Activez un ou plusieurs leviers pour estimer l'économie.",
    simulator_lever_pertes: "Réduire les pertes matière (%)",
    simulator_lever_pertes_hint:
      "Aligner le réel sur le théorique pour les composants à fort écart.",
    simulator_lever_productivite: "Améliorer la productivité MO (%)",
    simulator_lever_productivite_hint:
      "Plus d'unités produites par heure-homme (réorganisation, automatisation partielle, formation).",
    simulator_lever_prix_top: "Négocier #composant (% prix)",
    simulator_lever_prix_top_default: "Négocier composant principal (%)",
    simulator_lever_prix_top_hint:
      "Top 1 composant en valeur — levier négociation amont.",
    simulator_lever_prix_mo: "Réduire prix MO (%)",
    simulator_lever_prix_mo_hint:
      "Optimisation atelier ou changement de barème salarial.",
    simulator_economie: "Économie annuelle estimée",
    simulator_reset: "Remettre à zéro",
    simulator_constats: "Constats :",
    ofs_title: "Détail OFs — #nb OF(s)",
    ofs_sub:
      "Triés par coût total unitaire décroissant. Les OFs marqués <strong>!</strong> sont des outliers (coût hors tendance).",
    ofs_outlier_tooltip:
      "Cet OF a un coût atypique : il s'écarte significativement de la fourchette des autres OFs (méthode IQR de Tukey). À investiguer (incident, recette modifiée, petit lot, saisie incomplète…).",
    ofs_col_of: "OF",
    ofs_col_ligne: "Ligne",
    ofs_col_date_fin: "Date fin",
    ofs_col_qty: "Qty #unit",
    ofs_col_lots: "Lots",
    ofs_col_heures_mo: "Heures MO",
    ofs_col_cout_mat: "Coût mat €/UG",
    ofs_col_cout_mo: "Coût MO €/UG",
    ofs_col_cout_total: "Coût total €/UG",
  },
  articleMargeAnalysis: {
    title: "Analyse marge & prix",
    title_with_article: "Analyse marge & prix — #name",
    excel_tooltip:
      "Télécharger l'analyse complète en Excel (synthèse, clients, distribution, évolution, détail factures, aide tarifaire)",
    excel_success: "Export Excel téléchargé",
    excel_error: "Échec de l'export Excel",
    period_label: "Période :",
    period_3m: "3 mois",
    period_6m: "6 mois",
    period_12m: "12 mois",
    toggle_inclure_mo: "Inclure la MO",
    toggle_inclure_remise_pied: "Inclure remise pied",
    filter_client_placeholder: "Filtrer client / groupe…",
    loading: "Chargement de l'analyse…",
    error_load: "Erreur lors du chargement",
    perimetre_mat_mo: "matière + MO",
    perimetre_mat_seule: "matière seule",
    perimetre:
      "Périmètre #scope · Données issues des factures sur #nbFactures facture(s) · #nbLignes ligne(s) · #nbClients client(s) distinct(s).",
    kpi_volume: "Volume vendu",
    kpi_volume_sub: "= #qty #unit (unité de vente, coef ×#coef)",
    kpi_ca_net: "CA net",
    kpi_ca_remise_pied: "dont #pct de remise pied",
    kpi_cout_retenu: "Coût retenu total (#scope)",
    kpi_cout_detail: "dont matière #mat € · MO #mo €",
    kpi_cout_unitaire: "soit #cout €/#unit (moyenne sur le volume vendu)",
    kpi_marge_totale: "Marge totale",
    kpi_marge_sub: "#pct · coef ×#coef",
    kpi_taux_marge: "Taux de marge",
    kpi_taux_mat_seule: "Matière seule",
    kpi_taux_mat_mo: "Matière + MO",
    kpi_taux_mo_impact: "MO #mo € → impact #pct sur le taux",
    kpi_taux_mo_na: "— MO non historisée",
    kpi_taux_mo_none: "Pas de coût MO trouvé sur les ventes — taux mat. seule = taux total",
    kpi_prix_moyen: "Prix encaissé moyen",
    kpi_prix_minmax:
      "médiane #median · min #min · max #max",
    kpi_dispersion: "Dispersion prix",
    kpi_dispersion_sub: "écart-type /#unit sur le PU encaissé",
    nc_section_title: "Non-conformités sur cet article",
    distribution_title: "Distribution des prix encaissés",
    distribution_sub:
      "Volume vendu par tranche de PU encaissé (€/#unit). Permet de positionner un nouveau client.",
    chart_volume_label: "Volume vendu (#unit)",
    chart_tooltip_lignes: "#nb ligne(s) facture",
    chart_tooltip_clients: "#nb client(s) distinct(s)",
    chart_tooltip_ca_cumule: "CA cumulé : #value €",
    chart_prix_label: "Prix moyen €/#unit",
    chart_cout_label: "Coût moyen €/#unit",
    chart_marge_label: "Marge €/#unit",
    pricing_title: "Aide à la décision tarifaire",
    pricing_sub: "Pour fixer un prix à un nouveau client.",
    pricing_cout_actuel: "Coût retenu actuel",
    pricing_cout_matiere: "Matière",
    pricing_cout_mo: "Main-d'œuvre",
    pricing_detail_cascade: "Détail cascade",
    pricing_detail_mo: "Détail MO",
    pricing_detail_cascade_tooltip:
      "Voir la cascade complète des composants, sources matière (réel / théorique / cascade), dernier lot retenu, écart réel/théorique.",
    pricing_detail_mo_tooltip:
      "Voir la chaîne de fallback MO : les 6 tiers évalués (historique OFs, dernier lot, famille×ligne, bilan productivité, catalogue) avec leur valeur et la source retenue.",
    pricing_detail_mo_none: "Aucune source disponible",
    pricing_prix_observes: "Prix observés",
    pricing_prix_observes_unit: "(€/#unit)",
    pricing_prix_observes_tooltip:
      "Stats agrégées sur toutes les lignes de vente. Affichées en €/UG car l'unité de vente peut varier entre clients (carton 6 vs carton 12 vs palette) — comparer des €/UV mélange des choses non-comparables.",
    pricing_stats_min: "Min",
    pricing_stats_p25: "P25",
    pricing_stats_median: "Médiane",
    pricing_stats_p75: "P75",
    pricing_stats_max: "Max",
    pricing_stats_eq: "= #value €/#unit",
    pricing_calculator: "Calculateur prix par marge",
    pricing_cout_retenu_inline: "Coût retenu : #value €/#unit",
    pricing_pre_filled:
      "Pré-rempli avec le taux observé sur la période (#pct %).",
    pricing_reset: "Reset",
    pricing_reset_tooltip: "Revenir au taux de marge effectivement constaté",
    pricing_marge_label: "Marge cible",
    pricing_marge_input_tooltip: "Saisis directement le taux de marge en %",
    pricing_prix_propose: "Prix de vente proposé",
    pricing_prix_marge_sub:
      "marge #marge €/#unit · coef ×#coef",
    pricing_tarif_generique: "Tarif générique catalogue",
    pricing_tarif_value_eq: "= #value €/#unit",
    aide_tarif_origine_title: "D'où vient ce prix ?",
    aide_tarif_origine_html:
      "Du <b>tarif catalogue générique</b> (fiche <i>ArticleFourni</i> sans tiers ni groupe associé). C'est le prix appliqué par défaut à tout client qui n'a pas de tarif spécifique configuré.",
    aide_tarif_calcul_title: "Comment il est calculé",
    aide_tarif_calcul_html:
      "On prend le <b>premier palier</b> du tarif catalogue (trié par quantité minimale) — c'est le prix de base avant remises quantitatives.<br><br><b>€/#unitUV</b> : prix brut tel que stocké en catalogue.<br><b>€/#unitUG</b> = €/#unitUV ÷ coefficient UV→UG (×#coef), pour comparer au coût retenu exprimé par unité de gestion.",
    aide_tarif_hierarchie_title: "Hiérarchie de résolution",
    aide_tarif_hierarchie_html:
      "Pour un client donné, le prix retenu suit cette priorité :<ol style='margin: 4px 0 0 16px; padding: 0'><li>Tarif spécifique au tiers</li><li>Tarif du groupe tiers</li><li><b>Tarif générique</b> (fallback)</li></ol>",
    clients_title: "Détail par client (#count)",
    clients_sub:
      "Trié par CA décroissant. Cliquer sur un en-tête pour trier autrement (à venir).",
    clients_empty_no_sales:
      "Aucune vente sur cette période. L'aide pricing ci-dessus s'appuie sur le coût théorique (production / cascade composants) pour proposer un prix.",
    clients_empty_no_match: "Aucun client ne correspond à la recherche.",
    clients_col_client: "Client",
    clients_col_qty: "Qté",
    clients_col_prix: "Prix encaissé",
    clients_col_tarif_cat: "Tarif cat.",
    clients_col_ecart: "Écart",
    clients_col_cout_moy: "Coût moy.",
    clients_col_marge_unit: "Marge /u",
    clients_col_taux: "Taux",
    clients_col_factures: "Factures",
    clients_btn_show_detail: "Voir le détail des factures",
    clients_btn_hide_detail: "Masquer le détail",
    clients_qty_eq: "= #qty #unit",
    clients_value_eq: "= #value €/#unit",
    clients_tarif_none_tooltip:
      "Aucune fiche tarif active pour ce client (ni tiers-spécifique, ni groupe, ni générique). Le client paie au prix décidé manuellement à chaque commande.",
    aide_qty_title: "Quantité vendue",
    aide_qty_html:
      "Volume cumulé sur la période, exprimé sur deux unités :<br><br><b>Unité de gestion (UG)</b> : unité de production / stockage (ex. sachets individuels).<br><b>Unité de vente (UV)</b> : unité commerciale facturée (ex. cartons, palettes).<br><br>Coefficient article : 1 UV = #coef UG.",
    aide_prix_title: "Prix encaissé",
    aide_prix_html:
      "<b>Prix moyen pondéré net</b> facturé à ce client sur la période, après remise pied de facture.<br><br>Calcul : Σ CA net ÷ Σ quantité.<br>Les avoirs sont compensés (signe négatif).",
    aide_tarif_client_highlight_title:
      "Pourquoi des valeurs différentes selon le client ?",
    aide_tarif_client_highlight_html:
      "Le tarif catalogue est résolu <b>par client</b> selon une hiérarchie à 3 niveaux. La pastille sous la valeur indique le niveau retenu.",
    aide_tarif_client_hierarchie_html:
      "<ol style='margin: 4px 0 0 16px; padding: 0'><li><b>Tarif client spécifique</b> — fiche <i>ArticleFourni</i> rattachée au tiers</li><li><b>Tarif groupe</b> — rattachée au groupe tiers du client</li><li><b>Tarif générique</b> — fallback catalogue sans tiers ni groupe</li></ol>Si aucun tarif n'est trouvé, \"—\" s'affiche : le prix a été décidé manuellement à la commande.",
    aide_tarif_client_calcul_html:
      "Premier palier de prix (trié par quantité minimale) de la fiche tarif retenue. Affiché en €/#unitUG (÷ coef ×#coef) et en €/#unitUV (brut catalogue).",
    aide_ecart_title: "Écart prix encaissé / tarif catalogue",
    aide_ecart_html:
      "(Prix encaissé − Tarif catalogue) ÷ Tarif catalogue.<br><br><b style='color: var(--color-on-valid)'>+%</b> = on facture plus cher que le tarif applicable (sur-encaissement : marge bonus, mais peut signaler une réclamation possible si le client le découvre).<br><b style='color: var(--color-on-error)'>−%</b> = on facture moins cher que le tarif (remise consentie ou oubli de mise à jour).<br><b>0%</b> = pratique conforme au catalogue.",
    aide_cout_title: "Coût moyen retenu",
    aide_cout_html:
      "Coût unitaire <b>réel</b> à la date d'expédition de chaque facture (figé à la vente, pas le coût courant).<br><br><b>Source</b> : matière profonde + MO profonde du lot expédié, à défaut coût plat (<i>COALESCE(profond, plat)</i>).<br>La MO est incluse uniquement si le toggle \"main-d'œuvre\" est activé en haut du dialog.",
    aide_marge_title: "Marge unitaire",
    aide_marge_html:
      "Prix encaissé − Coût moyen retenu, par unité.<br><br><b style='color: var(--color-on-valid)'>Vert</b> : marge positive (on gagne de l'argent).<br><b style='color: var(--color-on-error)'>Rouge</b> : marge négative (on vend à perte).<br><br>Cohérent avec le périmètre choisi en haut du dialog (matière seule ou matière + MO).",
    aide_taux_title: "Taux de marge",
    aide_taux_html:
      "Marge totale ÷ CA net.<br><br>Calculé sur le périmètre actif (matière seule ou matière + MO).<br><br><i>Différent du coefficient multiplicateur</i> (CA / coût) — ici c'est bien la marge ramenée au chiffre d'affaires.",
    lignes_empty: "Aucune ligne facture pour ce client.",
    lignes_col_date: "Date",
    lignes_col_facture: "Facture",
    lignes_col_qty: "Qté (#unit)",
    lignes_col_prix_net: "Prix net /#unit",
    lignes_col_ca_net: "CA net",
    lignes_col_cout_unit: "Coût /#unit",
    lignes_col_cout_total: "Coût total",
    lignes_col_marge: "Marge €",
    lignes_brouillon: "(brouillon)",
    lignes_avoir: "avoir",
    lignes_lot: "· lot #num",
    evolution_title: "Évolution mensuelle",
    evolution_sub:
      "Prix moyen encaissé, coût moyen et marge unitaire ramenés à l'#unit.",
    groupes_title: "Comparaison par groupe de tiers",
    groupes_sub:
      "Aide à comparer un nouveau client à son segment. Plus le groupe a de clients, plus la moyenne est statistiquement fiable.",
    groupes_col_groupe: "Groupe",
    groupes_col_clients: "Clients",
    groupes_col_volume: "Volume",
    groupes_col_prix_moyen: "Prix moyen",
    groupes_col_mediane: "Médiane",
    groupes_col_marge_moy: "Marge moy.",
    groupes_col_taux: "Taux",
    groupes_sub_col_client: "Client",
    groupes_sub_col_volume: "Volume",
    groupes_sub_col_ca_net: "CA net",
    groupes_sub_col_prix_moyen: "Prix moyen",
    groupes_sub_col_marge: "Marge",
    groupes_sub_col_taux: "Taux",
    groupes_sub_col_factures: "Factures",
    tarif_level_tiers: "tarif client spécifique",
    tarif_level_groupe: "tarif groupe",
    tarif_level_generique: "tarif générique",
    tarif_level_none: "aucun tarif catalogue",
    mo_source_unknown: "Source MO inconnue",
  },
  tiersMargeAnalysis: {
    title: "Analyse marge & ventes",
    title_with_tiers: "Analyse marge & ventes — #name",
    excel_tooltip:
      "Télécharger l'analyse complète en Excel (synthèse, articles, distribution paniers, évolution, détail factures, conditions tarifaires)",
    excel_export_title: "Exporter — Analyse marge & ventes",
    excel_success: "Export Excel téléchargé",
    excel_error: "Échec de l'export Excel",
    excel_toggle_mo: "Inclure la main-d'œuvre dans le coût",
    excel_toggle_mo_hint:
      "Décocher pour ne retenir que le coût matière dans le calcul de marge.",
    excel_toggle_remise: "Inclure la remise pied de facture",
    excel_toggle_remise_hint:
      "Décocher pour exclure la remise globale de la facture du calcul.",
    period_label: "Période :",
    period_3m: "3 mois",
    period_6m: "6 mois",
    period_12m: "12 mois",
    period_24m: "24 mois",
    period_ytd: "YTD",
    period_exercice: "Exercice",
    period_exerciceN1: "Exercice passé",
    toggle_inclure_mo: "Inclure la MO",
    toggle_inclure_remise_pied: "Inclure remise pied",
    filter_article_placeholder: "Filtrer article / famille…",
    loading: "Chargement de l'analyse…",
    error_load: "Erreur lors du chargement",
    perimetre_mat_mo: "matière + MO",
    perimetre_mat_seule: "matière seule",
    perimetre:
      "Périmètre #scope · Données issues des factures sur #nbFactures facture(s) · #nbLignes ligne(s) · #nbArticles article(s) distinct(s).",
    perimetre_dates: " · Du #from au #to.",
    perimetre_no_sales:
      "Aucune vente détectée sur cette période. Élargis la période ci-dessus, ou consulte les conditions tarifaires applicables au tiers ci-dessous (toujours utiles pour préparer une prochaine commande).",
    no_sales_section_title: "Conditions tarifaires applicables",
    no_sales_section_sub:
      "Réduction, franco, règlement, groupes, remises actives — synchronisés avec la fiche tiers.",
    no_sales_empty_title: "Pas de ventes sur cette période",
    no_sales_empty_msg:
      "Aucune facture n'a été émise pour #name sur les #months derniers mois (périmètre #scope). Essaie une période plus large, ou télécharge l'Excel pour récupérer les conditions tarifaires applicables.",
    cond_reduction_label: "Réduction tiers",
    cond_franco_label: "Franco port",
    cond_franco_qty_unit: "u",
    cond_reglement_label: "Règlement",
    cond_groupes_label: "Groupes tarifaires",
    remises_active_label: "Remises actives applicables",
    remises_empty: "Aucune remise active applicable au tiers.",
    remise_no_label: "(sans libellé)",
    insights_label: "Insights",
    kpi_ca_net: "CA net",
    kpi_ca_remise_pied: "dont #pct de remise pied",
    kpi_cout_retenu: "Coût retenu total (#scope)",
    kpi_cout_detail: "dont matière #mat € · MO #mo €",
    kpi_marge_totale: "Marge totale",
    kpi_marge_sub: "#pct · coef ×#coef",
    kpi_taux_marge: "Taux de marge",
    kpi_taux_mat_seule: "Matière seule",
    kpi_taux_mat_mo: "Matière + MO",
    kpi_taux_mo_impact: "MO #mo € → impact #pct sur le taux",
    kpi_taux_mo_na: "— MO non historisée",
    kpi_volume_factures: "Volume de factures",
    kpi_volume_unit: "factures",
    kpi_volume_sub: "dont #nbAvoirs avoir(s) · #nbLignes ligne(s)",
    kpi_panier_moyen: "Panier moyen",
    kpi_panier_marge_sub: "marge moy. #value €/facture",
    kpi_frequence: "Fréquence d'achat",
    kpi_frequence_unit: "factures/mois",
    kpi_frequence_sub: "#nb article(s) distinct(s) achetés",
    nc_section_title: "Non-conformités liées au tiers",
    panier_title: "Distribution des paniers",
    panier_sub:
      "Nombre de factures par tranche de montant — pour comprendre la structure du portefeuille.",
    chart_panier_label: "Nombre de factures",
    chart_panier_axis_y: "Nb factures",
    chart_panier_tooltip_factures: "#nb facture(s)",
    chart_panier_tooltip_ca: "CA cumulé : #value €",
    pricing_title: "Conditions tarifaires",
    pricing_sub:
      "Réduction, franco, règlement, remises actives applicables au tiers.",
    chart_evolution_ca: "CA net (€)",
    chart_evolution_marge: "Marge (€)",
    chart_familles_tooltip: "#name : #value € (#pct %)",
    familles_title: "Mix produit (#count famille#plural)",
    familles_sub:
      "Répartition du CA par famille article. Trié par CA décroissant.",
    familles_col_famille: "Famille",
    familles_col_articles: "Articles",
    familles_col_ca: "CA net",
    familles_col_part: "Part",
    familles_col_marge: "Marge",
    familles_col_taux: "Taux",
    familles_sub_col_article: "Article",
    familles_sub_col_qty: "Qty",
    familles_sub_col_ca: "CA net",
    familles_sub_col_marge: "Marge",
    familles_sub_col_taux: "Taux",
    familles_sub_col_factures: "Factures",
    familles_sans_famille: "Sans famille",
    familles_viz_title: "Visualisation mix produit",
    familles_viz_sub: "Top 8 familles par CA. Concentration vs diversification.",
    articles_title: "Détail par article (#count)",
    articles_sub:
      "Cliquer une ligne pour déplier le détail des factures · cliquer l'en-tête d'une colonne pour trier.",
    articles_empty_no_sales: "Aucune vente sur cette période.",
    articles_empty_no_match: "Aucun article ne correspond à la recherche.",
    articles_col_article: "Article",
    articles_col_qty: "Qté",
    articles_col_prix: "Prix encaissé",
    articles_col_tarif_cat: "Tarif cat.",
    articles_col_ecart: "Écart",
    articles_col_cout_moy: "Coût moy.",
    articles_col_marge_unit: "Marge /u",
    articles_col_taux: "Taux",
    articles_col_factures: "Factures",
    articles_btn_show_detail: "Voir le détail des factures",
    articles_btn_hide_detail: "Masquer le détail",
    articles_qty_eq: "= #qty #unit",
    articles_value_eq: "= #value €/#unit",
    articles_tarif_none_tooltip:
      "Aucune fiche tarif active pour ce client / cet article (ni tiers-spécifique, ni groupe, ni générique).",
    articles_ecart_tooltip:
      "Écart entre le prix moyen encaissé et le tarif catalogue, calculé en €/UG.",
    articles_factures_dern: "dern. #date",
    lignes_empty: "Aucune ligne facture pour cet article.",
    lignes_col_date: "Date",
    lignes_col_facture: "Facture",
    lignes_col_qty: "Qté",
    lignes_col_prix_net: "Prix net",
    lignes_col_ca_net: "CA net",
    lignes_col_cout_retenu: "Coût retenu",
    lignes_col_marge: "Marge €",
    lignes_brouillon: "(brouillon)",
    lignes_avoir: "avoir",
    lignes_lot: "· lot #num",
    evolution_title: "Évolution mensuelle",
    evolution_sub: "CA net et marge totale par mois sur la période.",
    btn_close: "Quitter",
    tarif_level_tiers: "tarif client spécifique",
    tarif_level_groupe: "tarif groupe",
    tarif_level_generique: "tarif générique",
    tarif_level_none: "aucun tarif catalogue",
    remise_scope_tiers: "tiers global",
    remise_scope_tiers_article: "tiers · article",
    remise_scope_groupe: "groupe global",
    remise_scope_groupe_article: "groupe · article",
    remise_value_pct: "#value %",
    remise_value_unitaire: "#value €/u",
    remise_value_eur: "#value €",
    unit_default: "u.",
  },
};
